(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
    /* jshint -W100 */
    gettextCatalog.setStrings('en', { "* Rodomos tik paskutinių šešių mėnesių išklotinės": "* Only reports for the last six months are available", "A": "Tu", "AAS": "AAS", "AB": "AB", "ADB": "ADB", "APB": "APB", "AS": "AS", "Adresas": "Address", "Advokatų profesinė bendrija": "Advokatų profesinė bendrija", "Akcinės bendrovės filialas": "Akcinės bendrovės filialas", "Anaujinti": "Update", "Apie mus": "About", "Apmokėti": "Pay", "Apmokėti iki": "Due Date", "Aprašymas": "Description", "Aprašymo nėra": "Description is empty", "Ar Jūs tikrai norite atstatyti pradinius parametrus?": "Do you want to reset parameters?", "Ar Jūs tikrai norite pašalinti DNS įrašą?": "Do you want to remove DNS record?", "Asmens kodas": "Personal Code", "Asmens tipas": "Type Of Person", "Asmuo": "Person", "Asociacija": "Association", "Ataskaitos": "Reports", "Atnaujinti": "Update", "Atsakymas nesulauktas. Mėginkite dar kartą.": "No response, please try again.", "Atsijungti nuo Klientų zonos": "Log out", "Atsisiųsti": "Download", "Atsk. asmuo": "The Accountable Person", "Atstovaujamas asmuo": "Represented By Person", "Atšaukti": "Cancel", "Automatinėje paslaugų valdymo sistemoje Jūs galite:": "Automatic Service Management System, You Can:", "Ačiū, kad pirkote!": "Thank You That You Bought!", "Baigti registraciją": "To Complete The Registration", "Balandis": "April", "Baltnetos komunikacijos": "Baltnetos komunikacijos", "Bendrija": "Association", "Birželis": "June", "Biudžetinė įstaiga": "Budget Institution", "Būsena": "Status", "CJSC": "CJSC", "CSV": "CSV", "Cancel": "Cancel", "DNS zonos įrašai": "DNS Records", "DNS įrašas atnaujintas": "DNS Record Updated", "DNS įrašas pašalintas": "DNS Record Deleted", "DNS įrašas pridėtas": "DNS Record Added", "DNSB": "DNSB", "Data": "Date", "Debesų kompiuterijos ir serverių ekspertai": "Cloud computing and server experts", "Dedikuotų serverių nuoma": "Dedicated Server Rent", "Disko talpa": "Disk Space", "Documentas": "Dokumentas", "Dokumentas pasirašytas sėkmingai": "Document was signed successfully", "Domenas": "Domain", "Domeno pirkimas": "Buy domain", "Download (International)": "Download (International)", "Download (LT)": "Download (LT)", "Duomenys": "Data", "Duomenų centras": "Data Center", "Duomenų naudojimo grafikas": "Data usage chart", "EUR/met.": "EUR/year", "EUR/mėn.": "EUR/month", "El. lizdas": "Socket", "El. paštas": "E-mail", "El. paštas pakeistas sėkmingai": "E-mail Was Changed Successfully", "El. pašto keitimo instrukcijos išsiųstos nurodytu adresu": "E-mail change instructions were sent to provided address", "Elektros lizdas perkrautas sėkmingai": "PDU rebooted successfully", "Elektros lizdų perkrovimas": "Reboot the electrical outlets", "Estija": "Estonia", "FM AB": "FM AB", "Failas": "File", "Fizinis asmuo": "Person", "Formuoti": "Shape", "GMbH": "GMbH", "Gedimas": "HD Request", "Gedimas užregistruotas sėkmingai.": "HD Request Recorded Successfully.", "Gegužė": "May", "Gruodis": "December", "Grįžti": "Back", "I understand risk": "I understand risk", "IB": "IB", "IOOO": "IOOO", "IP adresai": "IP Address", "IT priežiūra": "IT Support", "IT ūkio priežiūros įvykdytų darbų ataskaita": "IT infrastructure maintenance report", "Iki": "To", "Inc": "Inc", "Incidentai": "Incidents", "Informacijos prašymai": "Information Requests", "Informuojame, kad šiuo metu paslaugos keisti negalima": "Please Be Advised That Services Can Not Be Changed Currently", "Inicijuojamas mokėjimas. Luktelėkite...": "Initiating a Payment. Please wait ...", "Internetas": "Internet", "Interneto ryšio paslaugos, vartojimo statistika": "Internet Usage", "Investicines kompanija": "Investment Company", "Iį": "Iį", "Iš plano": "From plan", "Iš viso:": "Total:", "Išeinantys": "Outgoing", "Išrašymo data": "Invoice Date", "Išspręsta": "Resolved", "Išspręsti iki": "Deadline", "Išspręstos": "Resolved", "Ištrinti": "Delete", "Išvalyti": "Clear", "Jeigu mokėjimą atlikote ne iš Automatinės paslaugų valdymo sistemos (myportal.balt.net) puslapio, Jūsų mokėjimas bus užskaitytas per kelias darbo dienas. Prašome nekartoti mokėjimo.": "If payment was done from other sources, not from Automatic Service Management System (myportal.balt.net) please don't pay again, because payment will be received within a few working days.", "Juridinis asmuo": "Company", "Jūs neturite VoIP išklotinių": "There are no VoIP reports", "Jūs neturite sutarčių": "There are no contracts", "Jūs neturite sąskaitų": "There are no invoices", "Jūs neturite užklausų pasirinktame laikotarpyje": "There are no requests for selected period", "Jūs neturite užsakytų paslaugų": "There are no active services", "Jūs neužsisakėte paslaugų": "You Are Not Order Service", "Jūs užsiregistravote į sistemą": "You Registered To System", "Jūsų paslaugų krepšelis": "Your shopping cart", "K": "Th", "KB": "KB", "Kaina (be PVM)": "Price (excl. VAT)", "Keisti": "Change", "Keisti el. paštą": "Change E-mail", "Keisti profilio duomenis": "Change Profile", "Keisti slaptažodį": "Reset Password", "Keliaujame į mokėjimus. Luktelėkite...": "Go To Payments. Please wait ...", "Kiekis": "Quantity", "Kiti validavimo pranešimai.": "Other validation messages", "Kito mėnesio mokestis": "Next Month Payment", "Kitos paslaugos": "Other services", "Kliento sutartys": "Contracts", "Kliento sąskaitos": "Invoices", "Komunikacija": "Communication", "Kontaktai": "Contacts", "Kontrolinis kodas": "Verification code", "Kovas": "March", "Kredito unija": "Kredito unija", "Kurti naują VoIP išklotinę": "Create New VoIP Report", "KŪB": "KŪB", "LLP": "LLP", "Labdaros ir paramos fondas": "Labdaros ir paramos fondas", "Lapkritis": "November", "Latvija": "Latvia", "Liepa": "July", "Lietuva": "Lithuania", "Likutis": "Balance", "Ltd": "Ltd", "MB": "MB", "Mano užsakymas": "My Order", "Mat. vnt.": "UOM", "Mažoji bendrija": "Mažoji bendrija", "Mobiliuoju parašu": "M-Signature", "Mokėjimas buvo nutrauktas": "Payment Was Stopped", "Mokėjimo klaidos!": "Payment Errors!", "Mokėti": "Pay", "Naudosiu savo turimą": "I Already Have One", "Naudotojas": "Username", "Naudotojo vardas arba el. pašto adresas": "Username or email address", "Nauja kaina": "New Price", "Naujas slaptažodis": "New Password", "Nauji planai": "New Plans", "Ne": "No", "Negalime priimti mokėjimo!": "Cannot accept payment!", "Negalime priimti šio atšaukimo": "Cannot accept cancellation", "Nepavyko atsiųsti sąskaitos!": "Unable to download the invoice!", "Nepavyko prisijungti. Bandykite dar kartą.": "Connection failed. Please try again.", "Neteisingai nurodytas kontaktinis el. paštas.": "Wrong Contact Email ", "Neteisingai nurodytas pašto adresas.": "Incorrect e-mail address", "Neteisingai nurodytas serverio vardas.": "Hostname is not valid", "Nuo": "From", "Nurodykite domeną": "Enter Domain", "Nurodykite el. paštą": "E-mail", "Nurodyta reikšmė yra per ilga": "The Values Are Too Long", "Nurodyta reikšmė yra per trumpa.": "The Values Are Too Short", "Nėra duomenų": "No data", "OOO": "OOO", "OU": "OU", "Operacinė sistema": "Operating system", "PDF": "PDF", "Pabaiga": "End", "Pagalbos centras": "Helpdesk", "Pagalbos centro užklausos": "HD Requests", "Pakartokite slaptažodį": "Repeat Password", "Pakeiskite slaptažodį": "Change Password", "Pakeisti": "Change", "Pakeisti slaptažodį": "Change Password", "Pakeitimų prašymai": "Requests For Changes", "Palaukite...": "Please wait…", "Pamiršote slaptažodį?": "Forgot Password?", "Pasirašymas atšauktas": "Signing was canceled", "Pasirašyti": "Sign", "Pasirinkite adresą iš sąrašo": "Select an address from the list", "Pasirinkite mokėjimo būdą": "Choose payment method", "Pasirinkite paslaugą": "Select service", "Pasirinkite planą": "Choose Hosting", "Pasirinkti": "Apply", "Paslauga": "Service", "Paslaugos": "Services", "Paslaugos adresas": "Service Address", "Paslaugos duomenys": "Service Data", "Paslaugos greitis kbps": "Service speed in kbps", "Paslaugos planas": "Service", "Paslaugos trumpas aprašymas": "Short Description of the Problem", "Patikrinkite telefono numerį": "Check phone number", "Patikrinkite, ar sutampa išmaniajame įrenginyje ir ekrane matomas kontrolinis kodas": "Verify control code in displayed matches the one on smart device. ", "Patvirtinkite": "Confirm", "Patvirtinkite įvesdami PIN": "Confirm by entering PIN", "Pavadinimas": "Name", "Pažymėti viską": "Select all", "Periodas": "Period", "Perkrauti": "Reboot", "Personalinė įmonė": "Personalinė įmonė", "Peržiūrėti": "View", "Pirkti": "Buy", "Plano keitimas": "Plan change", "Pn": "Fr", "Politinė partija": "Politinė partija", "Pr": "Mo", "Pradiniai parametrai": "Default Parameters", "Pradžios data": "Start Date", "Pranešimas sėkmingai išsiųstas.": "Message Was Send Successfully.", "Pranešimo tekstas": "Message Text", "Pratęskite el. pašto keitimą": "Prolong Your E-mail Change", "Pratęskite registraciją": "Continue Registration", "Prašome palaukti": "Please Wait", "Pridėti": "Add", "Pridėti naują įrašą": "Add New Record", "Priminti": "Remember", "Prioritetas": "Priority", "Prisijungimas į Klientų zoną": "Sign In", "Prisijungti": "Log In", "Prisijunkite prie automatinės paslaugų valdymo sistemos. Įveskite savo prisijungimo vardą ir\nslaptažodį viršuje pateiktoje formoje. Jeigu Jūs neturite, nežinote ar pamiršote šiuos prisijungimo\nduomenis – kreipkitės į Jus aptarnaujantį vadybininką.": "Access to automated service management system. Enter your username and\npassword at the top of the form. If you forgot username or password - see you serving manager.", "Procesoriaus branduoliai": "CPU Cores", "Profesinė sąjunga ar susivienijimas": "Profesinė sąjunga ar susivienijimas", "Profilis": "Profile", "Profilis atnaujintas": "Profile updated", "PĮ": "PĮ", "RAB": "RAB", "RAM atmintis": "RAM Size", "Reboot": "Reboot", "Rebooting socket power for running servers may cause data loss!": "Rebooting socket power for running servers may cause data loss!", "Redaguoti": "Edit", "Redaguoti DNS": "Edit DNS", "Registracija": "Sign Up", "Registracijos instrukcijos išsiųstos į Jūsų elektroninį paštą": "Registration instructions sent to you by e-mail", "Registravimasis į Klientų zoną": "Registration To Client Zone", "Registravimo data": "Registration Date", "Registruotis": "Sign up", "Resursas nerastas": "Resource not found", "Resursų nuoma (IaaS)": "Public Cloud (VMware IaaS)", "Rugpjūtis": "August", "Rugsėjis": "September", "S": "Su", "SARL": "SARL", "SE": "SE", "SIA": "SIA", "SLA": "SLA", "SLA ataskaita": "SLA Report", "Sausis": "January", "Savaitė": "Week", "Savivaldybės įmonė": "Savivaldybės įmonė", "Serverio vardas": "Hostname", "Serverio vardas ir IP adresas": "Hostname and IP address", "Serveris": "Server", "Serveris neatsiliepė. Bandykite dar kartą.": "The Server Did Not Respond. Please Try Again.", "Serveris šiuo metu nepasiekiamas": "Server is Not Available", "Serverių saugykla": "Colocation", "Siųsti": "Send", "Skambučiai": "Calls", "Slaptažodis": "Password", "Slaptažodis pakeistas sėkmingai": "Password changed successfully", "Slaptažodžio atstatymo instrukcijos išsiųstos į Jūsų elektroninį paštą": "Password reset instructions were sent to your email address", "Sp. z.o.o.": "Sp. z.o.o.", "Spalis": "October", "Sprendimas": "Resolution", "Sukurkite paskyrą": "Create Account", "Sukurkite užklausą": "Register HD request", "Sukurti VDS": "Add New VDS", "Sukurti domeną": "Create Domain", "Sukurti talpinimo paslaugą": "Create Hosting Service", "Sukurti užklausą": "Add New Request", "Suma": "Amount", "Suma (be PVM)": "Amount (excl. VAT)", "Susirašinėjimas": "Conversation", "Sutartys": "Contracts", "Sveikiname, Jūs prisijungėte prie sistemos.": "You Are Logged In", "Svetainių talpinimas ir domenai": "Hosting and Domains", "Sąskaita apmokėta sėkmingai.": "Invoice payment had been succeeded", "Sąskaitos": "Invoices", "Sąskaitos apmokėjimas buvo nutrauktas.": "Invoice payment has been canceled", "Sąskaitos numeris": "Invoice Number", "T": "We", "TOO": "TOO", "TTL": "TTL", "Taip": "Yes", "Techninė pagalba:": "Helpdesk:", "Telefono numeris": "Phone number", "Tema": "Subject", "Threre is no PDU sockets assigend to service": "Threre is no PDU sockets assigend to service", "Tikrinti": "Check", "Tipas": "Type", "Toks domenas jau užimtas": "Domain Is Already Taken", "Toliau": "Next", "Tradicinė religinė bendruomenė ar bendrija": "Tradicinė religinė bendruomenė ar bendrija", "Turimas planas": "Current plan", "Type reason here": "Type reason here", "TŪB": "TŪB", "UAB": "UAB", "UAB - firma": "UAB - firma", "UAB DK": "UAB DK", "UAB FMĮ": "UAB FMĮ", "UAB Filialas": "UAB Filialas", "UADB": "UADB", "UADBB": "UADBB", "UAGDPB": "UAGDPB", "URL error: \"baseUrl\" should be defined or \"options.url\" specified to \"query\" a resource": "URL error: \"baseUrl\" should be defined or \"options.url\" specified to \"query\" a resource", "Upload (International)": "Upload (International)", "Upload (LT)": "Upload (LT)", "Uždaryti": "Close", "Užklausos ID": "Request ID", "Užpildykite privalomus laukus": "Please fill in mandatory fields", "Užregistruoti": "Register", "Užregistruoti naują domeną": "Register New Domain", "Užsienio juridinio asmens atstovybė": "Užsienio juridinio asmens atstovybė", "Užsienio juridinio asmens filialas": "Užsienio juridinio asmens filialas", "VK": "VK", "Valdymo skydelis": "Control panel", "Vardas": "Name", "Vasaris": "February", "Veiksmai": "Actions", "Viešosios įstaigos filialas": "Viešosios įstaigos filialas", "Virtualūs dedikuoti serveriai (VDS)": "Virtual Dedicated Server (VDS)", "VoIP išklotinė": "VoIP Report", "VoIP išklotinė atšaukta": "VoIP Report Delete in Progress", "VoIP išklotinė kuriama": "VoIP Report Creation is in Progress", "VoIP išklotinės": "VoIP Reports", "Vykdomos": "In progress", "VĮ": "VĮ", "Všį": "Všį", "helpdesk.done": "Closed", "helpdesk.draft": "Not Opened", "helpdesk.fixed": "Repaired", "helpdesk.open": "In Progress", "helpdesk.pending": "Pending", "invoice.open": "In Debt", "invoice.paid": "Paid", "invoice.proforma2": "Advance", "keisti bendrąją informaciją: prisijungimo vardus, slaptažodžius ir t. t.;": "change general information: usernames, passwords, etc.;", "keisti virtualaus serverio FTP prisijungimo, MySQL, webalizer slaptažodžius, aktyvuoti MySQL, webalizer (lankomumo statistika);": "change the virtual server FTP login, MySQL, webalizer passwords, activate MySQL, webalizer (attendance statistics);", "kurti naujas pašto dėžutes, keisti slaptažodžius, pašalinti dėžutes;": "create new email accounts, change passwords, removing boxes;", "nežinoma": "unknown", "oy": "oy", "pagalba@balt.net, +370 700 800 88": "pagalba@balt.net, +370 700 800 88", "pasižiūrėti savo turimų paslaugų planus(-ą), stebėti jų naudojimo statistiką;": "to see your existing service plans and monitor their usage statistics;", "paslauga": ["service", "services"], "pateikti klausimus ir registruoti problemas.": "submit questions and register issues.", "plc": "plc", "reports.done": "Done", "reports.file_type.csv": "CSV", "reports.file_type.pdf": "PDF", "reports.generating": "Generating", "reports.pending": "Pending", "reports.report_type.incoming": "Incoming Calls", "reports.report_type.outgoing": "Outgoing Calls", "service.draft": "Installing", "service.in_progress": "In Progress", "service.temporary_lock": "You Can’t Change Service At This Moment", "su 21% PVM": "with 21% VAT", "užsisakyti naują internetinį vardą (vardų zoną) su galūnėmis: .lt, .lv, .com, .net, .org;": "order new domain: .lt, .lv, .com, .net,, .org;", "užsisakyti naują virtualų serverį;": "order new virtual server;", "vds.os.openvz_debian_32": "Linux Debian OS 32bit", "vds.os.openvz_debian_64": "Linux Debian OS 64bit", "Į planą": "To plan", "Įeinantys": "Incoming", "Įmonės kodas": "Company Code", "Įmonės pavadinimas": "Company Name", "Įsigyti": "Buy", "Įvykiai": "Events", "Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.": "An error occurred! Please contact the system administrator.", "Įvyko klaida, mėginkite dar kartą": "Connection failed. Please try again.", "įjungti / išjungti apsaugą nuo virusų ar šiukšlių (angl. spam);": "turn on / turn off spam", "Š": "Sa", "Ši DNS zona neaptarnaujama mūsų serveriuose. Kreipkitės į DNS zoną aptarnaujantį tiekėją.": "There is no DNS zone on our servers, please contact your DNS zone provider.", "Ši VoIP išklotinė yra mokama. Išklotinės kaina yra 4,34 EUR. Ar norite tęsti?": "The price of creating this report is 4.34 EUR. Do you want to proceed?", "Ši {{item.number}} sąskaita apmokėta. Mokėjimas bus įskaitytas per kelias darbo dienas. Ačiū.": "This invoice {{item.number}} is already payed. The payment will be received within a few working days. Thank you.", "Šiandien": "Today", "Šis laukas yra privalomas.": "Required Field", "Šis vartotojas neturi el. parašo": "This user doesn’t have e-signature or it is missconfigured", "Šiuo metu paslauga atnaujinama. Luktelėkite...": "At This Time Service Is Up To Date. Please Wait ...", "ŪB": "ŪB", "ŽŪB": "ŽŪB", "ŽŪK": "ŽŪK", "„Smart-ID“": "“Smart-ID”" });
    /* jshint +W100 */
}]);
angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
    /* jshint -W100 */
    gettextCatalog.setStrings('lt', { "* Rodomos tik paskutinių šešių mėnesių išklotinės": "* Rodomos tik paskutinių šešių mėnesių išklotinės", "A": "A", "AAS": "AAS", "AB": "AB", "ADB": "ADB", "APB": "APB", "AS": "AS", "Adresas": "Adresas", "Advokatų profesinė bendrija": "Advokatų profesinė bendrija", "Akcinės bendrovės filialas": "Akcinės bendrovės filialas", "Anaujinti": "Atnaujinti", "Apie mus": "Apie mus", "Apmokėti": "Apmokėti", "Apmokėti iki": "Apmokėti iki", "Aprašymas": "Aprašymas", "Aprašymo nėra": "Aprašymo nėra", "Ar Jūs tikrai norite atstatyti pradinius parametrus?": "Ar Jūs tikrai norite atstatyti pradinius parametrus?", "Ar Jūs tikrai norite pašalinti DNS įrašą?": "Ar Jūs tikrai norite pašalinti DNS įrašą?", "Asmens kodas": "Asmens kodas", "Asmens tipas": "Asmens tipas", "Asmuo": "Asmuo", "Asociacija": "Asociacija", "Ataskaitos": "Ataskaitos", "Atnaujinti": "Atnaujinti", "Atsakymas nesulauktas. Mėginkite dar kartą.": "Atsakymas nesulauktas. Mėginkite dar kartą.", "Atsijungti nuo Klientų zonos": "Atsijungti nuo Klientų zonos", "Atsisiųsti": "Atsisiųsti", "Atsk. asmuo": "Atsk. asmuo", "Atstovaujamas asmuo": "Atstovaujamas asmuo", "Atšaukti": "Atšaukti", "Automatinėje paslaugų valdymo sistemoje Jūs galite:": "Automatinėje paslaugų valdymo sistemoje Jūs galite:", "Ačiū, kad pirkote!": "Ačiū, kad pirkote!", "Baigti registraciją": "Baigti registraciją", "Balandis": "Balandis", "Baltnetos komunikacijos": "Baltnetos komunikacijos", "Bendrija": "Bendrija", "Birželis": "Birželis", "Biudžetinė įstaiga": "Biudžetinė įstaiga", "Būsena": "Būsena", "CJSC": "CJSC", "CSV": "CSV", "Cancel": "Atšaukti", "DNS zonos įrašai": "DNS zonos įrašai", "DNS įrašas atnaujintas": "DNS įrašas atnaujintas", "DNS įrašas pašalintas": "DNS įrašas pašalintas", "DNS įrašas pridėtas": "DNS įrašas pridėtas", "DNSB": "DNSB", "Data": "Data", "Debesų kompiuterijos ir serverių ekspertai": "Debesų kompiuterijos ir serverių ekspertai", "Dedikuotų serverių nuoma": "Dedikuotų serverių nuoma", "Disko talpa": "Disko talpa", "Dokumentas pasirašytas sėkmingai": "Dokumentas pasirašytas sėkmingai", "Domenas": "Domenas", "Domeno pirkimas": "Domeno pirkimas", "Download (International)": "Download (International)", "Download (LT)": "Download (LT)", "Duomenys": "Duomenys", "Duomenų centras": "Duomenų centras", "Duomenų naudojimo grafikas": "Duomenų naudojimo grafikas", "EUR/met.": "EUR/met.", "EUR/mėn.": "EUR/mėn.", "El. lizdas": "El. lizdas", "El. paštas": "El. paštas", "El. paštas pakeistas sėkmingai": "El. paštas pakeistas sėkmingai", "El. pašto keitimo instrukcijos išsiųstos nurodytu adresu": "El. pašto keitimo instrukcijos išsiųstos nurodytu adresu", "Elektros lizdas perkrautas sėkmingai": "Elektros lizdas perkrautas sėkmingai", "Elektros lizdų perkrovimas": "Elektros lizdų perkrovimas", "Estija": "Estija", "FM AB": "FM AB", "Failas": "Failas", "Fizinis asmuo": "Fizinis asmuo", "Formuoti": "Formuoti", "GMbH": "GMbH", "Gedimas": "Gedimas", "Gedimas užregistruotas sėkmingai.": "Gedimas užregistruotas sėkmingai.", "Gegužė": "Gegužė", "Gruodis": "Gruodis", "Grįžti": "Grįžti", "I understand risk": "Suprantu riziką", "IB": "IB", "IOOO": "IOOO", "IP adresai": "IP adresai", "IT priežiūra": "IT priežiūra", "IT ūkio priežiūros įvykdytų darbų ataskaita": "IT ūkio priežiūros įvykdytų darbų ataskaita", "Iki": "Iki", "Inc": "Inc", "Incidentai": "Incidentai", "Informacijos prašymai": "Informacijos prašymai", "Informuojame, kad šiuo metu paslaugos keisti negalima": "Informuojame, kad šiuo metu paslaugos keisti negalima", "Inicijuojamas mokėjimas. Luktelėkite...": "Inicijuojamas mokėjimas. Luktelėkite...", "Internetas": "Internetas", "Interneto ryšio paslaugos, vartojimo statistika": "Interneto ryšio paslaugos, vartojimo statistika", "Investicines kompanija": "Investicines kompanija", "Iį": "Iį", "Iš plano": "Iš plano", "Iš viso:": "Iš viso:", "Išeinantys": "Išeinantys", "Išrašymo data": "Išrašymo data", "Išspręsta": "Išspręsta", "Išspręsti iki": "Išspręsti iki", "Išspręstos": "Išspręstos", "Ištrinti": "Ištrinti", "Išvalyti": "Išvalyti", "Jeigu mokėjimą atlikote ne iš Automatinės paslaugų valdymo sistemos (myportal.balt.net) puslapio, Jūsų mokėjimas bus užskaitytas per kelias darbo dienas. Prašome nekartoti mokėjimo.": "Jeigu mokėjimą atlikote ne iš Automatinės paslaugų valdymo sistemos (myportal.balt.net) puslapio, Jūsų mokėjimas bus užskaitytas per kelias darbo dienas. Prašome nekartoti mokėjimo.", "Juridinis asmuo": "Juridinis asmuo", "Jūs neturite VoIP išklotinių": "Jūs neturite VoIP išklotinių", "Jūs neturite sutarčių": "Jūs neturite sutarčių", "Jūs neturite sąskaitų": "Jūs neturite sąskaitų", "Jūs neturite užklausų pasirinktame laikotarpyje": "Jūs neturite užklausų pasirinktame laikotarpyje", "Jūs neturite užsakytų paslaugų": "Jūs neturite užsakytų paslaugų", "Jūs neužsisakėte paslaugų": "Jūs neužsisakėte paslaugų", "Jūs užsiregistravote į sistemą": "Jūs užsiregistravote į sistemą", "Jūsų paslaugų krepšelis": "Jūsų paslaugų krepšelis", "K": "K", "KB": "KB", "Kaina (be PVM)": "Kaina (be PVM)", "Keisti": "Keisti", "Keisti el. paštą": "Keisti el. paštą", "Keisti profilio duomenis": "Keisti profilio duomenis", "Keisti slaptažodį": "Keisti slaptažodį", "Keliaujame į mokėjimus. Luktelėkite...": "Keliaujame į mokėjimus. Luktelėkite...", "Kiekis": "Kiekis", "Kiti validavimo pranešimai.": "Kiti validavimo pranešimai.", "Kito mėnesio mokestis": "Kito mėnesio mokestis", "Kitos paslaugos": "Kitos paslaugos", "Kliento sutartys": "Sutartys", "Kliento sąskaitos": "Kliento sąskaitos", "Komunikacija": "Komunikacija", "Kontaktai": "Kontaktai", "Kontrolinis kodas": "Kontrolinis kodas", "Kovas": "Kovas", "Kredito unija": "Kredito unija", "Kurti naują VoIP išklotinę": "Kurti naują VoIP išklotinę", "KŪB": "KŪB", "LLP": "LLP", "Labdaros ir paramos fondas": "Labdaros ir paramos fondas", "Lapkritis": "Lapkritis", "Latvija": "Latvija", "Liepa": "Liepa", "Lietuva": "Lietuva", "Likutis": "Likutis", "Ltd": "Ltd", "MB": "MB", "Mano užsakymas": "Mano užsakymas", "Mat. vnt.": "Mat. vnt.", "Mažoji bendrija": "Mažoji bendrija", "Mobiliuoju parašu": "Mobiliuoju parašu", "Mokėjimas buvo nutrauktas": "Mokėjimas buvo nutrauktas", "Mokėjimo klaidos!": "Mokėjimo klaidos!", "Mokėti": "Mokėti", "Naudosiu savo turimą": "Naudosiu savo turimą", "Naudotojas": "Naudotojas", "Naudotojo vardas arba el. pašto adresas": "Naudotojo vardas arba el. pašto adresas", "Nauja kaina": "Nauja kaina", "Naujas slaptažodis": "Naujas slaptažodis", "Nauji planai": "Nauji planai", "Ne": "Ne", "Negalime priimti mokėjimo!": "Negalime priimti mokėjimo!", "Negalime priimti šio atšaukimo": "Negalime priimti šio atšaukimo", "Nepavyko atsiųsti sąskaitos!": "Nepavyko atsiųsti sąskaitos!", "Nepavyko prisijungti. Bandykite dar kartą.": "Nepavyko prisijungti. Bandykite dar kartą.", "Neteisingai nurodytas kontaktinis el. paštas.": "Neteisingai nurodytas kontaktinis el. paštas.", "Neteisingai nurodytas pašto adresas.": "Neteisingai nurodytas pašto adresas.", "Neteisingai nurodytas serverio vardas.": "Neteisingai nurodytas serverio vardas.", "Nuo": "Nuo", "Nurodykite domeną": "Nurodykite domeną", "Nurodykite el. paštą": "Nurodykite el. paštą", "Nurodyta reikšmė yra per ilga": "Nurodyta reikšmė yra per ilga", "Nurodyta reikšmė yra per trumpa.": "Nurodyta reikšmė yra per trumpa.", "Nėra duomenų": "Nėra duomenų", "OOO": "OOO", "OU": "OU", "Operacinė sistema": "Operacinė sistema", "PDF": "PDF", "Pabaiga": "Pabaiga", "Pagalbos centras": "Pagalbos centras", "Pagalbos centro užklausos": "Pagalbos centro užklausos", "Pakartokite slaptažodį": "Pakartokite slaptažodį", "Pakeiskite slaptažodį": "Pakeiskite slaptažodį", "Pakeisti": "Pakeisti", "Pakeisti slaptažodį": "Pakeisti slaptažodį", "Pakeitimų prašymai": "Pakeitimų prašymai", "Palaukite...": "Palaukite…", "Pamiršote slaptažodį?": "Pamiršote slaptažodį?", "Pasirašymas atšauktas": "Pasirašymas atšauktas", "Pasirašyti": "Pasirašyti", "Pasirinkite adresą iš sąrašo": "Pasirinkite adresą iš sąrašo", "Pasirinkite mokėjimo būdą": "Pasirinkite mokėjimo būdą", "Pasirinkite paslaugą": "Pasirinkite paslaugą", "Pasirinkite planą": "Pasirinkite planą", "Pasirinkti": "Pasirinkti", "Paslauga": "Paslauga", "Paslaugos": "Paslaugos", "Paslaugos adresas": "Paslaugos adresas", "Paslaugos duomenys": "Paslaugos duomenys", "Paslaugos greitis kbps": "Paslaugos greitis kbps", "Paslaugos planas": "Paslaugos planas", "Paslaugos trumpas aprašymas": "Paslaugos trumpas aprašymas", "Patikrinkite telefono numerį": "Patikrinkite telefono numerį", "Patikrinkite, ar sutampa išmaniajame įrenginyje ir ekrane matomas kontrolinis kodas": "Patikrinkite, ar sutampa išmaniajame įrenginyje ir ekrane matomas kontrolinis kodas", "Patvirtinkite": "Patvirtinkite", "Patvirtinkite įvesdami PIN": "Patvirtinkite įvesdami PIN", "Pavadinimas": "Pavadinimas", "Pažymėti viską": "Pažymėti viską", "Periodas": "Periodas", "Perkrauti": "Perkrauti", "Personalinė įmonė": "Personalinė įmonė", "Peržiūrėti": "Peržiūrėti", "Pirkti": "Pirkti", "Plano keitimas": "Plano keitimas", "Pn": "Pn", "Politinė partija": "Politinė partija", "Pr": "Pr", "Pradiniai parametrai": "Pradiniai parametrai", "Pradžios data": "Pradžios data", "Pranešimas sėkmingai išsiųstas.": "Pranešimas sėkmingai išsiųstas.", "Pranešimo tekstas": "Pranešimo tekstas", "Pratęskite el. pašto keitimą": "Pratęskite el. pašto keitimą", "Pratęskite registraciją": "Pratęskite registraciją", "Prašome palaukti": "Prašome palaukti", "Pridėti": "Pridėti", "Pridėti naują įrašą": "Pridėti naują įrašą", "Priminti": "Priminti", "Prioritetas": "Prioritetas", "Prisijungimas į Klientų zoną": "Prisijungimas į Klientų zoną", "Prisijungti": "Prisijungti", "Prisijunkite prie automatinės paslaugų valdymo sistemos. Įveskite savo prisijungimo vardą ir\nslaptažodį viršuje pateiktoje formoje. Jeigu Jūs neturite, nežinote ar pamiršote šiuos prisijungimo\nduomenis – kreipkitės į Jus aptarnaujantį vadybininką.": "Prisijunkite prie automatinės paslaugų valdymo sistemos. Įveskite savo prisijungimo vardą ir\nslaptažodį viršuje pateiktoje formoje. Jeigu Jūs neturite, nežinote ar pamiršote šiuos prisijungimo\nduomenis – kreipkitės į Jus aptarnaujantį vadybininką.", "Procesoriaus branduoliai": "Procesoriaus branduoliai", "Profesinė sąjunga ar susivienijimas": "Profesinė sąjunga ar susivienijimas", "Profilis": "Profilis", "Profilis atnaujintas": "Profilis atnaujintas", "PĮ": "PĮ", "RAB": "RAB", "RAM atmintis": "RAM atmintis", "Reboot": "Perkrauti", "Rebooting socket power for running servers may cause data loss!": "Elektros lizdo perkrovimas veikiančiam serveriui, gali sukelti duomenų praradimą!", "Redaguoti": "Redaguoti", "Redaguoti DNS": "Redaguoti DNS", "Registracija": "Registracija", "Registracijos instrukcijos išsiųstos į Jūsų elektroninį paštą": "Registracijos instrukcijos išsiųstos į Jūsų elektroninį paštą", "Registravimasis į Klientų zoną": "Registravimasis į Klientų zoną", "Registravimo data": "Registravimo data", "Registruotis": "Registruotis", "Resursas nerastas": "Resursas nerastas", "Resursų nuoma (IaaS)": "Resursų nuoma (IaaS)", "Rugpjūtis": "Rugpjūtis", "Rugsėjis": "Rugsėjis", "S": "S", "SARL": "SARL", "SE": "SE", "SIA": "SIA", "SLA": "SLA", "SLA ataskaita": "SLA ataskaita", "Sausis": "Sausis", "Savaitė": "Savaitė", "Savivaldybės įmonė": "Savivaldybės įmonė", "Serverio vardas": "Serverio vardas", "Serverio vardas ir IP adresas": "Serverio vardas ir IP adresas", "Serveris": "Serveris", "Serveris neatsiliepė. Bandykite dar kartą.": "Serveris neatsiliepė. Bandykite dar kartą.", "Serveris šiuo metu nepasiekiamas": "Serveris šiuo metu nepasiekiamas", "Serverių saugykla": "Serverių saugykla", "Siųsti": "Siųsti", "Skambučiai": "Skambučiai", "Slaptažodis": "Slaptažodis", "Slaptažodis pakeistas sėkmingai": "Slaptažodis pakeistas sėkmingai", "Slaptažodžio atstatymo instrukcijos išsiųstos į Jūsų elektroninį paštą": "Slaptažodžio atstatymo instrukcijos išsiųstos į Jūsų elektroninį paštą", "Sp. z.o.o.": "Sp. z.o.o.", "Spalis": "Spalis", "Sprendimas": "Sprendimas", "Sukurkite paskyrą": "Sukurkite paskyrą", "Sukurkite užklausą": "Sukurkite užklausą", "Sukurti VDS": "Sukurti VDS", "Sukurti domeną": "Sukurti domeną", "Sukurti talpinimo paslaugą": "Sukurti talpinimo paslaugą", "Sukurti užklausą": "Sukurti užklausą", "Suma": "Suma", "Suma (be PVM)": "Suma (be PVM)", "Susirašinėjimas": "Susirašinėjimas", "Sutartys": "Sutartys", "Sveikiname, Jūs prisijungėte prie sistemos.": "Sveikiname, Jūs prisijungėte prie sistemos.", "Svetainių talpinimas ir domenai": "Svetainių talpinimas ir domenai", "Sąskaita apmokėta sėkmingai.": "Sąskaita apmokėta sėkmingai.", "Sąskaitos": "Sąskaitos", "Sąskaitos apmokėjimas buvo nutrauktas.": "Sąskaitos apmokėjimas buvo nutrauktas.", "Sąskaitos numeris": "Sąskaitos numeris", "T": "T", "TOO": "TOO", "TTL": "TTL", "Taip": "Taip", "Techninė pagalba:": "Techninė pagalba:", "Telefono numeris": "Telefono numeris", "Tema": "Tema", "Threre is no PDU sockets assigend to service": "Nėra priskirtų PDU", "Tikrinti": "Tikrinti", "Tipas": "Tipas", "Toks domenas jau užimtas": "Toks domenas jau užimtas", "Toliau": "Toliau", "Tradicinė religinė bendruomenė ar bendrija": "Tradicinė religinė bendruomenė ar bendrija", "Turimas planas": "Turimas planas", "Type reason here": "Įrašykite priežastį", "TŪB": "TŪB", "UAB": "UAB", "UAB - firma": "UAB - firma", "UAB DK": "UAB DK", "UAB FMĮ": "UAB FMĮ", "UAB Filialas": "UAB Filialas", "UADB": "UADB", "UADBB": "UADBB", "UAGDPB": "UAGDPB", "URL error: \"baseUrl\" should be defined or \"options.url\" specified to \"query\" a resource": "URL error: \"baseUrl\" should be defined or \"options.url\" specified to \"query\" a resource", "Upload (International)": "Upload (International)", "Upload (LT)": "Upload (LT)", "Uždaryti": "Uždaryti", "Užklausos ID": "Užklausos ID", "Užpildykite privalomus laukus": "Užpildykite privalomus laukus", "Užregistruoti": "Užregistruoti", "Užregistruoti naują domeną": "Užregistruoti naują domeną", "Užsienio juridinio asmens atstovybė": "Užsienio juridinio asmens atstovybė", "Užsienio juridinio asmens filialas": "Užsienio juridinio asmens filialas", "VK": "VK", "Valdymo skydelis": "Valdymo skydelis", "Vardas": "Vardas", "Vasaris": "Vasaris", "Veiksmai": "Veiksmai", "Viešosios įstaigos filialas": "Viešosios įstaigos filialas", "Virtualūs dedikuoti serveriai (VDS)": "Virtualūs dedikuoti serveriai (VDS)", "VoIP išklotinė": "VoIP išklotinė", "VoIP išklotinė atšaukta": "VoIP išklotinė atšaukta", "VoIP išklotinė kuriama": "VoIP išklotinė kuriama", "VoIP išklotinės": "VoIP išklotinės", "Vykdomos": "Vykdomos", "VĮ": "VĮ", "Všį": "Všį", "helpdesk.done": "Uždaryta", "helpdesk.draft": "Ne priskirta", "helpdesk.fixed": "Pataisyta", "helpdesk.open": "Vykdoma", "helpdesk.pending": "Laikinai sustabdyta", "invoice.open": "Neapmokėta", "invoice.paid": "Apmokėta", "invoice.proforma2": "Išankstinė", "keisti bendrąją informaciją: prisijungimo vardus, slaptažodžius ir t. t.;": "keisti bendrąją informaciją: prisijungimo vardus, slaptažodžius ir t. t.;", "keisti virtualaus serverio FTP prisijungimo, MySQL, webalizer slaptažodžius, aktyvuoti MySQL, webalizer (lankomumo statistika);": "keisti virtualaus serverio FTP prisijungimo, MySQL, webalizer slaptažodžius, aktyvuoti MySQL, webalizer (lankomumo statistika);", "kurti naujas pašto dėžutes, keisti slaptažodžius, pašalinti dėžutes;": "kurti naujas pašto dėžutes, keisti slaptažodžius, pašalinti dėžutes;", "nežinoma": "nežinoma", "oy": "oy", "pagalba@balt.net, +370 700 800 88": "pagalba@balt.net, +370 700 800 88", "pasižiūrėti savo turimų paslaugų planus(-ą), stebėti jų naudojimo statistiką;": "pasižiūrėti savo turimų paslaugų planus(-ą), stebėti jų naudojimo statistiką;", "paslauga": ["paslauga", "paslaugos", "paslaugų"], "pateikti klausimus ir registruoti problemas.": "pateikti klausimus ir registruoti problemas.", "plc": "plc", "reports.done": "Atlikta", "reports.file_type.csv": "CSV", "reports.file_type.pdf": "PDF", "reports.generating": "Ruošiama", "reports.pending": "Eilėje", "reports.report_type.incoming": "Įeinantys skambučiai", "reports.report_type.outgoing": "Išeinantys skambučiai", "service.draft": "Ruošiama", "service.in_progress": "Aktyvi", "service.temporary_lock": "Šiuo metu negalima keisti paslaugos parametrų", "su 21% PVM": "su 21% PVM", "užsisakyti naują internetinį vardą (vardų zoną) su galūnėmis: .lt, .lv, .com, .net, .org;": "užsisakyti naują internetinį vardą (vardų zoną) su galūnėmis: .lt, .lv, .com, .net, .org;", "užsisakyti naują virtualų serverį;": "užsisakyti naują virtualų serverį;", "vds.os.openvz_debian_32": "Linux Debian OS 32bit", "vds.os.openvz_debian_64": "Linux Debian OS 64bit", "Į planą": "Į planą", "Įeinantys": "Įeinantys", "Įmonės kodas": "Įmonės kodas", "Įmonės pavadinimas": "Įmonės pavadinimas", "Įsigyti": "Įsigyti", "Įvykiai": "Įvykiai", "Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.": "Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.", "Įvyko klaida, mėginkite dar kartą": "Įvyko klaida, mėginkite dar kartą", "įjungti / išjungti apsaugą nuo virusų ar šiukšlių (angl. spam);": "įjungti / išjungti apsaugą nuo virusų ar šiukšlių (angl. spam);", "Š": "Š", "Ši DNS zona neaptarnaujama mūsų serveriuose. Kreipkitės į DNS zoną aptarnaujantį tiekėją.": "Ši DNS zona neaptarnaujama mūsų serveriuose. Kreipkitės į DNS zoną aptarnaujantį tiekėją.", "Ši VoIP išklotinė yra mokama. Išklotinės kaina yra 4,34 EUR. Ar norite tęsti?": "Ši VoIP išklotinė yra mokama. Išklotinės kaina yra 4,34 EUR. Ar norite tęsti?", "Ši {{item.number}} sąskaita apmokėta. Mokėjimas bus įskaitytas per kelias darbo dienas. Ačiū.": "Ši {{item.number}} sąskaita apmokėta. Mokėjimas bus įskaitytas per kelias darbo dienas. Ačiū.", "Šiandien": "Šiandien", "Šis laukas yra privalomas.": "Šis laukas yra privalomas.", "Šis vartotojas neturi el. parašo": "Šis vartotojas neturi el. parašo arba jis blogai sukonfigūruotas", "Šiuo metu paslauga atnaujinama. Luktelėkite...": "Šiuo metu paslauga atnaujinama. Luktelėkite...", "ŪB": "ŪB", "ŽŪB": "ŽŪB", "ŽŪK": "ŽŪK", "„Smart-ID“": "„Smart-ID“" });
    /* jshint +W100 */
}]);
angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
    /* jshint -W100 */
    gettextCatalog.setStrings('ru', { "* Rodomos tik paskutinių šešių mėnesių išklotinės": "* Вы можете увидеть отчет за последние шесть месяцев", "A": "Вт", "AAS": "AAS", "AB": "AB", "ADB": "ADB", "APB": "APB", "AS": "AS", "Adresas": "Адрес", "Advokatų profesinė bendrija": "Advokatų profesinė bendrija", "Akcinės bendrovės filialas": "Akcinės bendrovės filialas", "Anaujinti": "Обновить", "Apie mus": "О нас", "Apmokėti": "Оплатить", "Apmokėti iki": "Оплатить до", "Aprašymas": "Описание", "Aprašymo nėra": "Нет описания", "Ar Jūs tikrai norite atstatyti pradinius parametrus?": "Вы действительно хотите вернуться к первоначальным настройкам?", "Ar Jūs tikrai norite pašalinti DNS įrašą?": "Вы уверены, что вы хотите удалить запись DNS?", "Asmens kodas": "Персональный код", "Asmens tipas": "Тип личности", "Asmuo": "Физическое лицо", "Asociacija": "Asociacija", "Ataskaitos": "Отчеты", "Atnaujinti": "Восстановить", "Atsakymas nesulauktas. Mėginkite dar kartą.": "Нет ответа. Попробуйте еще раз.", "Atsijungti nuo Klientų zonos": "Отсоединить", "Atsisiųsti": "Скачать", "Atsk. asmuo": "Ответственное лицо", "Atstovaujamas asmuo": "Уполномоченный представитель клиента", "Atšaukti": "Отменить", "Automatinėje paslaugų valdymo sistemoje Jūs galite:": "Автоматическая система управления услугами позволяет:", "Ačiū, kad pirkote!": "Спасибо за покупку!", "Baigti registraciją": "Pегистрация завершинa", "Balandis": "Апрель", "Baltnetos komunikacijos": "Балтнет Коммуникации", "Bendrija": "Bendrija", "Birželis": "Июнь", "Biudžetinė įstaiga": "Biudžetinė įstaiga", "Būsena": "Состояние", "CJSC": "CJSC", "CSV": "CSV", "Cancel": "Отменить", "DNS zonos įrašai": "Записи DNS зоны", "DNS įrašas atnaujintas": "Запись DNS обновлен", "DNS įrašas pašalintas": "Запись DNS удален", "DNS įrašas pridėtas": "Запись DNS добавлен", "DNSB": "DNSB", "Data": "Дата", "Debesų kompiuterijos ir serverių ekspertai": "Эксперты в сфере облачных вычислений и серверов.", "Dedikuotų serverių nuoma": "Аренда выделенных серверoв", "Disko talpa": "Eмкость диска", "Documentas": "Документ", "Dokumentas pasirašytas sėkmingai": "Документ успешно подписан", "Domenas": "Домен", "Domeno pirkimas": "Покупка домена", "Download (International)": "Download (Международный)", "Download (LT)": "Download (LT)", "Duomenys": "Данные", "Duomenų centras": "Дата центр", "Duomenų naudojimo grafikas": "График потребления данных", "EUR/met.": "EUR/год.", "EUR/mėn.": "EUR/месяц.", "El. lizdas": "Розетка", "El. paštas": "Эл. почта", "El. paštas pakeistas sėkmingai": "Эл. почта успешно изменен", "El. pašto keitimo instrukcijos išsiųstos nurodytu adresu": "Инструкции отправлены по электронной почте", "Elektros lizdas perkrautas sėkmingai": "Перезагрузка питания завершена", "Elektros lizdų perkrovimas": "Перезагрузка электро розеток", "Estija": "Эстония", "FM AB": "FM AB", "Failas": "Файл", "Fizinis asmuo": "Физическое лицо", "Formuoti": "Формировать", "GMbH": "GMbH", "Gedimas": "Неисправность", "Gedimas užregistruotas sėkmingai.": "Неисправность записывается успешно.", "Gegužė": "Май", "Gruodis": "Декабрь", "Grįžti": "Вернутся", "I understand risk": "Я понимаю, риск", "IB": "IB", "IOOO": "IOOO", "IP adresai": "IP Адрес", "IT priežiūra": "ИТ поддержка", "IT ūkio priežiūros įvykdytų darbų ataskaita": "Отчет по обслуживанию ИТ", "Iki": "до", "Inc": "Inc", "Incidentai": "Происшествия", "Informacijos prašymai": "Информационные запросы", "Informuojame, kad šiuo metu paslaugos keisti negalima": "Обратите внимание, что в настоящее время услуги не могут быть изменены", "Inicijuojamas mokėjimas. Luktelėkite...": "Инициирование платежа. Пожалуйста, подождите ..", "Internetas": "Интернет", "Interneto ryšio paslaugos, vartojimo statistika": "Статистика использования интернетa", "Investicines kompanija": "Investicines kompanija", "Iį": "Iį", "Iš plano": "Iš plano", "Iš viso:": "Всего:", "Išeinantys": "Исходяшие", "Išrašymo data": "Дата выставления счета", "Išspręsta": "Решено", "Išspręsti iki": "Чтобы решить", "Išspręstos": "Решены", "Ištrinti": "Удалить", "Išvalyti": "Очистить", "Jeigu mokėjimą atlikote ne iš Automatinės paslaugų valdymo sistemos (myportal.balt.net) puslapio, Jūsų mokėjimas bus užskaitytas per kelias darbo dienas. Prašome nekartoti mokėjimo.": "Если оплата была сделана из других источников, а не из системы автоматического управления услугами (myportal.balt.net), пожалуйста, не платите еще раз за это. Оплата будет подтверждена в течение нескольких рабочих дней.", "Juridinis asmuo": "Юридическое лицо", "Jūs neturite VoIP išklotinių": "У Вас нет VoIP отчетов", "Jūs neturite sutarčių": "У вас нет контрактов", "Jūs neturite sąskaitų": "У Вас нет счет-фактуры", "Jūs neturite užklausų pasirinktame laikotarpyje": "У Вас нет запросов на выбранный период", "Jūs neturite užsakytų paslaugų": "У Вас нет заказанных услуг", "Jūs neužsisakėte paslaugų": "Вы не заказали услуг", "Jūs užsiregistravote į sistemą": "Вы вошли в систему", "Jūsų paslaugų krepšelis": "Ваша корзина", "K": "Чт", "KB": "KB", "Kaina (be PVM)": "Цена (без НДС)", "Keisti": "Изменение", "Keisti el. paštą": "Изменить адрес электронной почты", "Keisti profilio duomenis": "Изменить данные профиля", "Keisti slaptažodį": "Напоминание пароля", "Keliaujame į mokėjimus. Luktelėkite...": "Пожалуйста, подождите ...", "Kiekis": "Kоличество", "Kiti validavimo pranešimai.": "Другие сообщения валидации.", "Kito mėnesio mokestis": "Плата следующем месяцe", "Kitos paslaugos": "Прочие услуги", "Kliento sutartys": "Соглашениe с клиентам", "Kliento sąskaitos": "Cчет-фактуры киента", "Komunikacija": "VoIP", "Kontaktai": "Контакты", "Kontrolinis kodas": "Контрольный код", "Kovas": "Март", "Kredito unija": "Kredito unija", "Kurti naują VoIP išklotinę": "Создать новый отчет VoIP", "KŪB": "KŪB", "LLP": "LLP", "Labdaros ir paramos fondas": "Labdaros ir paramos fondas", "Lapkritis": "Ноябрe", "Latvija": "Латвия", "Liepa": "Июля", "Lietuva": "Литва", "Likutis": "баланс", "Ltd": "Ltd", "MB": "MB", "Mano užsakymas": "Mano užsakymas", "Mat. vnt.": "Ед. изм.", "Mažoji bendrija": "Mažoji bendrija", "Mobiliuoju parašu": "Электронной подписью", "Mokėjimas buvo nutrauktas": "Оплата была остановлена", "Mokėjimo klaidos!": "Ошибка oплата!", "Mokėti": "Оплатить", "Naudosiu savo turimą": "Используйте ваш собственный", "Naudotojas": "Пользователь", "Naudotojo vardas arba el. pašto adresas": "Имя пользователя или адрес электронной почты", "Nauja kaina": "Новая цена", "Naujas slaptažodis": "Новый пароль", "Nauji planai": "Новые планы", "Ne": "Нет", "Negalime priimti mokėjimo!": "Мы не можем принять оплату!", "Negalime priimti šio atšaukimo": "Мы не можем принять отмены", "Nepavyko atsiųsti sąskaitos!": "Мы не можем загрузить счет!", "Nepavyko prisijungti. Bandykite dar kartą.": "Подключение не удалось. Пожалуйста, попробуйте еще раз.", "Neteisingai nurodytas kontaktinis el. paštas.": "Неправильно указана электронная почта", "Neteisingai nurodytas pašto adresas.": "Неправильно указанa эл. почта", "Neteisingai nurodytas serverio vardas.": "Неправильно указаны имя сервера.", "Nuo": "От", "Nurodykite domeną": "Укажите домен", "Nurodykite el. paštą": "Укажите адрес эл. почты", "Nurodyta reikšmė yra per ilga": "Указанa значения слишком длинная", "Nurodyta reikšmė yra per trumpa.": "Указанa значения слишком короткая.", "Nėra duomenų": "Нет Данных", "OOO": "OOO", "OU": "OU", "Operacinė sistema": "Операционная система", "PDF": "PDF", "Pabaiga": "Конец", "Pagalbos centras": "Helpdesk", "Pagalbos centro užklausos": "Запросы в службу технической поддержки", "Pakartokite slaptažodį": "Повторите пароль", "Pakeiskite slaptažodį": "Измените свой пароль", "Pakeisti": "Заменить", "Pakeisti slaptažodį": "Изменить пароль", "Pakeitimų prašymai": "Запрос на изменение", "Palaukite...": "Подожите…", "Pamiršote slaptažodį?": "Забыли пароль?", "Pasirašymas atšauktas": "Подписание отменена", "Pasirašyti": "Подписать", "Pasirinkite adresą iš sąrašo": "Выберите адрес из списка", "Pasirinkite mokėjimo būdą": "Выберите способ оплаты", "Pasirinkite paslaugą": "Выберите услугу", "Pasirinkite planą": "Выберите план", "Pasirinkti": "Применить", "Paslauga": "Услуга", "Paslaugos": "Услуги", "Paslaugos adresas": "Адрес yслуги", "Paslaugos duomenys": "Услуги передачи данных", "Paslaugos greitis kbps": "Скорость Услуги кбит", "Paslaugos planas": "План услуги", "Paslaugos trumpas aprašymas": "Краткое описание услуги ", "Patikrinkite telefono numerį": "Проверьте номер телефона", "Patikrinkite, ar sutampa išmaniajame įrenginyje ir ekrane matomas kontrolinis kodas": "Проверьте, совпадают ли контрольный код, высвечиваемый в смарт-устройстве и на экране", "Patvirtinkite": "Подтвердите", "Patvirtinkite įvesdami PIN": "После ввода PIN кода подтвердите", "Pavadinimas": "Название", "Pažymėti viską": "Выбрать все", "Periodas": "Период", "Perkrauti": "Перезагружать", "Personalinė įmonė": "Personalinė įmonė", "Peržiūrėti": "Посмотреть", "Pirkti": "Заказать", "Plano keitimas": "Изменение плана", "Pn": "Пя", "Politinė partija": "Politinė partija", "Pr": "По", "Pradiniai parametrai": "Исходные установки", "Pradžios data": "Дата начала", "Pranešimas sėkmingai išsiųstas.": "Сообщение успешно отправлено.", "Pranešimo tekstas": "Сообщение", "Pratęskite el. pašto keitimą": "Продолжить изменение электронной почты", "Pratęskite registraciją": "Продолжить регистрацию", "Prašome palaukti": "Пожалуйста подождите", "Pridėti": "Добавить", "Pridėti naują įrašą": "Добавить новою запись", "Priminti": "Напомним", "Prioritetas": "Приоритет", "Prisijungimas į Klientų zoną": "Авторизуйтесь в зону клиента", "Prisijungti": "Присоединиться", "Prisijunkite prie automatinės paslaugų valdymo sistemos. Įveskite savo prisijungimo vardą ir\nslaptažodį viršuje pateiktoje formoje. Jeigu Jūs neturite, nežinote ar pamiršote šiuos prisijungimo\nduomenis – kreipkitės į Jus aptarnaujantį vadybininką.": "Чтобы подключится к автоматической системе управления услугами, вам надо ввести имя пользователя и пароль в форме расположенной сверху. В случае если у вас нет данных для подключения, вы их забыли или потеряли - обратитесь к вашему личному менеджеру.", "Procesoriaus branduoliai": "Ядра процессора", "Profesinė sąjunga ar susivienijimas": "Profesinė sąjunga ar susivienijimas", "Profilis": "Профиль", "Profilis atnaujintas": "Профиль обновлен", "PĮ": "PĮ", "RAB": "RAB", "RAM atmintis": "Память RAM", "Reboot": "Перезагружать", "Rebooting socket power for running servers may cause data loss!": "Перезагрузка питания для запущенных серверов может привести к потере данных!", "Redaguoti": "Модифицировать", "Redaguoti DNS": "Модифицировать DNS", "Registracija": "Pегистрация", "Registracijos instrukcijos išsiųstos į Jūsų elektroninį paštą": "Инструкции pегистрации отправлено вам по электронной почте", "Registravimasis į Klientų zoną": "Панель управления", "Registravimo data": "Дата регистрации", "Registruotis": "Регистрация", "Resursas nerastas": "Resursas nerastas", "Resursų nuoma (IaaS)": "Аренда ресурсов (VMware IaaS)", "Rugpjūtis": "Август", "Rugsėjis": "Сентября", "S": "Во", "SARL": "SARL", "SE": "SE", "SIA": "SIA", "SLA": "SLA", "SLA ataskaita": "Отчет SLA", "Sausis": "Января", "Savaitė": "Неделя", "Savivaldybės įmonė": "Savivaldybės įmonė", "Serverio vardas": "Имя сервера", "Serverio vardas ir IP adresas": "Имя хоста и IP-адрес", "Serveris": "Сервер", "Serveris neatsiliepė. Bandykite dar kartą.": "Сервер не ответил. Пожалуйста, попробуйте еще раз.", "Serveris šiuo metu nepasiekiamas": "Сервер в настоящее время недоступен", "Serverių saugykla": "Колокация в ЦОД", "Siųsti": "Отправить", "Skambučiai": "Звонки", "Slaptažodis": "Пароль", "Slaptažodis pakeistas sėkmingai": "Пароль успешно изменен", "Slaptažodžio atstatymo instrukcijos išsiųstos į Jūsų elektroninį paštą": "Инструкции по изменению пароля, отправленные Вам по электронной почте", "Sp. z.o.o.": "Sp. z.o.o.", "Spalis": "Октябре", "Sprendimas": "Решение", "Sukurkite paskyrą": "Cоздать аккаунт", "Sukurkite užklausą": "Регистрация запроса", "Sukurti VDS": "Создать VDS", "Sukurti domeną": "Создать домен", "Sukurti talpinimo paslaugą": "Создать хостинг", "Sukurti užklausą": "Создать запрос", "Suma": "Cумма", "Suma (be PVM)": "Сумма (без НДС)", "Susirašinėjimas": "Переписка", "Sutartys": "Договоры", "Sveikiname, Jūs prisijungėte prie sistemos.": "Поздравляем, вы подключены к системе.", "Svetainių talpinimas ir domenai": "Хостинг и домены", "Sąskaita apmokėta sėkmingai.": "Sąskaita apmokėta sėkmingai.", "Sąskaitos": "Cчета", "Sąskaitos apmokėjimas buvo nutrauktas.": "Sąskaitos apmokėjimas buvo nutrauktas.", "Sąskaitos numeris": "Номер счета", "T": "Cp", "TOO": "TOO", "TTL": "TTL", "Taip": "Да", "Techninė pagalba:": "Helpdesk:", "Telefono numeris": "Номер телефона", "Tema": "Тема", "Threre is no PDU sockets assigend to service": "PDU не назначены", "Tikrinti": "Проверить", "Tipas": "Тип", "Toks domenas jau užimtas": "Этот домен уже занят", "Toliau": "Далее", "Tradicinė religinė bendruomenė ar bendrija": "Tradicinė religinė bendruomenė ar bendrija", "Turimas planas": "Доступный план", "Type reason here": "Укажите причину", "TŪB": "TŪB", "UAB": "UAB", "UAB - firma": "UAB - firma", "UAB DK": "UAB DK", "UAB FMĮ": "UAB FMĮ", "UAB Filialas": "UAB Filialas", "UADB": "UADB", "UADBB": "UADBB", "UAGDPB": "UAGDPB", "URL error: \"baseUrl\" should be defined or \"options.url\" specified to \"query\" a resource": "URL error: \"baseUrl\" should be defined or \"options.url\" specified to \"query\" a resource", "Upload (International)": "Upload (International)", "Upload (LT)": "Upload (LT)", "Uždaryti": "Закрыть", "Užklausos ID": "ID запроса", "Užpildykite privalomus laukus": "Заполните обязательные поля", "Užregistruoti": "Зарегистрировать", "Užregistruoti naują domeną": "Зарегистрировать новый домен", "Užsienio juridinio asmens atstovybė": "Užsienio juridinio asmens atstovybė", "Užsienio juridinio asmens filialas": "Užsienio juridinio asmens filialas", "VK": "VK", "Valdymo skydelis": "Панель управления", "Vardas": "Имя", "Vasaris": "Февраль", "Veiksmai": "Действия", "Viešosios įstaigos filialas": "Viešosios įstaigos filialas", "Virtualūs dedikuoti serveriai (VDS)": "Виртуальные выделенные серверы", "VoIP išklotinė": "Отчет VoIP", "VoIP išklotinė atšaukta": "Отчет VoIP будет удален", "VoIP išklotinė kuriama": "Отчет VoIP создается", "VoIP išklotinės": "Отчеты VoIP", "Vykdomos": "Проводится", "VĮ": "VĮ", "Všį": "Všį", "helpdesk.done": "Закрыто", "helpdesk.draft": "Не открыта", "helpdesk.fixed": "Исправлена", "helpdesk.open": "Выполняется", "helpdesk.pending": "Задержана", "invoice.open": "Не оплаченно", "invoice.paid": "Оплаченно", "invoice.proforma2": "Авансовый", "keisti bendrąją informaciją: prisijungimo vardus, slaptažodžius ir t. t.;": "изменить общую информацию: имена пользователей, пароли, и так далее.", "keisti virtualaus serverio FTP prisijungimo, MySQL, webalizer slaptažodžius, aktyvuoti MySQL, webalizer (lankomumo statistika);": "Изменять аутентификацию подключения к FTP серверу, MySQL, webalizer. Активизировать MySQL, webalizer (статистика посещаемости).", "kurti naujas pašto dėžutes, keisti slaptažodžius, pašalinti dėžutes;": "создать новые почтовые ящики, изменять пароли, yдалить почтовые ящики;", "nežinoma": "nežinoma", "oy": "oy", "pagalba@balt.net, +370 700 800 88": "pagalba@balt.net, +370 700 800 88", "pasižiūrėti savo turimų paslaugų planus(-ą), stebėti jų naudojimo statistiką;": "Посмотреть ваши планы услуг, следить за статистикой их использования.", "paslauga": ["услуга", "услуги", "услуг"], "pateikti klausimus ir registruoti problemas.": "Задать вопросы и регистрировать проблемы. ", "plc": "plc", "reports.done": "Готово", "reports.file_type.csv": "CSV", "reports.file_type.pdf": "PDF", "reports.generating": "Генерирование", "reports.pending": "Задержана", "reports.report_type.incoming": "Входящие звонки", "reports.report_type.outgoing": "Исходящие звонки", "service.draft": "Подготовка к установке", "service.in_progress": "Работает", "service.temporary_lock": "На данный момент вы не можете изменить настройки услуги", "su 21% PVM": "c 21% НДС", "užsisakyti naują internetinį vardą (vardų zoną) su galūnėmis: .lt, .lv, .com, .net, .org;": "Заказать новое доменное имя в доменных зонах: .lt, .lv, .com, .net, .org.", "užsisakyti naują virtualų serverį;": "заказать новый виртуальный сервер;", "vds.os.openvz_debian_32": "Linux Debian OS 32bit", "vds.os.openvz_debian_64": "Linux Debian OS 64bit", "Į planą": "Į planą", "Įeinantys": "Входящие", "Įmonės kodas": "Код предприятии", "Įmonės pavadinimas": "Название компании", "Įsigyti": "Kупить", "Įvykiai": "События", "Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.": "Была ошибка! Пожалуйста, обратитесь к администратору системы.", "Įvyko klaida, mėginkite dar kartą": "Произошла ошибка, пробуйте еще раз", "įjungti / išjungti apsaugą nuo virusų ar šiukšlių (angl. spam);": "Включить или выключить защиту от вирусов и мусора (spam).", "Š": "Cуб", "Ši DNS zona neaptarnaujama mūsų serveriuose. Kreipkitės į DNS zoną aptarnaujantį tiekėją.": "Нет такой DNS зоны на наших серверах, пожалуйста обратитесь к поставщику зоны DNS.", "Ši VoIP išklotinė yra mokama. Išklotinės kaina yra 4,34 EUR. Ar norite tęsti?": "Этот отчет является платный. Цена отчета 4,34 евро. Вы уверены, что хотите создать отчет?", "Ši {{item.number}} sąskaita apmokėta. Mokėjimas bus įskaitytas per kelias darbo dienas. Ačiū.": "Эта фактура {{item.number}} уже оплачена. Оплата будет подтверждена в течение нескольких рабочих дней. Благодарим Вас за оплату.", "Šiandien": "Сегодня", "Šis laukas yra privalomas.": "Это поле является обязательным.", "Šis vartotojas neturi el. parašo": "Этот пользователь не имеет электронной подписи", "Šiuo metu paslauga atnaujinama. Luktelėkite...": "Пожалуйста, подождите ...", "ŪB": "ŪB", "ŽŪB": "ŽŪB", "ŽŪK": "ŽŪK", "„Smart-ID“": "Smart- ID" });
    /* jshint +W100 */
}]);

},{}],2:[function(require,module,exports){
'use strict';

require('./root');
require('./selfcare');
require('./po');

},{"./po":3,"./root":4,"./selfcare":32}],3:[function(require,module,exports){
//require('./translate');
'use strict';

require('../../../po/translate');

},{"../../../po/translate":1}],4:[function(require,module,exports){
'use strict';

angular.module('selfcare', ['ngRoute', 'ngNamedRoute', 'ngCookies', 'ngSanitize', 'ui.select', 'ui.bootstrap', 'ui.slider', 'ngTable', 'angular-modelizer', 'gettext', 'blockUI', 'tandibar/ng-rollbar', 'ui.slider', 'daterangepicker', 'ui-select-infinity', 'igCharLimit', 'angular-confirm', 'vcRecaptcha', 'mgo-angular-wizard', 'tmh.dynamicLocale', 'nvd3', 'cp.ngConfirm']);

angular.module('selfcare').config(["$routeProvider", "$locationProvider", "$httpProvider", "tmhDynamicLocaleProvider", "blockUIConfig", function ($routeProvider, $locationProvider, $httpProvider, tmhDynamicLocaleProvider, blockUIConfig) {
    //location configuration
    $locationProvider.html5Mode(true);

    //route configuration
    $routeProvider.otherwise({
        redirectTo: '/'
    });

    //append interceptors
    $httpProvider.interceptors.push('noConnectionInterceptor');
    $httpProvider.interceptors.push('authenticationRequiredInterceptor');

    //http default configuration
    $httpProvider.defaults.cache = false;
    $httpProvider.defaults.xsrfCookieName = 'csrftoken';
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

    //block ui configuration
    blockUIConfig.templateUrl = 'selfcare/templates/page/loading.html';
    blockUIConfig.autoBlock = false;
    blockUIConfig.delay = 0;

    tmhDynamicLocaleProvider.localeLocationPattern(STATIC_FILES_URL + 'bower_components/angular-i18n/angular-locale_{{locale}}.js');
}]);

angular.module('selfcare').run(["$rootScope", "$location", "namedRouteService", "$route", "$cookies", "helpers", "bnLanguage", "externalLinkResolver", "calendarTranslations", function ($rootScope, $location, namedRouteService, $route, $cookies, helpers, bnLanguage, externalLinkResolver, calendarTranslations) {

    //login handling
    $rootScope.$next_location = null;

    function onlyPath(location) {
        if (helpers.strings.isBlank(location)) {
            return null;
        }
        return location === '/' ? location : location.substring(0, location.indexOf('?'));
    }

    $rootScope.redirectToLogin = function () {
        $rootScope.$next_location = onlyPath($location.url());
        namedRouteService.open('login');
        $rootScope.$broadcast('djangoAuth.logged_out');
    };
    $rootScope.restoreNextLocation = function (isUrlChange) {
        if (isUrlChange === null || isUrlChange === undefined) {
            isUrlChange = true;
        }
        var goToLocation = $rootScope.$next_location;
        if (helpers.objects.isEmpty(goToLocation) || onlyPath(goToLocation) === '/') {
            goToLocation = namedRouteService.reverse('invoices');
        }
        if (isUrlChange) {
            $location.url(goToLocation);
        } else {
            $location.path(goToLocation);
        }
    };
    $rootScope.redirectToShutdownPage = function () {
        namedRouteService.open('shutdown');
    };

    //helper classes binding
    $rootScope.helpers = helpers;

    //language selection
    $rootScope.bnLang = bnLanguage;
    $rootScope.bnLang.init();

    $rootScope.calendarNow = helpers.dates.nowAsStr();
    $rootScope.calendarBeforeMonth = helpers.dates.getMonthBeforeAsStr();
    $rootScope.calendarBeforeSevenMonth = helpers.dates.getSevenMonthBeforeAsStr();
    $rootScope.calendarBeforeYear = helpers.dates.getYearBeforeAsStr();
    $rootScope.calendarBeforeHalfYear = helpers.dates.getHalfYearBeforeAsStr();

    $rootScope.defaultDateTimeFormat = "yyyy-MM-dd HH:mm:ss";
    $rootScope.defaultDateFormat = "yyyy-MM-dd";
    $rootScope.recaptchaSiteKey = GOOGLE_RECAPTCHA_SITE_KEY;
    $rootScope.testingModeIsOn = TESTING_MODE_IS_ON;

    // external link resolver
    $rootScope.externalLinkResolver = externalLinkResolver;
    //calendar translations
    $rootScope.calendarTranslations = calendarTranslations;
}]);

},{}],5:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('API_PATHS', {
    ADDRESS_PATHS: {
        ADDRESS_API: 'suggest/api/address/'
    },
    INVOICE_PATHS: {
        INVOICE_API: 'invoices/api/invoices/',
        INVOICE_DOWNLOAD: 'invoices/invoices/download/'
    },
    REPORT_PATHS: {
        REPORT_DOWNLOAD: 'reports/reports/download/',
        ORDERED_REPORT_DOWNLOAD: 'reports/reports/ordered-download/',
        VOIP_API: 'reports/api/voip-reports',
        VOIP_DETAIL_API: 'reports/api/voip-reports/detail'
    },
    PRODUCT_PATHS: {
        PRODUCT_API: 'eshop/api/products/',
        DA_SERVERS_API: 'eshop/api/da-servers/',
        CHECK_DOMAIN_API: 'eshop/api/check-domain/'
    },
    TICKET_PATHS: {
        TICKET_API: 'tickets/api/tickets/',
        TICKET_DETAIL_API: 'tickets/api/tickets/detail/',
        TICKET_MESSAGE_API: 'tickets/api/tickets/message/'
    },
    SERVICE_PATHS: {
        SERVICE_API: 'services/api/services/',
        SERVICE_RESOURCE_POOL_API: 'services/api/rp-services/',
        SERVICE_VIRTUAL_DEDICATED_SERVER_API: 'services/api/vds-services/',
        SERVICE_DNS_ZONE_API: 'services/api/dns-zone/',
        SERVICE_DNS_ZONE_RECORD_API: 'services/api/dns-zone-records/',
        SERVICE_DNS_ZONE_TTL_API: 'services/api/dns-zone-ttl/',
        SERVICE_DNS_ZONE_TYPES_API: 'services/api/dns-zone-types/',
        GRAPH_API: 'services/api/graph/'
    },
    CONTRACT_PATHS: {
        CONTRACT_API: 'contracts/api/contracts/',
        CONTRACT_DOWNLOAD: 'contracts/contracts/download/',
        CONTRACT_METADATA: 'contracts/contracts/metadata/'

    }
});

},{}],6:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('EXTERNAL_LINKS', {
    DEFAULT: 'http://www.balt.net/',
    AGREEMENT: {
        lt: 'http://www.balt.net/sutartys/',
        ru: 'http://www.balt.net/dogovory/',
        en: 'http://www.balt.net/service-contracts/'
    },
    ABOUT: {
        lt: 'http://www.balt.net/apie-mus/apie-mus/',
        ru: 'http://www.balt.net/o-kompanii/pochemu-baltneta/',
        en: 'http://www.balt.net/about/about-us/'
    },
    CONTACTS: {
        lt: 'http://www.balt.net/kontaktai/',
        ru: 'http://www.balt.net/kontakty/',
        en: 'http://www.balt.net/contacts/'
    }
});

},{}],7:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('FILE_TYPES', {
    PDF: 'pdf',
    CSV: 'csv'
});

},{}],8:[function(require,module,exports){
'use strict';

require('./api-paths');
require('./product-attributes');
require('./product-types');
require('./product-categories');
require('./service-states');
require('./service-operations');
require('./product-list-types');
require('./paysera-languages');
require('./validation-patterns');
require('./pagination-counter');
require('./ticket-states');
require('./ticket-categories');
require('./person-titles');
require('./external-links');
require('./payment-return-paths');
require('./wizard-steps');
require('./file-types');
require('./voip-report-types');
require('./voip-report-states');
require('./vat-constats');
require('./invoice-states');
require('./invoice-local-lock');

},{"./api-paths":5,"./external-links":6,"./file-types":7,"./invoice-local-lock":9,"./invoice-states":10,"./pagination-counter":11,"./payment-return-paths":12,"./paysera-languages":13,"./person-titles":14,"./product-attributes":15,"./product-categories":16,"./product-list-types":17,"./product-types":18,"./service-operations":19,"./service-states":20,"./ticket-categories":21,"./ticket-states":22,"./validation-patterns":23,"./vat-constats":24,"./voip-report-states":25,"./voip-report-types":26,"./wizard-steps":27}],9:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('INVOICE_LOCAL_LOCK', {
    LOCKED: 'LOCKED',
    UNLOCKED: 'UNLOCKED'
});

},{}],10:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('INVOICE_STATES', {
    PRO: 'proforma2',
    OPEN: 'open',
    PAID: 'paid'
});

},{}],11:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('PAGINATION_COUNTERS', {
    page: 1,
    count: 25
});

},{}],12:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('PAYMENT_RETURN_PATHS', {

    VDS_PAYMENT_RETURN_PATH_SUCCESS: '/service/add-virtual-dedicated-server/success',
    VDS_PAYMENT_RETURN_PATH_FAILURE: '/service/add-virtual-dedicated-server/failure',

    HOSTING_PAYMENT_RETURN_PATH_SUCCESS: '/service/add-hosting-server/success',
    HOSTING_PAYMENT_RETURN_PATH_FAILURE: '/service/add-hosting-server/failure',

    DOMAIN_PAYMENT_RETURN_PATH_SUCCESS: '/service/add-domain/success',
    DOMAIN_PAYMENT_RETURN_PATH_FAILURE: '/service/add-domain/failure',

    INVOICE_PAYMENT_RETURN_PATH_SUCCESS: '/invoices?payment_result=success',
    INVOICE_PAYMENT_RETURN_PATH_FAILURE: '/invoices?payment_result=failure'

});

},{}],13:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('PAYSERA_LANGUAGES', {
    'lt': 'LIT',
    'en': 'ENG',
    'ru': 'RUS'
});

},{}],14:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('PARTNER_SHORT_TITLES', {
    COMPANY: 6,
    PERSON: 10
});

},{}],15:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('PRODUCT_ATTRIBUTES', {
    OPEN_VZ_SERVICE: {
        CPU: 'openvz_cpu_core',
        RAM: 'openvz_ram',
        HDD: 'openvz_disc',
        IP_COUNT: 'openvz_ip_count',
        OS: 'openvz_os',
        HOST_NAME: 'openvz_hostname'
    },
    VMW_SERVICE: {
        CPU: 'vcpu_cou',
        RAM: 'vmem_size',
        HDD: 'vmw_hdd_san',
        IP_COUNT: 'vmw_ip_count',
        OS: 'vmw_os',
        INTERNET: 'vmw_datacom',
        // type specific attributes
        SSD: 'vmw_ssd',
        OPERATIONS: 'vmw_iops',
        BACKUP: 'vmw_backup'
    },
    WEB_SERVICE: {
        DOMAIN: 'da_domain',
        EMAIL: 'da_email',
        SERVER: 'da_server'
    }
});

},{}],16:[function(require,module,exports){
/*
 8504	Hosting / DA Paslaugos
 8467	Hosting / Data backup
 8462	Hosting / Domain
 8434	Hosting / E-Mail
 8435	Hosting / FTP
 8443	Hosting / Hosting
 8487	Hosting / Webzona
 8503	Resursų nuoma (IaaS) / Demo Resource Pool(VMWare)
 8491	Resursų nuoma (IaaS) / Reource Poll(VMWare)
 8501	Virtual Dedicated Server(VDS) / Demo OpenVZ(VDS)
 8500	Virtual Dedicated Server(VDS) / OpenVZ(VDS)
 */

'use strict';

angular.module('selfcare').constant('PRODUCT_CATEGORIES', {
    HOSTING_DIRECT_ADMIN: 8504,
    HOSTING_PDU_MANAGEMENT: 8470,
    HOSTING_DATA_BACKUP: 8467,
    HOSTING_DOMAIN: 8462,
    HOSTING_EMAIL: 8434,
    HOSTING_FTP: 8435,
    HOSTING_HOST: 8443,
    HOSTING_WEB_ZONE: 8487,

    IASS_DEMO_RESOURCE_POOL: 8503,
    IASS_RESOURCE_POOL: 8491,
    DEDICATED_SERVERS: 8471,

    VDS_DEMO_OPEN_VZ: 8501,
    VDS_OPEN_VZ: 8500,

    INTERNET: 8451
});

},{}],17:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('PRODUCT_LIST_TYPES', {
    VDS: 'dc-vds',
    HOSTING: 'dc-hosting',
    DOMAIN: 'dc-domain'
});

},{}],18:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('PRODUCT_TYPE', {
    OPEN_VZ_SERVICE: 'openvz_service',
    VMW_SERVICE: 'vmw_service',
    WEB_SERVICE: 'web_service',
    DOMAIN_NAME: "domain_name"
});

},{}],19:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('SERVICE_OPERATIONS', {
    EDIT: 'edit',
    LOGIN: 'login',
    GRAPH: 'graph',
    CHANGE_PASSWORD: 'changePassword'
});

},{}],20:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('SERVICE_STATES', {
    DRAFT: 'draft',
    IN_PROGRESS: 'in_progress',
    TEMPORARY_LOCK: 'temporary_lock'
});

},{}],21:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('TICKET_CATEGORIES', {
    INCIDENT: 'incident',
    CHANGE_REQUEST: 'change',
    INFORMATION_REQUEST: 'info',
    EVENTS: 'event'
});

},{}],22:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('TICKET_STATES', {
    OPEN: 'open',
    CLOSED: 'closed',
    DONE: 'done'
});

},{}],23:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('VALIDATION_PATTERNS', {
    HOST_NAME: '/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/'
});

},{}],24:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('VAT_СONSTANTS', {
    DEFAULT: 0.21
});

},{}],25:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('VOIP_REPORT_STATES', {
    DONE: 'done',
    GENERATING: 'generating',
    PENDING: 'pending'
});

},{}],26:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('VOIP_REPORT_TYPES', {
    INCOMING: 'incoming',
    OUTGOING: 'outgoing'
});

},{}],27:[function(require,module,exports){
'use strict';

angular.module('selfcare').constant('WIZARD_STEPS', {
    DOMAIN: {
        domain: { index: 0, prop: 'domain' },
        buy: { index: 1, prop: 'buy' },
        done: { index: 2, prop: 'done' }
    },
    HOSTING: {
        productList: { index: 0, prop: 'productList' },
        domain: { index: 1, prop: 'domain' },
        buy: { index: 2, prop: 'buy' },
        done: { index: 3, prop: 'done' }
    },
    VDS: {
        vds: { index: 0, prop: 'vds' },
        buy: { index: 1, prop: 'buy' },
        done: { index: 2, prop: 'done' }
    }
});

},{}],28:[function(require,module,exports){
'use strict';

require('./number-formatter');
require('./partitions');
require('./txt2html');

},{"./number-formatter":29,"./partitions":30,"./txt2html":31}],29:[function(require,module,exports){
'use strict';

angular.module('selfcare').filter('numberFormatter', ["helpers", function (helpers) {
    return function (number, places, rtz, rm) {
        if (isNaN(places) || angular.isUndefined(places)) {
            places = 2;
        }
        if (angular.isUndefined(rtz)) {
            rtz = false;
        }
        if (angular.isUndefined(rm)) {
            rm = "none";
        }
        var getNumberValue = function getNumberValue(number) {
            if (number === null || number === "") {
                return null;
            } else {
                if (angular.isString(number)) {
                    number = parseFloat(number);
                }
                return helpers.numbers.toFixedNumberRoot(number, places, rtz, rm);
            }
        };
        return getNumberValue(number);
    };
}]);

},{}],30:[function(require,module,exports){
/*
 * Angular filter to make chunks of the given array
 */

'use strict';

angular.module('selfcare').filter('partition', ["helpers", function (helpers) {
    var cache = {}; // holds old arrays for difference repeat scopes
    function simpleChunk(arr, number_of_chunks) {
        var chunks = [],
            i = 0,
            n = arr.length;
        var chunk_size = Math.ceil(n / number_of_chunks);
        while (i < n) {
            chunks.push(arr.slice(i, i += chunk_size));
        }
        return chunks;
    }

    function declarativeChunk(arr, number_of_chunks) {
        var chunks = [],
            last = 0;
        angular.forEach(number_of_chunks, function (chunck) {
            chunks.push(arr.slice(last, Math.min(chunck + last, arr.length)));
            last = last + chunck;
        });
        return chunks;
    }

    function chunk(arr, number_of_chunks) {
        if (angular.isNumber(number_of_chunks)) {
            return simpleChunk(arr, number_of_chunks);
        } else {
            return declarativeChunk(arr, helpers.arrays.strLineToInt(number_of_chunks));
        }
    }

    return function (newArr, size, scope) {
        var id = scope.$id;
        if (helpers.arrays.isEmpty(newArr)) {
            return;
        }
        if (helpers.arrays.isNotEmpty(cache[id])) {
            return cache[id];
        }
        cache[id] = chunk(newArr, size);
        return cache[id];
    };
}]);

},{}],31:[function(require,module,exports){
/*
 * Angular filter to make plaint text as HTML
 */

'use strict';

angular.module('selfcare').filter('txt2html', ["helpers", "$sce", function (helpers, $sce) {
    return function (text) {
        if (helpers.strings.isBlank(text)) {
            return '';
        }
        return helpers.txt2Parser.parse(text);
    };
}]);

},{}],32:[function(require,module,exports){
'use strict';

require('./routes');
require('./services');
require('./resources');
require('./modules');
require('./constants');
require('./filters');

},{"./constants":8,"./filters":28,"./modules":46,"./resources":74,"./routes":88,"./services":168}],33:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$provide", function ($provide) {

    $provide.decorator('datepickerDirective', ["$delegate", function ($delegate) {
        angular.forEach($delegate, function (directive) {
            var originalCompile = directive.compile;
            var originalLink = directive.link;
            if (originalCompile) {
                directive.compile = function () {
                    return function (scope) {
                        scope.$on('gettextLanguageChanged', function () {
                            scope.move(0);
                        });
                        originalLink.apply(this, arguments);
                    };
                };
            }
        });
        return $delegate;
    }]);
}]);

},{}],34:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$provide", function ($provide) {

    $provide.decorator('dateRangePickerDirective', ["$delegate", "calendarTranslations", "$rootScope", function ($delegate, calendarTranslations, $rootScope) {
        angular.forEach($delegate, function (directive) {
            var originalCompile = directive.compile;
            var originalLink = directive.link;
            if (originalCompile) {
                directive.compile = function () {
                    return function (scope) {
                        scope.$on('gettextLanguageChanged', function () {
                            scope.opts = calendarTranslations.getDateRangeOptions();
                        });
                        originalLink.apply(this, arguments);
                    };
                };
            }
        });
        return $delegate;
    }]);
}]);

},{}],35:[function(require,module,exports){
'use strict';

require('./datepicker-directive-extension');
require('./daterangepicker-directive-extension');

},{"./datepicker-directive-extension":33,"./daterangepicker-directive-extension":34}],36:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('dynaTemplate', ["$templateCache", "$parse", "$compile", "$timeout", function ($templateCache, $parse, $compile, $timeout) {
    function getTemplate(templateId) {
        return $templateCache.get(templateId);
    }
    return {
        restrict: 'EA',
        scope: {
            'template': '=dynaTemplate',
            'item': '=dynaItem',
            'enabled': '=dynaEnabled'
        },
        link: function link(scope, element, attrs) {
            var dynaTemplate = scope.template;
            var templateElement = angular.element($compile(getTemplate(dynaTemplate))(scope));
            function addDynaTemplate() {
                if (scope.enabled) {
                    element.after(templateElement);
                }
            }
            $timeout(function () {
                addDynaTemplate();
            }, 0);
        }
    };
}]);

},{}],37:[function(require,module,exports){
'use strict';

require('./dyna-template');

},{"./dyna-template":36}],38:[function(require,module,exports){
'use strict';

angular.module('selfcare').run(["$rootScope", "$window", "namedRouteService", "helpers", function ($rootScope, $window, namedRouteService, helpers) {

    function handleError404(current, previous) {
        //remember the last good route
        if (helpers.objects.isNotEmpty(previous)) {
            $window.history.pushState(previous.params, '', helpers.routes.interpolatePath(previous.$$route.originalPath, previous.params));
        }
        namedRouteService.open(current.$$route.error404);
    }

    $rootScope.$on('$routeChangeError', function (ev, current, previous, rejection) {
        if (rejection.status === 404 && current.$$route.error404) {
            handleError404(current, previous);
        }
    });
}]);

},{}],39:[function(require,module,exports){
"use strict";

angular.module('selfcare').factory("flash", ["$rootScope", "djangoServerUtils", function ($rootScope, djangoServerUtils) {
    var currentMessage = null,
        msgQueue = [];

    $rootScope.$on("$routeChangeSuccess", function () {
        currentMessage = msgQueue.shift() || null;
    });

    //function getMsg(){
    //    return currentMessage || msgQueue.shift() || null;
    //}

    function setMsg(message, queue) {
        if (queue) {
            msgQueue.push(message);
        } else {
            currentMessage = message;
        }
    }

    return {
        clear: function clear() {
            currentMessage = null;
        },
        error: function error(message, queue) {
            setMsg({
                level: 'danger',
                message: message
            }, queue);
        },
        success: function success(message, queue) {
            setMsg({
                level: 'success',
                message: message
            }, queue);
        },
        info: function info(message, queue) {
            setMsg({
                level: 'info',
                message: message
            }, queue);
        },
        server: function server(data, queue, traverse) {
            var self = this;
            var serverMessages = djangoServerUtils.formatMessages(data);
            angular.forEach(serverMessages.globalMessages, function (globalMessage) {
                self.error(globalMessage, queue);
            });
            return serverMessages.validationErrors;
        },
        getMessage: function getMessage() {
            return currentMessage;
        }
    };
}]).directive('flash', ["flash", function (flash) {
    return {
        templateUrl: 'selfcare/modules/flash/flash.html',
        restrict: 'E',
        replace: true,
        scope: true,
        link: function link($scope) {
            $scope.$watch(flash.getMessage, function () {
                $scope.message = flash.getMessage();
            });
            //remove message
            $scope.removeMessage = function () {
                flash.clear();
            };
        }
    };
}]);

},{}],40:[function(require,module,exports){
'use strict';

require('./flash');

},{"./flash":39}],41:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('blurMe', ["$timeout", function ($timeout) {
    return {
        restrict: 'A', /* optional */
        link: function link(scope, el, attrs) {
            el.bind('click', function () {
                el.blur();
            });
        }
    };
}]);

},{}],42:[function(require,module,exports){
'use strict';

require('./poster');
require('./blur-me');

},{"./blur-me":41,"./poster":43}],43:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('poster', ["$rootScope", "$document", function ($rootScope, $document) {

    //This poster is useful only for _self target form submissions,
    //otherwise the popup blocker should do his dirty job

    var self = this;
    var bodyElement = $document.find('body').eq(0);

    this.addForm = function (data, action, target) {

        if (!target) {
            target = '_self';
        }

        var form = angular.element('<form/></form>');
        form.attr('action', action);
        form.attr('method', 'POST');
        form.attr('target', target);
        form.attr('style', 'display:none;');
        this.addFormFields(form, data);

        bodyElement.append(form);

        return form;
    };

    this.addFormFields = function (form, data) {
        angular.forEach(data, function (value, name) {
            self.addFormField(form, name, value);
        });
    };

    this.addFormField = function (form, name, value) {
        form.append(this.makeFormField(name, value));
    };

    this.makeFormField = function (name, value) {
        var inputElement = angular.element('<input></input>');
        inputElement.attr('type', 'hidden');
        inputElement.attr('name', name);
        inputElement.attr('value', value);
        return inputElement;
    };

    this.submit = function (form) {
        form.submit();
        form.remove();
    };

    this.postForm = function (data) {
        var form = this.addForm(data.fields, data.action, data.target);
        this.submit(form);
    };
}]);

},{}],44:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('includeReplace', function () {
    return {
        require: 'ngInclude',
        restrict: 'A', /* optional */
        link: function link(scope, el, attrs) {
            el.replaceWith(el.children());
        }
    };
});

},{}],45:[function(require,module,exports){
'use strict';

require('./include');

},{"./include":44}],46:[function(require,module,exports){
'use strict';

require('./slider-extension');
require('./flash');
require('./payment');
require('./include');
require('./form');
require('./modelize');
require('./service');
require('./validation');
require('./dynamic');
require('./translation');
require('./calendars');
require('./error-routing');

},{"./calendars":35,"./dynamic":37,"./error-routing":38,"./flash":40,"./form":42,"./include":45,"./modelize":47,"./payment":51,"./service":57,"./slider-extension":66,"./translation":68,"./validation":70}],47:[function(require,module,exports){
'use strict';

require('./modelize-extension');

},{"./modelize-extension":48}],48:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('modelizeExtension', ["$q", "gettextCatalog", function ($q, gettextCatalog) {

    var QUERY_WITH_PAGES = function queryWithPages(queryParams, options) {

        options = options || {};
        options.params = queryParams || {};
        if (options.updateRemoteState !== false) options.updateRemoteState = true;

        var _this = this,
            url = options.url || this.baseUrl,
            fullResponse = !!options.fullResponse,
            rawData = !!options.rawData;

        if (!url) {
            throw new Error(gettextCatalog.getString('URL error: "baseUrl" should be defined or "options.url" specified to "query" a resource'));
        }

        var _future = rawData ? [] : _this.$newCollection([], options);
        var promise = this.$request.get(url, angular.extend({}, options, { fullResponse: true })).then(function (res) {
            if (rawData) {
                Array.prototype.push.apply(_future, res.data.list);
            } else {
                _future.reset(res.data.list, options);
            }
            _future.total = res.data.total;
            if (angular.isFunction(options.onSuccess)) {
                options.onSuccess.call(_this, res);
            }

            return fullResponse ? res : _future;
        }, function (res) {
            if (angular.isFunction(options.onError)) {
                options.onError.call(_this, res);
            }
            return $q.reject(res);
        });

        if (_future._loadingTracker) {
            _future._loadingTracker.addPromise(promise);
        }

        promise.$future = _future;

        return promise;
    };

    function addStaticMethod(model, fncName, fnc) {
        if (!model.hasOwnProperty('static')) {
            model['static'] = {};
        }
        model['static'][fncName] = fnc;
        return model;
    }

    this.definePagedQuery = function (model) {
        return addStaticMethod(model, 'queryWithPages', QUERY_WITH_PAGES);
    };
}]);

},{}],49:[function(require,module,exports){
'use strict';

var CART_STORAGE_ID = 'cart-storage';

angular.module('selfcare').provider('$cart', function () {
    this.$get = function () {};
}).run(["$rootScope", "cart", "cartItem", "cartStore", function ($rootScope, cart, cartItem, cartStore) {

    $rootScope.$on('cart:change', function () {
        cart.$save();
    });

    if (cartStore.isAvailable(CART_STORAGE_ID)) {
        cart.$restore(cartStore.get(CART_STORAGE_ID));
    } else {
        cart.init();
    }
}]).service('cart', ["$rootScope", "cartItem", "cartStore", function ($rootScope, cartItem, cartStore) {

    this.init = function () {
        this.$cart = {
            items: []
        };
    };

    this.addItem = function (id, refId, name, price, quantity, data) {
        var inCart = this.getItemById(id);
        if (typeof inCart === 'object') {
            //Update quantity of an item if it's already in the cart
            inCart.setQuantity(1, true);
            $rootScope.$broadcast('cart:itemChanged', inCart);
        } else {
            var newItem = new cartItem(id, refId, name, price, quantity, data);
            this.$cart.items.push(newItem);
            $rootScope.$broadcast('cart:itemAdded', newItem);
        }
        $rootScope.$broadcast('cart:change', {});
    };

    this.getItemById = function (itemId) {
        var items = this.getCart().items;
        var build = false;
        angular.forEach(items, function (item) {
            if (item.getId() === itemId) {
                build = item;
            }
        });
        return build;
    };

    this.setCart = function (cart) {
        this.$cart = cart;
        return this.getCart();
    };

    this.getCart = function () {
        return this.$cart;
    };

    this.getItems = function () {
        return this.getCart().items;
    };

    this.getTotalItems = function () {
        var count = 0;
        var items = this.getItems();
        angular.forEach(items, function (item) {
            count += item.getQuantity();
        });
        return count;
    };

    this.getTotalUniqueItems = function () {
        return this.getCart().items.length;
    };

    this.getTotalCost = function () {
        var total = 0;
        var items = this.getItems();
        angular.forEach(items, function (item) {
            total += item.getTotal();
        });
        return +parseFloat(total).toFixed(2);
    };

    this.removeItem = function (index) {
        var removedItems = this.$cart.items.splice(index, 1);
        $rootScope.$broadcast('cart:itemRemoved', removedItems[0]);
        $rootScope.$broadcast('cart:change', {});
    };

    this.removeItemById = function (id) {
        var cart = this.getCart(),
            removedItems = null;
        angular.forEach(cart.items, function (item, index) {
            if (item.getId() === id) {
                removedItems = cart.items.splice(index, 1);
            }
        });
        this.setCart(cart);
        $rootScope.$broadcast('cart:itemRemoved', removedItems[0]);
        $rootScope.$broadcast('cart:change', {});
    };

    this.empty = function () {
        $rootScope.$broadcast('cart:change', {});
        this.$cart.items = [];
        cartStore.destroy(CART_STORAGE_ID);
    };

    this.toObject = function () {

        if (this.getItems().length === 0) {
            return false;
        }

        var items = [];
        angular.forEach(this.getItems(), function (item) {
            items.push(item.toObject());
        });

        return {
            totalCost: this.getTotalCost(),
            items: items
        };
    };

    this.$restore = function (storedCart) {
        var _self = this;
        _self.init();

        angular.forEach(storedCart.items, function (item) {
            _self.$cart.items.push(new cartItem(item._id, item._ref_id, item._name, item._price, item._quantity, item._data));
        });
        this.$save();
    };

    this.$save = function () {
        return cartStore.set(CART_STORAGE_ID, JSON.stringify(this.getCart()));
    };
}]).factory('cartItem', ["$rootScope", function ($rootScope) {

    var Item = function Item(id, refId, name, price, quantity, data) {
        this.setId(id);
        this.setRefId(refId);
        this.setName(name);
        this.setPrice(price);
        this.setQuantity(quantity);
        this.setData(data);
    };

    Item.prototype.setId = function (id) {
        if (id) {
            this._id = id;
        }
    };
    Item.prototype.getId = function () {
        return this._id;
    };

    Item.prototype.setRefId = function (ref_id) {
        if (ref_id) {
            this._ref_id = ref_id;
        }
    };
    Item.prototype.getRefId = function () {
        return this._ref_id;
    };

    Item.prototype.setName = function (name) {
        if (name) {
            this._name = name;
        }
    };
    Item.prototype.getName = function () {
        return this._name;
    };

    Item.prototype.setPrice = function (price) {
        var priceFloat = parseFloat(price);
        if (priceFloat && priceFloat >= 0) {
            this._price = priceFloat;
        }
    };
    Item.prototype.getPrice = function () {
        return this._price;
    };

    Item.prototype.setQuantity = function (quantity, relative) {
        var quantityInt = parseInt(quantity);
        if (quantityInt % 1 === 0) {
            if (relative === true) {
                this._quantity += quantityInt;
            } else {
                this._quantity = quantityInt;
            }
            if (this._quantity < 1) {
                this._quantity = 1;
            }
        } else {
            this._quantity = 1;
        }
        $rootScope.$broadcast('cart:change', {});
    };
    Item.prototype.getQuantity = function () {
        return this._quantity;
    };

    Item.prototype.setData = function (data) {
        if (data) {
            this._data = data;
        }
    };
    Item.prototype.getData = function () {
        if (this._data) {
            return JSON.parse(this._data);
        }
    };

    Item.prototype.setDataValue = function (key, value) {
        if (this._data) {
            this._data[key] = value;
            $rootScope.$broadcast('cart:change', {});
        }
    };

    Item.prototype.extendDataValue = function (data) {
        if (this._data) {
            this._data = angular.extend({}, this._data, data);
            $rootScope.$broadcast('cart:change', {});
        }
    };

    Item.prototype.getTotal = function () {
        return +parseFloat(this.getQuantity() * this.getPrice()).toFixed(2);
    };

    Item.prototype.toObject = function () {
        return {
            id: this.getId(),
            refId: this.getRefId(),
            name: this.getName(),
            price: this.getPrice(),
            quantity: this.getQuantity(),
            total: this.getTotal(),
            data: this.getData()
        };
    };

    return Item;
}]).service('cartStore', ["$cookieStore", "helpers", function ($cookieStore, helpers) {

    return {
        get: function get(key) {
            var storage = $cookieStore.get(key);
            if (storage) {
                var cart = angular.fromJson(storage);
                return JSON.parse(cart);
            }
            return false;
        },
        set: function set(key, val) {
            if (val === undefined) {
                $cookieStore.remove(key);
            } else {
                $cookieStore.put(key, angular.toJson(val));
            }
            return $cookieStore.get(key);
        },
        isAvailable: function isAvailable(key) {
            return helpers.objects.isNotEmpty($cookieStore.get(key));
        },
        destroy: function destroy(key) {
            $cookieStore.remove(key);
        }
    };
}]).controller('CartController', ["$scope", "cart", function ($scope, cart) {
    $scope.cart = cart;
}]).directive('addToCart', ["cart", function (cart) {
    return {
        restrict: 'EA',
        controller: 'CartController',
        controllerAs: 'cartCtrl',
        scope: {
            id: '@',
            refId: '@',
            name: '@',
            quantity: '@',
            quantityMax: '@',
            price: '@',
            data: '@'
        },
        templateUrl: 'selfcare/modules/payment/cart/add-to-cart.html',
        link: function link(scope, element, attrs) {
            scope.attrs = attrs;

            scope.inCart = function () {
                return cart.getItemById(attrs.id);
            };

            if (scope.inCart()) {
                scope.q = cart.getItemById(attrs.id).getQuantity();
            } else {
                scope.q = parseInt(scope.quantity);
            }

            scope.qtyOpt = [];
            for (var i = 1; i <= scope.quantityMax;) {
                scope.qtyOpt.push(i);
                i = i + 1;
            }
        }

    };
}]).directive('cartSummary', function () {
    return {
        restrict: 'EA',
        controller: 'CartController',
        controllerAs: 'cartCtrl',
        scope: true,
        templateUrl: 'selfcare/modules/payment/cart/cart-summary.html',
        link: function link(scope, element, attrs) {}
    };
}).directive('cartTable', function () {
    return {
        restrict: 'EA',
        controller: 'CartController',
        controllerAs: 'cartCtrl',
        scope: true,
        templateUrl: 'selfcare/modules/payment/cart/cart-table.html',
        link: function link(scope, element, attrs) {}
    };
}).directive('checkOut', ["$parse", "cart", function ($parse, cart) {
    return {
        restrict: 'EA',
        controller: 'CartController',
        controllerAs: 'cartCtrl',
        templateUrl: 'selfcare/modules/payment/cart/check-out.html',
        link: function link(scope, element, attrs, ctrl) {

            var onCheckCallback = $parse(attrs.onCheck);
            element.bind('click', function (event) {
                if (onCheckCallback) {
                    onCheckCallback(scope, {
                        $cart: cart.toObject()
                    });
                }
            });
        }
    };
}]);

},{}],50:[function(require,module,exports){
'use strict';

require('./cart');

},{"./cart":49}],51:[function(require,module,exports){
'use strict';

require('./cart');
require('./payment-table');

},{"./cart":50,"./payment-table":52}],52:[function(require,module,exports){
'use strict';

require('./payment-table');

},{"./payment-table":53}],53:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('paymentTable', ["$templateCache", "$parse", "blockUIWrapper", "paymentService", "flash", "poster", "gettextCatalog", function ($templateCache, $parse, blockUIWrapper, paymentService, flash, poster, gettextCatalog) {
    return {
        restrict: 'EA',
        scope: {
            'payment': '=',
            'buttonLabel': '='
        },
        templateUrl: 'selfcare/modules/payment/payment-table/payment-table.html',
        link: function link(scope, element, attrs) {
            var onPostPaid = $parse(attrs.onPostPaid),
                onPrePaid = $parse(attrs.onPrePaid);

            scope.buy = function (provider) {

                var serviceCreatePromise = blockUIWrapper.wrap(paymentService.createPayment(scope.payment, provider));

                serviceCreatePromise.then(function (data) {
                    var service_post_data = data.service_post_data;
                    if (service_post_data.pre_paid) {

                        var buyServicePromise = blockUIWrapper.wrap(paymentService.executePayment(service_post_data.payment_id));

                        buyServicePromise.then(function (data) {

                            if (onPrePaid) {
                                onPrePaid(scope.$parent, {
                                    $payment: scope.payment,
                                    $service: service_post_data
                                });
                            }

                            flash.info(gettextCatalog.getString('Inicijuojamas mokėjimas. Luktelėkite...'));
                            if (data.provider === 'PAYSERA') {
                                poster.postForm(data.payment_post_data);
                            } else if (data.provider === 'PAYPAL') {
                                window.location.href = data.payment_post_data;
                            }
                        }, function (response) {
                            flash.server(response.data);
                        });
                    } else {

                        if (onPostPaid) {
                            onPostPaid(scope.$parent, {
                                $payment: scope.payment
                            });
                        }
                    }
                }, function (response) {
                    flash.server(response.data);
                });
            };
        }
    };
}]);

},{}],54:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('hostingGridCell', ["$parse", "$timeout", "helpers", "bnLanguage", "validate", "VALIDATION_PATTERNS", function ($parse, $timeout, helpers, bnLanguage, validate, VALIDATION_PATTERNS) {
    return {
        restrict: 'EA',
        scope: {
            product: '=',
            buttonLabel: '=',
            servers: '=',
            mode: '='
        },
        templateUrl: 'selfcare/modules/service/hosting-grid/hosting-grid-cell.html',
        link: function link(scope, element, attrs) {

            scope.helpers = helpers;
            scope.bnLang = bnLanguage;

            scope.errors = null;

            scope.formatServerName = function (server) {
                return [server.server_name, '>', server.server_ip, '>', server.software_versions].join(' ');
            };

            scope.choose = function (product, productForm) {
                scope.errors = {};
                validate.formValidation(productForm, scope.errors);
                if (!productForm.$invalid) {
                    scope.$emit('hosting-grid:selected', product);
                }
            };

            scope.getTemplateHtml = function (product) {
                return bnLanguage.modelTranslation(product, 'template');
            };
        }
    };
}]);

},{}],55:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('hostingGrid', ["$parse", function ($parse) {
    return {
        restrict: 'EA',
        scope: {
            hostingData: '=',
            buttonLabel: '=',
            mode: '='
        },
        templateUrl: 'selfcare/modules/service/hosting-grid/hosting-grid.html',
        link: function link(scope, element, attrs) {
            var onSelect = $parse(attrs.onSelect);

            scope.$on('hosting-grid:selected', function (event, product) {
                if (onSelect) {
                    onSelect(scope.$parent, {
                        $product: product
                    });
                }
            });
        }
    };
}]);

},{}],56:[function(require,module,exports){
'use strict';

require('./hosting-grid');
require('./hosting-grid-cell');

},{"./hosting-grid":55,"./hosting-grid-cell":54}],57:[function(require,module,exports){
'use strict';

require('./service-units-helpers');
require('./units');
require('./plans-table');
require('./plans-grid');
require('./hosting-grid');

},{"./hosting-grid":56,"./plans-grid":58,"./plans-table":61,"./service-units-helpers":63,"./units":64}],58:[function(require,module,exports){
'use strict';

require('./plans-grid');
require('./plans-grid-cell');

},{"./plans-grid":60,"./plans-grid-cell":59}],59:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('plansGridCell', ["$parse", "$timeout", "helpers", "bnLanguage", "validate", "VALIDATION_PATTERNS", function ($parse, $timeout, helpers, bnLanguage, validate, VALIDATION_PATTERNS) {
    return {
        restrict: 'EA',
        scope: {
            product: '=',
            buttonLabel: '=',
            mode: '='
        },
        templateUrl: 'selfcare/modules/service/plans-grid/plans-grid-cell.html',
        link: function link(scope, element, attrs) {
            scope.helpers = helpers;
            scope.bnLang = bnLanguage;

            scope.errors = null;
            scope.hostnamePattern = VALIDATION_PATTERNS.HOST_NAME;

            scope.choose = function (product, productForm) {
                scope.errors = {};
                validate.formValidation(productForm, scope.errors);
                if (!productForm.$invalid) {
                    scope.$emit('plans-grid:selected', product);
                }
            };
        }
    };
}]);

},{}],60:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('plansGrid', ["$parse", function ($parse) {
    return {
        restrict: 'EA',
        scope: {
            products: '=',
            buttonLabel: '=',
            mode: '='
        },
        templateUrl: 'selfcare/modules/service/plans-grid/plans-grid.html',
        link: function link(scope, element, attrs) {
            var onSelect = $parse(attrs.onSelect);

            scope.$on('plans-grid:selected', function (event, product) {
                if (onSelect) {
                    onSelect(scope.$parent, {
                        $product: product
                    });
                }
            });
        }
    };
}]);

},{}],61:[function(require,module,exports){
'use strict';

require('./plans-table');

},{"./plans-table":62}],62:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('plansTable', ["$parse", "$timeout", "helpers", "bnLanguage", "validate", "VALIDATION_PATTERNS", function ($parse, $timeout, helpers, bnLanguage, validate, VALIDATION_PATTERNS) {
    return {
        restrict: 'EA',
        scope: {
            products: '=',
            buttonLabel: '=',
            mode: '='
        },
        templateUrl: 'selfcare/modules/service/plans-table/plans-table.html',
        link: function link(scope, element, attrs) {
            scope.helpers = helpers;
            scope.bnLang = bnLanguage;

            scope.errors = {};
            scope.hostnamePattern = VALIDATION_PATTERNS.HOST_NAME;

            var onSelectCallback = $parse(attrs.onSelect);

            scope.choose = function (product, that) {
                // form is bound to the itteration scope :(
                var productForm = that['productForm_' + product.id];

                scope.errors[product.id] = [];
                validate.formValidation(productForm, scope.errors[product.id]);
                if (!productForm.$invalid) {
                    if (onSelectCallback) {
                        onSelectCallback(scope.$parent, {
                            $product: product
                        });
                    }
                } else {
                    console.error('errors', product.id, scope.errors[product.id]);
                }
            };
        }
    };
}]);

},{}],63:[function(require,module,exports){
'use strict';

var SERVICE_UNIT_SORT_FTN = function SERVICE_UNIT_SORT_FTN(firstS, secondS) {
    if (firstS.index > secondS.index) {
        return 1;
    } else if (firstS.index < secondS.index) {
        return -1;
    } else {
        return 0;
    }
};

angular.module('selfcare').service('serviceUnitsService', ["helpers", function (helpers) {

    this.applyUnitChanges = function (unit, unitChange) {
        unit.current.name = unitChange.name;
        if (unit.current.type === 'selection') {
            unit.current.value = unitChange.value;
        } else {
            unit.current.value = parseInt(unitChange.value);
        }
    };

    this.getSortedServiceUnits = function (service_units) {
        if (helpers.arrays.isEmpty(service_units)) {
            return [];
        }
        service_units.sort(SERVICE_UNIT_SORT_FTN);
        return service_units;
    };
}]);

},{}],64:[function(require,module,exports){
'use strict';

require('./service-units');

},{"./service-units":65}],65:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceUnitController', ["$scope", "helpers", "serviceUnitsService", function ($scope, helpers, serviceUnitsService) {

    function addUnitValue(attributeValue) {
        serviceUnitsService.applyUnitChanges($scope.unit, attributeValue);
        $scope.$emit('service-unit:changed', $scope.unit);
    }

    this.choose = function (attributeValue) {
        if (attributeValue) {
            addUnitValue(attributeValue);
        }
    };

    this.valuesIsEmpty = function () {
        return helpers.arrays.isEmpty($scope.unit.values);
    };

    this.valuesIsNotEmpty = function () {
        return helpers.arrays.isNotEmpty($scope.unit.values);
    };
}]).directive('serviceUnit', function () {
    return {
        restrict: 'EA',
        controller: 'ServiceUnitController',
        controllerAs: 'suCtrl',
        scope: {
            unit: '=',
            disabled: '='
        },
        templateUrl: 'selfcare/modules/service/units/service-unit.html',
        link: function link(scope, element, attrs) {}
    };
}).controller('ServiceUnitsController', ["$scope", "helpers", "serviceUnitsService", function ($scope, helpers, serviceUnitsService) {

    function appendUnitValueOfReverse(unitValue, reverse) {
        // add reverse value
        var unit = helpers.arrays.find($scope.units, 'code', reverse.code);
        if (unit) {
            var matches = helpers.arrays.filter(reverse.matches, 'match_value', String(unitValue));
            if (helpers.arrays.isNotEmpty(matches)) {
                var firstMatch = matches[0];
                var matchValues = [];
                angular.forEach(matches, function (match) {
                    if (match.match_equivalent.value) {
                        matchValues.push(match.match_equivalent.value);
                    }
                });
                if (!helpers.arrays.contains(matchValues, String(unit.current.value))) {
                    if (firstMatch && firstMatch.match_equivalent) {
                        serviceUnitsService.applyUnitChanges(unit, firstMatch.match_equivalent);
                    }
                }
            }
        }
    }

    function onUnitChanges(unit, reverses) {
        angular.forEach(reverses, function (reverse) {
            appendUnitValueOfReverse(unit.current.value, reverse);
        });
    }

    ////watch service unit change
    $scope.$on('service-unit:changed', function (event, unit) {
        if (helpers.arrays.isNotEmpty(unit.reverses)) {
            onUnitChanges(unit, unit.reverses);
        }
    });
}]).directive('serviceUnits', ["serviceUnitsService", "helpers", function (serviceUnitsService, helpers) {
    return {
        restrict: 'EA',
        controller: 'ServiceUnitsController',
        controllerAs: 'susCtrl',
        scope: {
            units: '=',
            rows: '=',
            disabled: '='
        },
        templateUrl: 'selfcare/modules/service/units/service-units.html',
        link: function link(scope, element, attrs) {
            scope.sortedUnits = [];
            scope.$watch('units', function (n, o) {
                if (helpers.arrays.isNotEmpty(n)) {
                    scope.sortedUnits = serviceUnitsService.getSortedServiceUnits(scope.units);
                }
            });
            ////watch service unit change
            scope.$on('service-units:refresh', function (event, units) {
                if (helpers.arrays.isNotEmpty(units)) {
                    scope.sortedUnits = serviceUnitsService.getSortedServiceUnits(units);
                }
            });
        }
    };
}]);

},{}],66:[function(require,module,exports){
'use strict';

require('./sliderval');

},{"./sliderval":67}],67:[function(require,module,exports){
'use strict';

var SLIDE_VALUES_SORT_FTN = function SLIDE_VALUES_SORT_FTN(firstS, secondS) {
    if (firstS.index > secondS.index) {
        return 1;
    } else if (firstS.index < secondS.index) {
        return -1;
    } else {
        return 0;
    }
};

angular.module('selfcare').directive('sliderVal', ["helpers", "$compile", function (helpers, $compile) {
    return {
        scope: {
            model: '=model',
            slider: '=slider',
            values: '=values'
        },
        transclude: true,
        templateUrl: 'selfcare/modules/slider-extension/slider-val.html',
        compile: function compile(element, attributes) {
            return function (scope, element, attrs, controllers) {

                var sliderHolder = element.find('.slider-holder');

                scope._values = scope.values || [];
                scope._values.sort(SLIDE_VALUES_SORT_FTN);
                scope.disabled = scope.disabled || false;

                var tickArray = (function () {
                    var tickArray = [];
                    angular.forEach(scope._values, function (value) {
                        tickArray.push(value.index);
                    });
                    return tickArray;
                })();

                var tickLabels = (function () {
                    var tickLabels = {};
                    angular.forEach(scope._values, function (value) {
                        tickLabels[value.index] = value.label;
                    });
                    return tickLabels;
                })();

                function localSlide(e, ui) {
                    var val = scope._values[ui.value];

                    var thisHandle = angular.element(ui.handle);
                    thisHandle.attr('aria-valuetext', val.label).attr('aria-valuenow', ui.value).find('.ui-slider-tooltip .ttContent').text(val.label);

                    return;
                }

                function modelArrayValue(val) {
                    var modelValue = {};
                    angular.forEach(scope._values, function (value, index) {
                        if (value.value === val) {
                            modelValue = {
                                value: value,
                                arrayIndex: index
                            };
                        }
                    });
                    return modelValue;
                }

                //plugin-generated slider options (can be overridden)
                var sliderOptions = {
                    step: 1,
                    orientation: 'horizontal',

                    min: 0,
                    max: scope._values.length - 1,
                    range: "min",

                    tickArray: tickArray,
                    tickLabels: tickLabels,

                    slide: function slide(e, ui) {
                        return localSlide(e, ui);
                    }

                };

                scope._slider = scope.slider ? angular.extend(sliderOptions, scope.slider) : sliderOptions;
                scope._model = scope.model ? modelArrayValue(scope.model).arrayIndex : 0;

                var slider = angular.element('<div></div>');
                slider.attr('ui-slider', '_slider');
                slider.attr('ng-model', '_model');
                slider.attr('min', scope._slider.min);
                slider.attr('max', scope._slider.max);
                slider.attr('disabled', scope.disabled);

                var sliderComp = $compile(slider)(scope);
                sliderHolder.append(sliderComp);

                scope.$watch('_model', function (n, o) {
                    var _n = n ? n : 0;
                    scope.model = scope._values[_n].value;
                });

                scope.$watch('model', function (n, o) {
                    scope._model = n ? modelArrayValue(n).arrayIndex : 0;
                });
            };
        }
    };
}]);

},{}],68:[function(require,module,exports){
'use strict';

require('./translation-attributes');

},{"./translation-attributes":69}],69:[function(require,module,exports){
'use strict';

angular.module('selfcare').directive('translatedTitle', ['gettextCatalog', function (gettextCatalog) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var translatedTitle = gettextCatalog.getString(attrs.translatedTitle);
            element.attr('title', translatedTitle);
        }
    };
}]);

},{}],70:[function(require,module,exports){
'use strict';

require('./r-pattern');

},{"./r-pattern":71}],71:[function(require,module,exports){
"use strict";

angular.module('selfcare').directive("rpattern", function () {
    return {
        restrict: "A",
        require: "ngModel",
        link: function link(scope, el, attrs, ngModel) {
            var validator,
                patternValidator,
                pattern = attrs.rpattern,
                required = true;

            if (pattern) {
                if (pattern.match(/^\/(.*)\/$/)) {
                    pattern = new RegExp(pattern.substr(1, pattern.length - 2));
                    patternValidator = function (value) {
                        return validate(pattern, value);
                    };
                } else {
                    patternValidator = function (value) {
                        var patternObj = scope.$eval(pattern);
                        if (!patternObj || !patternObj.test) {
                            throw new Error('Expected ' + pattern + ' to be a RegExp but was ' + patternObj);
                        }
                        return validate(patternObj, value);
                    };
                }
            }

            ngModel.$formatters.push(patternValidator);
            ngModel.$parsers.push(patternValidator);

            attrs.$observe("required", function (newval) {
                required = newval;
                patternValidator(ngModel.$viewValue);
            });

            function validate(regexp, value) {
                if (value === null || value === "" || !required || regexp.test(value)) {
                    ngModel.$setValidity('pattern', true);
                    return value;
                } else {
                    ngModel.$setValidity('pattern', false);
                    return;
                }
            }
        }
    };
});

},{}],72:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('AddressResource', ["modelize", "API_PATHS", function (modelize, API_PATHS) {
    return modelize.defineModel('address', {
        baseUrl: API_PATHS.ADDRESS_PATHS.ADDRESS_API
    });
}]);

},{}],73:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('ContractsResource', ["modelize", "modelizeExtension", "API_PATHS", "$browser", function (modelize, modelizeExtension, API_PATHS, $browser) {
    return modelize.defineModel('contract', modelizeExtension.definePagedQuery({
        baseUrl: API_PATHS.CONTRACT_PATHS.CONTRACT_API,

        currencyName: modelize.attr.computed(function () {
            return this.currency_id[1];
        }),
        stateLabel: modelize.attr.computed(function () {
            return 'contract.' + this.state;
        }),
        //some static methods on the model
        'static': {
            getUrl: function getUrl(contractId) {
                return window.location.origin + '/' + API_PATHS.CONTRACT_PATHS.CONTRACT_DOWNLOAD + contractId + '/';
            },
            downloadContent: function downloadContent(contractId) {
                window.open(API_PATHS.CONTRACT_PATHS.CONTRACT_DOWNLOAD + contractId + '/?download=true', '_blank');
            },
            getMetadata: function getMetadata(contractId) {
                return API_PATHS.CONTRACT_PATHS.CONTRACT_METADATA + contractId;
            }
        }

    }));
}]);

},{}],74:[function(require,module,exports){
'use strict';

require('./invoices-resource');
require('./product-resource');
require('./address-resource');
require('./services-resource');
require('./tickets-resource');
require('./reports-resource');
require('./contracts-resource');

},{"./address-resource":72,"./contracts-resource":73,"./invoices-resource":75,"./product-resource":76,"./reports-resource":77,"./services-resource":78,"./tickets-resource":79}],75:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('InvoicesResource', ["modelize", "modelizeExtension", "API_PATHS", function (modelize, modelizeExtension, API_PATHS) {
    return modelize.defineModel('invoice', modelizeExtension.definePagedQuery({
        baseUrl: API_PATHS.INVOICE_PATHS.INVOICE_API,

        currencyName: modelize.attr.computed(function () {
            return this.currency_id[1];
        }),
        stateLabel: modelize.attr.computed(function () {
            return 'invoice.' + this.state;
        }),
        //some static methods on the model
        'static': {
            openContent: function openContent(invoiceId) {
                window.open(API_PATHS.INVOICE_PATHS.INVOICE_DOWNLOAD + invoiceId + '/', '_blank');
            },
            downloadContent: function downloadContent(invoiceId) {
                window.open(API_PATHS.INVOICE_PATHS.INVOICE_DOWNLOAD + invoiceId + '/?download=true', '_blank');
            }
        }

    }));
}]);

},{}],76:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('ProductResource', ["modelize", "productHelpers", "PRODUCT_TYPE", "PRODUCT_ATTRIBUTES", "API_PATHS", function (modelize, productHelpers, PRODUCT_TYPE, PRODUCT_ATTRIBUTES, API_PATHS) {

    return modelize.defineModel('product', {

        baseUrl: API_PATHS.PRODUCT_PATHS.PRODUCT_API,

        //is type of
        rp: modelize.attr.computed(function () {
            return this.unit_type === PRODUCT_TYPE.VMW_SERVICE;
        }),
        vds: modelize.attr.computed(function () {
            return this.unit_type === PRODUCT_TYPE.OPEN_VZ_SERVICE;
        }),

        //common attributes for the product
        cpu: modelize.attr.computed(function () {
            if (this.vds) {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.OPEN_VZ_SERVICE.CPU);
            } else {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.VMW_SERVICE.CPU);
            }
        }),
        ram: modelize.attr.computed(function () {
            if (this.vds) {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.OPEN_VZ_SERVICE.RAM);
            } else {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.VMW_SERVICE.RAM);
            }
        }),
        hdd: modelize.attr.computed(function () {
            if (this.vds) {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.OPEN_VZ_SERVICE.HDD);
            } else {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.VMW_SERVICE.HDD);
            }
        }),
        ip: modelize.attr.computed(function () {
            if (this.vds) {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.OPEN_VZ_SERVICE.IP_COUNT);
            } else {
                return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.VMW_SERVICE.IP_COUNT);
            }
        }),
        os: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.OPEN_VZ_SERVICE.OS);
        }),
        host: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.OPEN_VZ_SERVICE.HOST_NAME);
        }),

        // Only for resource pool services
        ssd: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.VMW_SERVICE.SSD);
        }),
        operations: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.VMW_SERVICE.OPERATIONS);
        }),
        backup: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.VMW_SERVICE.BACKUP);
        }),

        //only for hosting
        domain: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.WEB_SERVICE.DOMAIN);
        }),
        email: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.WEB_SERVICE.EMAIL);
        }),
        server: modelize.attr.computed(function () {
            return productHelpers.getValue(this.attributes, PRODUCT_ATTRIBUTES.WEB_SERVICE.SERVER);
        }),

        'static': {

            ////attribute values
            getProductValues: function getProductValues(products, unit_type) {
                return productHelpers.getProductValues(products, unit_type);
            },
            getPaymentAttributes: function getPaymentAttributes(paymentValue, unit_type) {
                return productHelpers.getPaymentAttributes(paymentValue, unit_type);
            },
            assignServiceUnitValues: function assignServiceUnitValues(paymentValue, serviceDetail) {
                return productHelpers.assignServiceUnitValues(paymentValue, serviceDetail);
            }

        }

    });
}]);

angular.module('selfcare').factory('DAServersResource', ["modelize", "API_PATHS", function (modelize, API_PATHS) {

    return modelize.defineModel('DAServer', {
        baseUrl: API_PATHS.PRODUCT_PATHS.DA_SERVERS_API
    });
}]);

},{}],77:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('ReportsResourceBase', ["modelize", "API_PATHS", function (modelize, API_PATHS) {
    return {
        stateLabel: modelize.attr.computed(function () {
            return 'reports.' + this.status;
        }),
        reportTypeName: modelize.attr.computed(function () {
            return 'reports.report_type.' + this.report_type;
        }),
        fileTypeName: modelize.attr.computed(function () {
            return 'reports.file_type.' + this.file_type;
        }),
        //some static methods on the model
        'static': {
            openContent: function openContent(report_type, reportId) {
                window.open(API_PATHS.REPORT_PATHS.ORDERED_REPORT_DOWNLOAD + report_type + '/' + reportId + '/', '_blank');
            },
            downloadContent: function downloadContent(report_type, reportId) {
                window.open(API_PATHS.REPORT_PATHS.ORDERED_REPORT_DOWNLOAD + report_type + '/' + reportId + '/?download=true', '_blank');
            }
        }
    };
}]);

angular.module('selfcare').factory('VoipReportResource', ["modelize", "ReportsResourceBase", "modelizeExtension", "API_PATHS", function (modelize, ReportsResourceBase, modelizeExtension, API_PATHS) {
    var voipReportsResource = angular.extend({}, ReportsResourceBase, {
        baseUrl: API_PATHS.REPORT_PATHS.VOIP_API
    });
    return modelize.defineModel('voipReports', modelizeExtension.definePagedQuery(voipReportsResource));
}]);

},{}],78:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('ServicesResourceBase', ["modelize", "helpers", "serviceUnitHelper", "serviceStateHelper", "serviceOperationHelper", function (modelize, helpers, serviceUnitHelper, serviceStateHelper, serviceOperationHelper) {

    return {

        //simplified names
        productName: modelize.attr.computed(function () {
            if (helpers.strings.isBlank(this.product_id[1])) {
                return this.category[1];
            }
            return this.product_id[1];
        }),
        slaLevelName: modelize.attr.computed(function () {
            return this.sla_level_id[1];
        }),
        currencyName: modelize.attr.computed(function () {
            return this.currency_id[1];
        }),
        categoryId: modelize.attr.computed(function () {
            return this.category[0];
        }),
        domainName: modelize.attr.computed(function () {
            if (this.domain === null) {
                return null;
            }
            return this.domain[1];
        }),
        domainId: modelize.attr.computed(function () {
            if (this.domain === null) {
                return null;
            }
            return this.domain[0];
        }),
        hostName: modelize.attr.computed(function () {
            return helpers.objects.getProperty(this.info, 'openvz_hostname');
        }),
        hostIp: modelize.attr.computed(function () {
            return helpers.objects.getProperty(this.info, 'openvz_ipaddress');
        }),

        //category types
        operations: modelize.attr.computed(function () {
            return serviceOperationHelper.operations(this);
        }),
        //unit logic
        unit_type: modelize.attr.computed(function () {
            return serviceUnitHelper.getConfUnitAttribute(this.conf_units[0], 'unit_type');
        }),
        editMode: modelize.attr.computed(function () {
            return serviceStateHelper.editModeStates(this);
        }),
        stateLabel: modelize.attr.computed(function () {
            return 'service.' + this.state;
        }),
        uomName: modelize.attr.computed(function () {
            return this.uom_id[1];
        })
    };
}]);

angular.module('selfcare').factory('ServicesResource', ["modelize", "modelizeExtension", "ServicesResourceBase", "API_PATHS", function (modelize, modelizeExtension, ServicesResourceBase, API_PATHS) {

    //define service
    var servicesResource = angular.extend({}, ServicesResourceBase, {
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_API
    });

    return modelize.defineModel('service', modelizeExtension.definePagedQuery(servicesResource));
}]);

angular.module('selfcare').factory('ServiceUnitServicesResourceBase', ["modelize", "ServicesResourceBase", "serviceUnitHelper", "API_PATHS", function (modelize, ServicesResourceBase, serviceUnitHelper, API_PATHS) {

    var servicesResource = angular.extend({}, ServicesResourceBase, {
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_RESOURCE_POOL_API,

        serviceCurrents: modelize.attr.computed(function () {
            return serviceUnitHelper.getCurrentServiceUnits(this.service_units);
        }),

        priceIsNotTheSame: modelize.attr.computed(function () {
            return this.price !== parseFloat(this.current_tariff);
        })

    });

    return servicesResource;
}]);

angular.module('selfcare').factory('ServicesResourcePoolResource', ["modelize", "modelizeExtension", "serviceUnitHelper", "ServiceUnitServicesResourceBase", "API_PATHS", function (modelize, modelizeExtension, serviceUnitHelper, ServiceUnitServicesResourceBase, API_PATHS) {

    //define service
    var servicesResource = angular.extend({}, ServiceUnitServicesResourceBase, {
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_RESOURCE_POOL_API,

        price: modelize.attr.computed(function () {
            return serviceUnitHelper.getResourcePoolPrice({
                priceList: this.service_unit_price_list,
                priceExtensions: this.service_unit_price_extensions,
                pricePackages: this.service_unit_package_list,
                currents: this.serviceCurrents,
                current_tariff: this.current_tariff
            });
        })

    });

    return modelize.defineModel('serviceResourcePool', modelizeExtension.definePagedQuery(servicesResource));
}]);

angular.module('selfcare').factory('ServicesVirtualDedicatedServerResource', ["modelize", "modelizeExtension", "serviceUnitHelper", "ServiceUnitServicesResourceBase", "API_PATHS", function (modelize, modelizeExtension, serviceUnitHelper, ServiceUnitServicesResourceBase, API_PATHS) {

    //define service
    var servicesResource = angular.extend({}, ServiceUnitServicesResourceBase, {
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_VIRTUAL_DEDICATED_SERVER_API,

        price: modelize.attr.computed(function () {
            return serviceUnitHelper.getVirtualDedicatedServerPrice({
                priceList: this.service_unit_price_list,
                pricePackages: this.service_unit_package_list,
                currents: this.serviceCurrents,
                current_tariff: this.current_tariff
            });
        }),

        osName: modelize.attr.computed(function () {
            return 'vds.os.' + this.conf_units[0].openvz_os;
        })

    });

    return modelize.defineModel('serviceVirtualDedicated', modelizeExtension.definePagedQuery(servicesResource));
}]);

angular.module('selfcare').factory('ServicesDNSZoneRecordResource', ["modelize", "TicketsResourceBase", "modelizeExtension", "API_PATHS", function (modelize, TicketsResourceBase, modelizeExtension, API_PATHS) {
    return modelize.defineModel('serviceDNSZoneRecord', modelizeExtension.definePagedQuery({
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_DNS_ZONE_RECORD_API
    }));
}]);

angular.module('selfcare').factory('ServicesDNSZoneResource', ["modelize", "modelizeExtension", "API_PATHS", function (modelize, modelizeExtension, API_PATHS) {

    return modelize.defineModel('serviceDNSZone', modelizeExtension.definePagedQuery({
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_DNS_ZONE_API,
        domainName: modelize.attr.computed(function () {
            if (this.domain_id === null) {
                return null;
            }
            return this.domain_id[1];
        }),
        domainId: modelize.attr.computed(function () {
            if (this.domain_id === null) {
                return null;
            }
            return this.domain_id[0];
        })
    }));
}]);

angular.module('selfcare').factory('ServicesDNSZoneTTLResource', ["modelize", "API_PATHS", function (modelize, API_PATHS) {

    return modelize.defineModel('serviceDNSZoneTTL', {
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_DNS_ZONE_TTL_API
    });
}]);

angular.module('selfcare').factory('ServicesDNSZoneTypeResource', ["modelize", "API_PATHS", function (modelize, API_PATHS) {

    return modelize.defineModel('serviceDNSZoneType', {
        baseUrl: API_PATHS.SERVICE_PATHS.SERVICE_DNS_ZONE_TYPES_API
    });
}]);

},{}],79:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('TicketsResourceBase', ["modelize", "helpers", "TICKET_STATES", function (modelize, helpers, TICKET_STATES) {
    return {
        serviceName: modelize.attr.computed(function () {
            if (helpers.objects.isEmpty(this.service)) {
                return '';
            }
            return this.service[1];
        }),
        typeName: modelize.attr.computed(function () {
            if (helpers.objects.isEmpty(this.categ1_id)) {
                return '';
            }
            return this.categ1_id[1];
        }),
        isClosed: modelize.attr.computed(function () {
            if (helpers.objects.isEmpty(this.state)) {
                return false;
            }
            return TICKET_STATES.DONE === this.state;
        }),
        isNotClosed: modelize.attr.computed(function () {
            return !this.isClosed;
        }),
        stateLabel: modelize.attr.computed(function () {
            return 'helpdesk.' + this.state;
        })
    };
}]);

angular.module('selfcare').factory('TicketsResource', ["modelize", "TicketsResourceBase", "modelizeExtension", "API_PATHS", function (modelize, TicketsResourceBase, modelizeExtension, API_PATHS) {
    var ticketsResource = angular.extend({}, TicketsResourceBase, {
        baseUrl: API_PATHS.TICKET_PATHS.TICKET_API
    });
    return modelize.defineModel('ticket', modelizeExtension.definePagedQuery(ticketsResource));
}]);

angular.module('selfcare').factory('TicketsMessageResource', ["modelize", "TicketsResourceBase", "modelizeExtension", "API_PATHS", function (modelize, TicketsResourceBase, modelizeExtension, API_PATHS) {
    return modelize.defineModel('ticketMessage', modelizeExtension.definePagedQuery({
        baseUrl: API_PATHS.TICKET_PATHS.TICKET_MESSAGE_API
    }));
}]);

angular.module('selfcare').factory('TicketsDetailResource', ["modelize", "TicketsResourceBase", "modelizeExtension", "API_PATHS", function (modelize, TicketsResourceBase, modelizeExtension, API_PATHS) {
    var ticketsResource = angular.extend({}, TicketsResourceBase, {
        baseUrl: API_PATHS.TICKET_PATHS.TICKET_DETAIL_API,
        messages: modelize.attr.collection({
            modelClass: 'ticketMessage',
            baseUrl: '/messages/'
        })
    });
    return modelize.defineModel('ticketDetail', modelizeExtension.definePagedQuery(ticketsResource));
}]);

},{}],80:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {
    $routeProvider.when('/checkout', {
        name: 'checkout',
        templateUrl: 'selfcare/routes/cart/check-out.html',
        controller: 'CheckoutController',
        controllerAs: 'ctrl'
    });
}]);

},{}],81:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('CheckoutController', ["$scope", "modelize", "poster", "flash", "paymentService", "blockUIWrapper", function ($scope, modelize, poster, flash, paymentService, blockUIWrapper) {

    this.checkout = function (cart) {
        var checkOutPromise = blockUIWrapper.wrap(paymentService.checkout(cart));

        checkOutPromise.then(function (data) {
            poster.postForm(data.payment_post_data);
        }, function (response) {
            flash.server(response.data);
        });
    };
}]);

},{}],82:[function(require,module,exports){
'use strict';

require('./checkout-controller');
require('./cart-routes');

},{"./cart-routes":80,"./checkout-controller":81}],83:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/shutdown', {
        name: 'shutdown',
        templateUrl: 'selfcare/routes/shutdown.html'
    });

    $routeProvider.when('/404', {
        name: '404',
        templateUrl: 'selfcare/routes/404.html'
    });

    $routeProvider.when('/dns-zone-detail-error-404', {
        name: 'dns-zone-detail-error-404',
        templateUrl: 'selfcare/routes/dns-zone-detail-error-404.html'
    });
}]);

},{}],84:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ContractsController', ["$scope", "$routeParams", "$location", "$timeout", "flash", "ngTableCreator", "contractSearch", "locationChangeHandler", "bnLanguage", "contractOperationHelper", "gettextCatalog", "PAYMENT_RETURN_PATHS", "helpers", function ($scope, $routeParams, $location, $timeout, flash, ngTableCreator, contractSearch, locationChangeHandler, bnLanguage, contractOperationHelper, gettextCatalog, PAYMENT_RETURN_PATHS, helpers) {

    console.log('$routeParams', $routeParams, $location.search());
    var instance = this;
    if ($routeParams.open) {
        contractOperationHelper.getMetadata($routeParams.open).then(function (contract) {
            console.log(contract.id);
            if (contract.id) {
                instance.openContent(contract);
            }
        });
    }
    //to view on manual location changes like 'browser back button'
    var contractSearchLocationChangeHandler = locationChangeHandler.create({
        onInit: function onInit() {
            console.log('onInit', arguments);
            $scope.tableParams = ngTableCreator.create(function ($defer, params) {
                contractSearch.executeContractSearch($defer, params);
            }, { date: 'desc' });
        },
        onUrlChange: function onUrlChange(searchParameters) {
            console.log('on_url_change', searchParameters);
            $scope.tableParams.parameters(searchParameters, true);
        },
        resolveParams: function resolveParams() {
            console.log('resolveParams', arguments);

            return $scope.tableParams.url();
        }
    });
    contractSearchLocationChangeHandler.start();

    //available operations
    this.openContent = function (contract) {
        $location.search('open', contract.id);
        contractOperationHelper.openContent(contract, $scope, $location);
    };
    this.downloadContent = function (contract) {
        contractOperationHelper.downloadContent(contract);
    };

    this.isSearchEmpty = function () {
        return contractSearch.isSearchEmpty();
    };
}]);

},{}],85:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/contracts', {
        name: 'contracts',
        templateUrl: 'selfcare/routes/contracts/contracts.html',
        controller: 'ContractsController',
        controllerAs: 'ctrl',
        reloadOnSearch: false
    });
}]);

},{}],86:[function(require,module,exports){
'use strict';

require('./contracts-controller');
require('./contracts-routes');

},{"./contracts-controller":84,"./contracts-routes":85}],87:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('HeaderController', ["$scope", "$rootScope", "$q", "helpers", "$location", "menuHelper", "namedRouteService", "djangoAuth", function ($scope, $rootScope, $q, helpers, $location, menuHelper, namedRouteService, djangoAuth) {

    $scope.authenticated = USER_AUTHENTICATED;
    $scope.profile = null;
    $scope.menuContext = null;

    function getProfile() {
        if ($scope.authenticated) {
            djangoAuth.profile().then(function (data) {
                $scope.profile = data;
            });
        }
    }

    function getMenuContext() {
        if ($scope.authenticated) {
            menuHelper.resolveContext().then(function (data) {
                $scope.menuContext = data;
            });
        }
    }

    getProfile();
    getMenuContext();

    $scope.logout = function () {
        djangoAuth.logout().then(function () {
            namedRouteService.open('login');
        });
    };

    $rootScope.$on('djangoAuth.logged_out', function () {
        $scope.authenticated = false;
        $scope.profile = null;
    });

    $rootScope.$on('djangoAuth.logged_in', function (event, authenticated, profile) {
        $scope.authenticated = true;
        $scope.profile = profile;
        getMenuContext();
    });

    $rootScope.$on('djangoAuth.profile_updated', function (event, profile) {
        $scope.profile = profile;
    });

    $scope.profileName = function () {
        if (helpers.objects.isEmpty($scope.profile)) {
            return '...';
        } else {
            return helpers.strings.truncate($scope.profile.partner.name, 30);
        }
    };

    $scope.isMenuItemAvailable = function (menuItem) {
        if (helpers.objects.isEmpty($scope.menuContext)) {
            return false;
        }
        return $scope.menuContext.permittedMenuItems.indexOf(menuItem) >= 0 && $scope.menuContext.restrictedMenuItems.indexOf(menuItem) < 0;
    };
}]);

},{}],88:[function(require,module,exports){
'use strict';

require('./login');
require('./password');
require('./registration');
require('./profile');
require('./cart');
require('./invoices');
require('./services');
require('./tickets');
require('./payment');
require('./header-controller');
require('./common-routes');
require('./reports');
require('./contracts');

},{"./cart":82,"./common-routes":83,"./contracts":86,"./header-controller":87,"./invoices":89,"./login":92,"./password":95,"./payment":99,"./profile":103,"./registration":106,"./reports":110,"./services":114,"./tickets":127}],89:[function(require,module,exports){
'use strict';

require('./invoices-controller');
require('./invoices-routes');

},{"./invoices-controller":90,"./invoices-routes":91}],90:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('InvoicesController', ["$scope", "$routeParams", "$location", "$timeout", "flash", "invoiceOperationHelper", "ngTableCreator", "invoiceSearch", "locationChangeHandler", "bnLanguage", "gettextCatalog", "PAYMENT_RETURN_PATHS", "helpers", function ($scope, $routeParams, $location, $timeout, flash, invoiceOperationHelper, ngTableCreator, invoiceSearch, locationChangeHandler, bnLanguage, gettextCatalog, PAYMENT_RETURN_PATHS, helpers) {

    var payment_result = $routeParams.payment_result;

    function addInvoicePaymentFlash() {
        if (helpers.objects.isNotEmpty(payment_result)) {
            if (payment_result === 'success') {
                flash.success(gettextCatalog.getString('Sąskaita apmokėta sėkmingai.'));
            } else {
                flash.error(gettextCatalog.getString('Sąskaitos apmokėjimas buvo nutrauktas.'));
            }
            $location.search('payment_result', null);
        }
    }

    $timeout(function () {
        addInvoicePaymentFlash();
    }, 250);

    //to view on manual location changes like 'browser back button'
    var invoiceSearchLocationChangeHandler = locationChangeHandler.create({
        onInit: function onInit() {
            $scope.tableParams = ngTableCreator.create(function ($defer, params) {
                invoiceSearch.executeInvoiceSearch($defer, params);
            }, { date_invoice: 'desc' });
        },
        onUrlChange: function onUrlChange(searchParameters) {
            $scope.tableParams.parameters(searchParameters, true);
        },
        resolveParams: function resolveParams() {
            return $scope.tableParams.url();
        }
    });
    invoiceSearchLocationChangeHandler.start();

    //available operations
    this.openContent = function (invoice) {
        invoiceOperationHelper.openContent(invoice);
    };
    this.downloadContent = function (invoice) {
        invoiceOperationHelper.downloadContent(invoice);
    };

    function prepareInvoicePayment(invoice) {

        var invoicePaymentPayment = {
            totalPrice: helpers.money.toMoney(invoice.residual),
            totalPriceWithVat: helpers.money.toMoney(invoice.residual),
            paymentText: invoice.number,
            lang: bnLanguage.getPaySeraLanguage(),
            unit: 'EUR',
            returnPathSuccess: PAYMENT_RETURN_PATHS.INVOICE_PAYMENT_RETURN_PATH_SUCCESS,
            returnPathFailure: PAYMENT_RETURN_PATHS.INVOICE_PAYMENT_RETURN_PATH_FAILURE,

            services: []
        };

        //make domain product item
        var invoiceProduct = {
            invoiceValue: invoice,
            attributes: {},
            extra: {
                invoice_id: invoice.id
            },
            description: invoice.number,
            unit: 'EUR'
        };

        //add domain product item
        invoicePaymentPayment.services.push(invoiceProduct);

        return invoicePaymentPayment;
    }

    this.pay = function (invoice) {
        invoiceOperationHelper.pay(prepareInvoicePayment(invoice));
    };

    this.isPaymentAvailable = function (invoice) {
        return invoiceOperationHelper.isPaymentAvailable(invoice);
    };

    this.isConclusionAvailable = function (invoice) {
        return invoiceOperationHelper.isConclusionAvailable(invoice);
    };

    this.isSearchEmpty = function () {
        return invoiceSearch.isSearchEmpty();
    };
}]);

},{}],91:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/invoices', {
        name: 'invoices',
        templateUrl: 'selfcare/routes/invoices/invoices.html',
        controller: 'InvoicesController',
        controllerAs: 'ctrl',
        reloadOnSearch: false
    });
}]);

},{}],92:[function(require,module,exports){
'use strict';

require('./login-controller');
require('./login-routes');

},{"./login-controller":93,"./login-routes":94}],93:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('LoginController', ["$scope", "flash", "djangoAuth", "blockUIWrapper", "validate", "namedRouteService", "gettextCatalog", function ($scope, flash, djangoAuth, blockUIWrapper, validate, namedRouteService, gettextCatalog) {

    $scope.model = { 'username': '', 'password': '' };
    $scope.errors = [];

    this.login = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            var loginPromise = blockUIWrapper.wrap(djangoAuth.loginAndGet($scope.model.username, $scope.model.password));

            loginPromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('Sveikiname, Jūs prisijungėte prie sistemos.'), true);
                $scope.restoreNextLocation(false);
            }, function (data) {
                $scope.errors = flash.server(data);
            });
        }
    };
}]);

},{}],94:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {
    $routeProvider.when('/', {
        name: 'login',
        templateUrl: 'selfcare/routes/login/login.html',
        controller: 'LoginController',
        controllerAs: 'ctrl',
        redirectTo: function redirectTo(routeParams, location, search) {
            if (USER_AUTHENTICATED) {
                return '/invoices';
            }
        }
    });
}]);

},{}],95:[function(require,module,exports){
'use strict';

require('./password-reset-controller');
require('./password-reset-confirm-controller');
require('./password-routes');

},{"./password-reset-confirm-controller":96,"./password-reset-controller":97,"./password-routes":98}],96:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('PasswordResetConfirmController', ["$scope", "$routeParams", "flash", "djangoAuth", "blockUIWrapper", "validate", "namedRouteService", "gettextCatalog", function ($scope, $routeParams, flash, djangoAuth, blockUIWrapper, validate, namedRouteService, gettextCatalog) {

    $scope.model = { 'new_password1': '', 'new_password2': '' };
    $scope.errors = [];

    this.resetConfirm = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            var confirmResetPromise = blockUIWrapper.wrap(djangoAuth.confirmReset($routeParams.token, $scope.model.new_password1, $scope.model.new_password2));

            confirmResetPromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('Slaptažodis pakeistas sėkmingai'), true);
                namedRouteService.open('login');
            }, function (data) {
                $scope.errors = flash.server(data);
            });
        }
    };
}]);

},{}],97:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('PasswordResetController', ["$scope", "flash", "djangoAuth", "blockUIWrapper", "validate", "namedRouteService", "gettextCatalog", function ($scope, flash, djangoAuth, blockUIWrapper, validate, namedRouteService, gettextCatalog) {

    $scope.model = { 'username': '' };
    $scope.errors = [];

    this.reset = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            var passwordResetPromise = blockUIWrapper.wrap(djangoAuth.resetPassword($scope.model.username));
            //run password reset operation to the server
            passwordResetPromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('Slaptažodžio atstatymo instrukcijos išsiųstos į Jūsų elektroninį paštą'), true);
                //move to root
                namedRouteService.open('login');
            }, function (data) {
                $scope.errors = flash.server(data);
            });
        }
    };
}]);

},{}],98:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/password-reset', {
        name: 'password-rest',
        templateUrl: 'selfcare/routes/password/password-reset.html',
        controller: 'PasswordResetController',
        controllerAs: 'ctrl'
    });

    $routeProvider.when('/password-reset-confirm', {
        name: 'password-rest-confirm',
        templateUrl: 'selfcare/routes/password/password-reset-confirm.html',
        controller: 'PasswordResetConfirmController',
        controllerAs: 'ctrl'
    });
}]);

},{}],99:[function(require,module,exports){
'use strict';

require('./payment-routes');

},{"./payment-routes":100}],100:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/payment/accept', {
        name: 'payment-accept',
        templateUrl: 'selfcare/routes/payment/accept.html'
    });

    $routeProvider.when('/payment/cancel', {
        name: 'payment-cancel',
        templateUrl: 'selfcare/routes/payment/cancel.html'
    });

    $routeProvider.when('/payment/accept-failure', {
        name: 'payment-accept-failure',
        templateUrl: 'selfcare/routes/payment/accept-failure.html'
    });

    $routeProvider.when('/payment/cancel-failure', {
        name: 'payment-cancel-failure',
        templateUrl: 'selfcare/routes/payment/cancel-failure.html'
    });
}]);

},{}],101:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ChangeEmailConfirmController', ["$scope", "flash", "$routeParams", "blockUIWrapper", "namedRouteService", "djangoAuth", "validate", "gettextCatalog", function ($scope, flash, $routeParams, blockUIWrapper, namedRouteService, djangoAuth, validate, gettextCatalog) {

    $scope.model = { 'password': '' };
    $scope.errors = [];

    //confirm change email
    this.changeEmailConfirm = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            var emailChangeConfirmPromise = blockUIWrapper.wrap(djangoAuth.changeEmailConfirm($routeParams.token, $scope.model));

            emailChangeConfirmPromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('El. paštas pakeistas sėkmingai'), true);
                namedRouteService.open('profile');
            }, function (data) {
                $scope.errors = flash.server(data);
            });
        }
    };
}]);

},{}],102:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ChangeEmailController', ["$scope", "flash", "blockUIWrapper", "djangoAuth", "namedRouteService", "validate", "gettextCatalog", function ($scope, flash, blockUIWrapper, djangoAuth, namedRouteService, validate, gettextCatalog) {

    $scope.model = { 'email': '' };
    $scope.errors = [];

    this.changeEmail = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            var changeEmailPromise = blockUIWrapper.wrap(djangoAuth.changeEmail($scope.model.email));

            changeEmailPromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('El. pašto keitimo instrukcijos išsiųstos nurodytu adresu'), true);
                namedRouteService.open('profile');
            }, function (data) {
                $scope.errors = flash.server(data);
            });
        }
    };
}]);

},{}],103:[function(require,module,exports){
'use strict';

require('./profile-controller');
require('./profile-routes');
require('./change-email-controller');
require('./change-email-confirm-controller');

},{"./change-email-confirm-controller":101,"./change-email-controller":102,"./profile-controller":104,"./profile-routes":105}],104:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ProfileController', ["$scope", "flash", "$routeParams", "PARTNER_TITLES", "djangoAuth", "blockUIWrapper", "AddressResource", "searchDelayHandler", "validate", "namedRouteService", "helpers", "gettextCatalog", "profile", function ($scope, flash, $routeParams, PARTNER_TITLES, djangoAuth, blockUIWrapper, AddressResource, searchDelayHandler, validate, namedRouteService, helpers, gettextCatalog, profile) {

    //resolved dynamic fields
    $scope.partnerTitles = PARTNER_TITLES;
    //model values containing user data
    $scope.model = profile;

    //attach password fields
    $scope.model.user = angular.extend({}, $scope.model.user, {
        'password1': '',
        'password2': ''
    });

    $scope.errors = [];

    //update profile
    this.updateProfile = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {

            var profilePromise = blockUIWrapper.wrap(djangoAuth.updateProfile($scope.model));

            profilePromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('Profilis atnaujintas'));
            }, function (data) {
                $scope.errors = flash.server(data);
                console.log($scope.errors);
            });
        }
    };

    var _addressCollection = AddressResource.$newCollection();
    this.getAddress = function (val) {
        //searchDelayHandler.search('address',function(){
        //});
        $scope.model.address.address_id[1] = null;
        return _addressCollection.fetch({ params: { q: val } });
    };

    function findAddress(id) {
        var addresses = _addressCollection.where({ id: id });
        if (helpers.arrays.isEmpty(addresses)) {
            return null;
        }
        return addresses[0];
    }

    this.addressFormatter = function (model) {
        if ($scope.model.address.address_id[1] === undefined || $scope.model.address.address_id[1] === null) {
            var address = findAddress(model);
            if (address === null) {
                return null;
            }
            return address.full_name;
        } else {
            return $scope.model.address.address_id[1];
        }
    };

    this.selectAddress = function ($item, $model, $label) {
        $scope.model.address.address_id[1] = $item.full_name;
    };

    function findPartnerTitle(id) {
        return helpers.arrays.find(PARTNER_TITLES, 'id', id);
    }

    this.selectPartnerTitle = function () {
        var title = findPartnerTitle($scope.model.partner.title[0]);
        $scope.model.partner.title[1] = title.name;
    };

    this.partnerTitlesTranslation = function (titleName) {
        return gettextCatalog.getString(titleName);
    };
}]);

},{}],105:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/profile', {
        name: 'profile',
        templateUrl: 'selfcare/routes/profile/profile.html',
        controller: 'ProfileController',
        controllerAs: 'ctrl',
        resolve: {
            profile: ["djangoAuth", "blockUIWrapper", function profile(djangoAuth, blockUIWrapper) {
                return blockUIWrapper.wrap(djangoAuth.profile());
            }]
        }
    });

    $routeProvider.when('/change-email', {
        name: 'change-email',
        templateUrl: 'selfcare/routes/profile/change-email.html',
        controller: 'ChangeEmailController',
        controllerAs: 'ctrl'
    });

    $routeProvider.when('/change-email-confirm', {
        name: 'change-email-confirm',
        templateUrl: 'selfcare/routes/profile/change-email-confirm.html',
        controller: 'ChangeEmailConfirmController',
        controllerAs: 'ctrl'
    });
}]);

},{}],106:[function(require,module,exports){
'use strict';

require('./registration-controller');
require('./registration-confirm-controller');
require('./registration-routes');

},{"./registration-confirm-controller":107,"./registration-controller":108,"./registration-routes":109}],107:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('RegistrationConfirmController', ["$scope", "flash", "$routeParams", "PARTNER_SHORT_TITLES", "djangoAuth", "blockUIWrapper", "AddressResource", "validate", "namedRouteService", "helpers", "gettextCatalog", function ($scope, flash, $routeParams, PARTNER_SHORT_TITLES, djangoAuth, blockUIWrapper, AddressResource, validate, namedRouteService, helpers, gettextCatalog) {

    //resolved dynamic fields
    $scope.partnerTitles = PARTNER_SHORT_TITLES;

    //model values containing user data
    $scope.model = {
        'user': {
            'username': '',
            'password1': '',
            'password2': ''
        },
        'partner': {
            'name': '',
            'ref': '',
            'title': [PARTNER_SHORT_TITLES.PERSON, null]
        },
        'address': {
            'address_id': [null, null]
        },
        phone: {
            'phone_addon': null,
            'phone': null
        }
    };
    $scope.errors = [];

    //confirm registration
    this.registrationConfirm = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            var registrationConfirmPromise = blockUIWrapper.wrap(djangoAuth.registrationConfirm($routeParams.token, $scope.model));

            registrationConfirmPromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('Jūs užsiregistravote į sistemą'), true);
                namedRouteService.open('login');
            }, function (data) {
                $scope.errors = flash.server(data);
            });
        }
    };

    var _addressCollection = AddressResource.$newCollection();
    this.getAddress = function (val) {
        return _addressCollection.fetch({ params: { q: val } });
    };

    function findAddress(id) {
        var addresses = _addressCollection.where({ id: id });
        if (helpers.arrays.isEmpty(addresses)) {
            return null;
        }
        return addresses[0];
    }

    this.addressFormatter = function (model) {
        var address = findAddress(model);
        if (address === null) {
            return null;
        }
        return address.full_name;
    };

    this.selectAddress = function ($item, $model, $label) {
        $scope.model.address.address_id[1] = $item.full_name;
    };

    this.resolveNameLabel = function () {
        if ($scope.model.partner.title[0] === PARTNER_SHORT_TITLES.PERSON) {
            return gettextCatalog.getString('Asmuo');
        } else {
            return gettextCatalog.getString('Įmonės pavadinimas');
        }
    };

    this.resolveRefLabel = function () {
        if ($scope.model.partner.title[0] === PARTNER_SHORT_TITLES.PERSON) {
            return gettextCatalog.getString('Asmens kodas');
        } else {
            return gettextCatalog.getString('Įmonės kodas');
        }
    };
}]);

},{}],108:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('RegistrationController', ["$scope", "flash", "djangoAuth", "blockUIWrapper", "validate", "namedRouteService", "gettextCatalog", function ($scope, flash, djangoAuth, blockUIWrapper, validate, namedRouteService, gettextCatalog) {

    $scope.model = { 'email': '' };
    $scope.errors = [];

    this.registration = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            var registrationPromise = blockUIWrapper.wrap(djangoAuth.register($scope.model.email));

            registrationPromise.then(function (data) {
                $scope.errors = [];
                flash.success(gettextCatalog.getString('Registracijos instrukcijos išsiųstos į Jūsų elektroninį paštą'), true);
                namedRouteService.open('login');
            }, function (data) {
                $scope.errors = flash.server(data);
            });
        }
    };
}]);

},{}],109:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/registration', {
        name: 'registration',
        templateUrl: 'selfcare/routes/registration/registration.html',
        controller: 'RegistrationController',
        controllerAs: 'ctrl'
    });

    $routeProvider.when('/registration-confirm', {
        name: 'registration-confirm',
        templateUrl: 'selfcare/routes/registration/registration-confirm.html',
        controller: 'RegistrationConfirmController',
        controllerAs: 'ctrl'
    });
}]);

},{}],110:[function(require,module,exports){
'use strict';

require('./reports-controller');
require('./reports-routes');
require('./voip-reports-controller');

},{"./reports-controller":111,"./reports-routes":112,"./voip-reports-controller":113}],111:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ReportsController', ["$scope", "$routeParams", "validate", "reportOperationHelper", function ($scope, $routeParams, validate, reportOperationHelper) {

    $scope.reportType = $routeParams.type;

    $scope.model = { 'date': '' };
    $scope.errors = [];

    $scope.calendarStatus = {
        opened: false
    };

    this.openCalendar = function ($event) {
        $scope.calendarStatus.opened = true;
    };

    this.reporting = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            $scope.errors = [];
            reportOperationHelper.downloadReport($scope.reportType, $scope.model.date);
        }
    };
}]);

},{}],112:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/reports/:type', {
        name: 'reports',
        templateUrl: 'selfcare/routes/reports/reports.html',
        controller: 'ReportsController',
        controllerAs: 'ctrl'
    });

    $routeProvider.when('/voip-reports', {
        name: 'voip-reports',
        templateUrl: 'selfcare/routes/reports/reports-voip.html',
        controller: 'VoipReportsController',
        controllerAs: 'ctrl'
    });
}]);

},{}],113:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('VoipReportsController', ["$scope", "validate", "locationChangeHandler", "ngTableCreator", "gettextCatalog", "flash", "helpers", "$confirm", "VoipReportResource", "FILE_TYPES", "VOIP_REPORT_TYPES", "VOIP_REPORT_STATES", "voipReportSearch", "reportOperationHelper", "reportCreateHelper", function ($scope, validate, locationChangeHandler, ngTableCreator, gettextCatalog, flash, helpers, $confirm, VoipReportResource, FILE_TYPES, VOIP_REPORT_TYPES, VOIP_REPORT_STATES, voipReportSearch, reportOperationHelper, reportCreateHelper) {

    $scope.fileTypes = FILE_TYPES;
    $scope.voipReportTypes = VOIP_REPORT_TYPES;
    $scope.model = {
        'date_from': null,
        'file_type': null,
        'report_type': null
    };
    $scope.errors = [];

    $scope.calendarStatus = {
        opened: false
    };

    this.openCalendar = function ($event) {
        $scope.calendarStatus.opened = true;
    };

    function formatVoipReport(model) {
        return {
            'date_from': helpers.dates.simpleFormat(model.date_from),
            'file_type': model.file_type,
            'report_type': model.report_type
        };
    }

    function afterReportCreationSuccess() {
        $scope.errors = [];
        $scope.tableParams.reload();
        flash.success(gettextCatalog.getString('VoIP išklotinė kuriama'));
    }

    $scope.tableParams = ngTableCreator.createNotPaged(function ($defer, params) {
        voipReportSearch.executeReportSearch($defer, params);
    });

    this.isSearchEmpty = function () {
        return voipReportSearch.isSearchEmpty();
    };

    function createVoipReport() {
        reportCreateHelper.createVoipReport(formatVoipReport($scope.model)).then(function (data) {
            afterReportCreationSuccess();
        }, function (response) {
            $scope.errors = flash.server(response.data);
        });
    }

    this.createReport = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            if ($scope.model.report_type === VOIP_REPORT_TYPES.INCOMING) {
                $confirm({
                    text: gettextCatalog.getString('Ši VoIP išklotinė yra mokama. Išklotinės kaina yra 4,34 EUR. Ar norite tęsti?'),
                    title: gettextCatalog.getString('Patvirtinkite'),
                    ok: gettextCatalog.getString('Taip'),
                    cancel: gettextCatalog.getString('Ne')
                }).then(function () {
                    createVoipReport();
                });
            } else {
                createVoipReport();
            }
        }
    };

    //available operations
    this.openContent = function (reportId) {
        VoipReportResource.openContent('voip', reportId);
    };
    this.downloadContent = function (reportId) {
        VoipReportResource.downloadContent('voip', reportId);
    };

    this.operationDownloadIsAvailable = function (report) {
        return report.status === VOIP_REPORT_STATES.DONE;
    };

    this.operationDeleteIsAvailable = function (report) {
        return report.status === VOIP_REPORT_STATES.PENDING;
    };

    function afterReportDeleteSuccess() {
        $scope.errors = [];
        $scope.tableParams.reload();
        flash.success(gettextCatalog.getString('VoIP išklotinė atšaukta'));
    }

    this.deleteReport = function (report) {
        reportCreateHelper.deleteReport(report).then(function (data) {
            afterReportDeleteSuccess();
        }, function (response) {
            $scope.errors = flash.server(response.data);
        });
    };
}]);

},{}],114:[function(require,module,exports){
'use strict';

require('./service-resource-pool-detail-controller');
require('./service-virtual-dedicated-server-detail-controller');
require('./service-add-virtual-dedicated-server-controller');
require('./services-controller');
require('./service-pdu-management-controller');
require('./services-routes');
require('./service-dns-zone-detail-controller');
require('./service-add-hosting-server-controller');
require('./service-add-domain-controller');
require('./service-graph-controller');
require('./service-virtual-dedicated-server-change-controller');
require('./service-direct-admin-change-password-modal-controller');

},{"./service-add-domain-controller":115,"./service-add-hosting-server-controller":116,"./service-add-virtual-dedicated-server-controller":117,"./service-direct-admin-change-password-modal-controller":118,"./service-dns-zone-detail-controller":119,"./service-graph-controller":120,"./service-pdu-management-controller":121,"./service-resource-pool-detail-controller":122,"./service-virtual-dedicated-server-change-controller":123,"./service-virtual-dedicated-server-detail-controller":124,"./services-controller":125,"./services-routes":126}],115:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceAddDomainController', ["$scope", "$routeParams", "$timeout", "flash", "vatService", "serviceCreateHelper", "PRODUCT_TYPE", "WIZARD_STEPS", "PAYMENT_RETURN_PATHS", "wizardHandlerHelper", "bnLanguage", "ProductResource", "validate", "gettextCatalog", "domains", "helpers", function ($scope, $routeParams, $timeout, flash, vatService, serviceCreateHelper, PRODUCT_TYPE, WIZARD_STEPS, PAYMENT_RETURN_PATHS, wizardHandlerHelper, bnLanguage, ProductResource, validate, gettextCatalog, domains, helpers) {

    var progress = $routeParams.progress;
    var wizardHandlerInstance = wizardHandlerHelper.create('domainWizard');

    $scope.domains = ProductResource.getProductValues(domains, PRODUCT_TYPE.DOMAIN_NAME);

    $scope.wizardData = {
        ready: false,
        stepAllowance: {
            domain: true,
            buy: false,
            done: false
        },
        errors: [],
        domainModel: {
            domain: null,
            tld: helpers.arrays.last($scope.domains)
        },
        finishText: null,
        payment: null
    };

    function nextWizardStep(step) {
        $scope.wizardData.stepAllowance[step.prop] = true;
        return wizardHandlerInstance.moveNext();
    }

    function finisWizard() {
        $scope.wizardData.stepAllowance.domain = false;
        $scope.wizardData.stepAllowance.buy = false;
        $scope.wizardData.stepAllowance.done = false;
        return wizardHandlerInstance.finish();
    }

    function doneWizard() {
        return nextWizardStep(WIZARD_STEPS.DOMAIN.done).then(finisWizard);
    }

    function goToWizardEnd() {
        return nextWizardStep(WIZARD_STEPS.DOMAIN.buy).then(nextWizardStep(WIZARD_STEPS.DOMAIN.done).then(finisWizard));
    }

    function prepareDomainProduct() {

        var domainPayment = {
            totalPrice: helpers.money.toMoney($scope.wizardData.domainModel.tld.price),
            totalPriceWithVat: vatService.totalVAT($scope.wizardData.domainModel.tld.price),
            paymentText: helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name),
            lang: bnLanguage.getPaySeraLanguage(),
            unit: gettextCatalog.getString('EUR/met.'),
            returnPathSuccess: PAYMENT_RETURN_PATHS.DOMAIN_PAYMENT_RETURN_PATH_SUCCESS,
            returnPathFailure: PAYMENT_RETURN_PATHS.DOMAIN_PAYMENT_RETURN_PATH_FAILURE,

            services: []
        };

        //make domain product item
        var domainProduct = {
            productValue: $scope.wizardData.domainModel.tld,
            attributes: {},
            extra: {
                domain: helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name)
            },
            description: helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name),
            unit: gettextCatalog.getString('EUR/met.')
        };

        //add domain product item
        domainPayment.services.push(domainProduct);

        return domainPayment;
    }

    function afterCheckDomain(isDomainInUser) {
        if (!isDomainInUser) {
            $scope.wizardData.errors = { "domain": [gettextCatalog.getString("Toks domenas jau užimtas")] };
        } else {
            $scope.wizardData.payment = prepareDomainProduct();
            nextWizardStep(WIZARD_STEPS.DOMAIN.buy);
        }
    }

    if (progress === 'new') {

        this.chooseDomain = function (formData) {
            $scope.wizardData.errors = [];
            validate.formValidation(formData, $scope.wizardData.errors);
            if (!formData.$invalid) {
                //we need to check domain if we have the new one
                serviceCreateHelper.checkDomain(helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name)).then(function (response) {
                    afterCheckDomain(response);
                })['catch'](function (response) {
                    $scope.wizardData.errors = flash.server(response.data);
                });
            }
        };

        this.onPostPaid = function (payment) {
            $scope.wizardData.finishText = gettextCatalog.getString('Ačiū, kad pirkote!');
            doneWizard();
        };

        this.onPrePaid = function (payment, service) {
            console.log('onPrePaid', payment, service);
        };

        $scope.wizardData.ready = true;
    } else if (progress === 'success') {

        goToWizardEnd().then(function () {
            $timeout(function () {
                $scope.wizardData.finishText = gettextCatalog.getString('Ačiū, kad pirkote!');
                $scope.wizardData.ready = true;
            }, 100);
        });
    } else if (progress === 'failure') {

        goToWizardEnd().then(function () {
            $timeout(function () {
                $scope.wizardData.finishText = gettextCatalog.getString('Mokėjimas buvo nutrauktas');
                $scope.wizardData.ready = true;
            }, 100);
        });
    }
}]);

},{}],116:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceAddHostingServerController', ["$scope", "$routeParams", "$timeout", "vatService", "flash", "wizardHandlerHelper", "serviceCreateHelper", "PRODUCT_TYPE", "WIZARD_STEPS", "PAYMENT_RETURN_PATHS", "bnLanguage", "ProductResource", "validate", "gettextCatalog", "products", "domains", "daServers", "helpers", function ($scope, $routeParams, $timeout, vatService, flash, wizardHandlerHelper, serviceCreateHelper, PRODUCT_TYPE, WIZARD_STEPS, PAYMENT_RETURN_PATHS, bnLanguage, ProductResource, validate, gettextCatalog, products, domains, daServers, helpers) {

    var progress = $routeParams.progress;
    var wizardHandlerInstance = wizardHandlerHelper.create('hostingWizard');

    $scope.hostingData = {
        products: ProductResource.getProductValues(products, PRODUCT_TYPE.WEB_SERVICE),
        domains: ProductResource.getProductValues(domains, PRODUCT_TYPE.DOMAIN_NAME),
        daServers: daServers
    };

    $scope.wizardData = {
        stepAllowance: {
            productList: true,
            domain: false,
            buy: false,
            done: false
        },
        errors: [],
        productModel: null,
        domainModel: {
            mode: 'N',
            domain: null,
            tld: helpers.arrays.last($scope.hostingData.domains)
        },
        payment: null
    };

    function nextWizardStep(step) {
        $scope.wizardData.stepAllowance[step.prop] = true;
        return wizardHandlerInstance.moveNext();
    }

    function finisWizard() {
        $scope.wizardData.stepAllowance.productList = false;
        $scope.wizardData.stepAllowance.domain = false;
        $scope.wizardData.stepAllowance.buy = false;
        $scope.wizardData.stepAllowance.done = false;
        return wizardHandlerInstance.finish();
    }

    function doneWizard() {
        nextWizardStep(WIZARD_STEPS.HOSTING.done).then(finisWizard);
    }

    function goToWizardEnd() {
        return nextWizardStep(WIZARD_STEPS.HOSTING.domain).then(nextWizardStep(WIZARD_STEPS.HOSTING.buy).then(nextWizardStep(WIZARD_STEPS.HOSTING.done).then(finisWizard)));
    }

    this.chooseProduct = function (product) {
        $scope.wizardData.productModel = product;
        nextWizardStep(WIZARD_STEPS.HOSTING.domain);
    };

    function calculateTotalHostingPrice() {
        if (helpers.objects.isEmpty($scope.wizardData.productModel) || helpers.objects.isEmpty($scope.wizardData.domainModel.tld)) {
            return 0;
        }
        if ($scope.wizardData.domainModel.mode === 'N') {
            return helpers.money.addMoney($scope.wizardData.productModel.price, $scope.wizardData.domainModel.tld.price);
        } else {
            return helpers.money.toMoney($scope.wizardData.productModel.price);
        }
    }

    function calculateHostingName() {
        if (helpers.objects.isEmpty($scope.wizardData.productModel) || helpers.objects.isEmpty($scope.wizardData.domainModel.tld)) {
            return '';
        }
        return [$scope.wizardData.productModel.name, $scope.wizardData.domainModel.tld.name].join(' ');
    }

    function prepareHostingProduct() {

        var hostingPayment = {
            totalPrice: calculateTotalHostingPrice(),
            totalPriceWithVat: vatService.totalVAT(calculateTotalHostingPrice()),
            paymentText: calculateHostingName(),
            lang: bnLanguage.getPaySeraLanguage(),
            unit: gettextCatalog.getString('EUR/met.'),
            returnPathSuccess: PAYMENT_RETURN_PATHS.HOSTING_PAYMENT_RETURN_PATH_SUCCESS,
            returnPathFailure: PAYMENT_RETURN_PATHS.HOSTING_PAYMENT_RETURN_PATH_FAILURE,

            services: []
        };

        //make hosting product name
        var hostingProduct = {
            productValue: $scope.wizardData.productModel,
            attributes: ProductResource.getPaymentAttributes($scope.wizardData.productModel, PRODUCT_TYPE.WEB_SERVICE),
            extra: {
                domain: helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name)
            },
            description: $scope.wizardData.productModel.name,
            unit: gettextCatalog.getString('EUR/met.')
        };

        //add hosting product item
        hostingPayment.services.push(hostingProduct);

        if ($scope.wizardData.domainModel.mode === 'N') {

            //make domain product item
            var domainProduct = {
                productValue: $scope.wizardData.domainModel.tld,
                attributes: {},
                extra: {
                    domain: helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name)
                },
                description: helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name),
                unit: gettextCatalog.getString('EUR/met.')
            };

            //add domain product item
            hostingPayment.services.push(domainProduct);
        }

        return hostingPayment;
    }

    function afterCheckDomain(isDomainInUser) {
        if (!isDomainInUser) {
            $scope.wizardData.errors = { "domain": [gettextCatalog.getString("Toks domenas jau užimtas")] };
        } else {
            $scope.wizardData.payment = prepareHostingProduct();
            nextWizardStep(WIZARD_STEPS.HOSTING.buy);
        }
    }

    if (progress === 'new') {

        this.chooseDomain = function (formData) {
            $scope.wizardData.errors = [];
            validate.formValidation(formData, $scope.wizardData.errors);
            if (!formData.$invalid) {
                if ($scope.wizardData.domainModel.mode === 'N') {
                    //we need to check domain if we have the new one
                    serviceCreateHelper.checkDomain(helpers.strings.calculateDomainName($scope.wizardData.domainModel.domain, $scope.wizardData.domainModel.tld.name)).then(function (response) {
                        afterCheckDomain(response);
                    })['catch'](function (response) {
                        $scope.wizardData.errors = flash.server(response.data);
                    });
                } else {
                    $scope.wizardData.payment = prepareHostingProduct();
                    nextWizardStep(WIZARD_STEPS.HOSTING.buy);
                }
            }
        };

        this.chooseDomainLabel = function () {
            if ($scope.wizardData.domainModel.mode === 'N') {
                return gettextCatalog.getString('Tikrinti');
            } else {
                return gettextCatalog.getString('Toliau');
            }
        };

        this.hostingPlanButtonLabel = function () {
            return gettextCatalog.getString('Įsigyti');
        };

        this.onPostPaid = function (payment) {
            $scope.wizardData.finishText = gettextCatalog.getString('Ačiū, kad pirkote!');
            doneWizard();
        };

        this.onPrePaid = function (payment, service) {
            console.log('onPrePaid', payment, service);
        };

        $scope.wizardData.ready = true;
    } else if (progress === 'success') {

        goToWizardEnd().then(function () {
            $timeout(function () {
                $scope.wizardData.finishText = gettextCatalog.getString('Ačiū, kad pirkote!');
                $scope.wizardData.ready = true;
            }, 100);
        });
    } else if (progress === 'failure') {

        goToWizardEnd().then(function () {
            $timeout(function () {
                $scope.wizardData.finishText = gettextCatalog.getString('Mokėjimas buvo nutrauktas');
                $scope.wizardData.ready = true;
            }, 100);
        });
    }
}]);

},{}],117:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceAddVirtualDedicatedServerController', ["$scope", "$routeParams", "$timeout", "vatService", "flash", "wizardHandlerHelper", "PRODUCT_TYPE", "WIZARD_STEPS", "PAYMENT_RETURN_PATHS", "blockUIWrapper", "bnLanguage", "ProductResource", "paymentService", "gettextCatalog", "poster", "products", "helpers", function ($scope, $routeParams, $timeout, vatService, flash, wizardHandlerHelper, PRODUCT_TYPE, WIZARD_STEPS, PAYMENT_RETURN_PATHS, blockUIWrapper, bnLanguage, ProductResource, paymentService, gettextCatalog, poster, products, helpers) {

    var progress = $routeParams.progress;
    var wizardHandlerInstance = wizardHandlerHelper.create('vdsWizard');

    $scope.products = ProductResource.getProductValues(products, PRODUCT_TYPE.OPEN_VZ_SERVICE);

    $scope.wizardData = {
        ready: false,
        stepAllowance: {
            vds: true,
            buy: false,
            done: false
        },
        errors: [],
        finishText: null,
        payment: null
    };

    function nextWizardStep(step) {
        $scope.wizardData.stepAllowance[step.prop] = true;
        return wizardHandlerInstance.moveNext();
    }

    function finisWizard() {
        $scope.wizardData.stepAllowance.vds = false;
        $scope.wizardData.stepAllowance.buy = false;
        $scope.wizardData.stepAllowance.done = false;
        return wizardHandlerInstance.finish();
    }

    function doneWizard() {
        nextWizardStep(WIZARD_STEPS.VDS.done).then(finisWizard);
    }

    function goToWizardEnd() {
        return nextWizardStep(WIZARD_STEPS.VDS.buy).then(nextWizardStep(WIZARD_STEPS.VDS.done).then(finisWizard));
    }

    function prepareVdsProduct(vdsModel) {

        var vdsPayment = {
            totalPrice: helpers.money.toMoney(vdsModel.price),
            totalPriceWithVat: vatService.totalVAT(vdsModel.price),

            paymentText: vdsModel.name,
            lang: bnLanguage.getPaySeraLanguage(),
            unit: gettextCatalog.getString('EUR/mėn.'),
            returnPathSuccess: PAYMENT_RETURN_PATHS.VDS_PAYMENT_RETURN_PATH_SUCCESS,
            returnPathFailure: PAYMENT_RETURN_PATHS.VDS_PAYMENT_RETURN_PATH_FAILURE,

            services: []
        };

        //make vds product name
        var vdsProduct = {
            productValue: vdsModel,
            attributes: ProductResource.getPaymentAttributes(vdsModel, PRODUCT_TYPE.OPEN_VZ_SERVICE),
            description: vdsModel.name,
            unit: gettextCatalog.getString('EUR/mėn.')
        };

        //add hosting product item
        vdsPayment.services.push(vdsProduct);

        return vdsPayment;
    }

    if (progress === 'new') {

        this.chooseProduct = function (product) {
            $scope.wizardData.payment = prepareVdsProduct(product);
            nextWizardStep(WIZARD_STEPS.VDS.buy);
        };

        this.vdsPlanButtonLabel = function () {
            return gettextCatalog.getString('Įsigyti');
        };

        this.onPostPaid = function (payment) {
            $scope.wizardData.finishText = gettextCatalog.getString('Ačiū, kad pirkote!');
            doneWizard();
        };

        this.onPrePaid = function (payment, service) {
            console.log('onPrePaid', payment, service);
        };

        $scope.wizardData.ready = true;
    } else if (progress === 'success') {

        goToWizardEnd().then(function () {
            $timeout(function () {
                $scope.wizardData.finishText = gettextCatalog.getString('Ačiū, kad pirkote!');
                $scope.wizardData.ready = true;
            }, 100);
        });
    } else if (progress === 'failure') {

        goToWizardEnd().then(function () {
            $timeout(function () {
                $scope.wizardData.finishText = gettextCatalog.getString('Mokėjimas buvo nutrauktas');
                $scope.wizardData.ready = true;
            }, 100);
        });
    }
}]);

},{}],118:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceDirectAdminChangePasswordCtrl', ["$scope", "$modalInstance", "newPassword", "service", function ($scope, $modalInstance, newPassword, service) {

    $scope.newPassword = newPassword;

    this.close = function () {
        $modalInstance.dismiss();
    };
}]);

},{}],119:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceDnsZoneDetailController', ["$scope", "serviceCreateHelper", "bnLanguage", "$confirm", "NgTableParams", "validate", "flash", "gettextCatalog", "helpers", "zoneDetail", "ttls", "types", function ($scope, serviceCreateHelper, bnLanguage, $confirm, NgTableParams, validate, flash, gettextCatalog, helpers, zoneDetail, ttls, types) {

    $scope.types = types;
    $scope.ttls = ttls;

    $scope.zoneDetail = zoneDetail;
    $scope.model = {
        name: null,
        ttl: null,
        type: null,
        data: null
    };
    $scope.priority = null;
    $scope.errors = [];

    var recordsEditErrors = {};
    var recordsEdit = {};
    var recordsModel = angular.copy(zoneDetail.records);

    $scope.tableParams = new NgTableParams({}, {
        dataset: angular.copy(recordsModel)
    });

    function modelToEmpty() {
        $scope.model = {
            name: null,
            ttl: null,
            type: null,
            data: null
        };
        $scope.priority = null;
    }

    function getEditErrorsSelection(recordsEditId) {
        if (helpers.objects.isEmpty(recordsEditErrors[recordsEditId])) {
            recordsEditErrors[recordsEditId] = {
                errors: {}
            };
        }
        return recordsEditErrors[recordsEditId];
    }

    function hasEditErrors(recordsEditId, field) {
        var errors = getEditErrorsSelection(recordsEditId).errors;
        if (errors.hasOwnProperty(field)) {
            return helpers.arrays.isNotEmpty(errors[field]);
        } else {
            return false;
        }
    }

    function assignEditErrors(recordsEditId, errors) {
        getEditErrorsSelection(recordsEditId).errors = errors;
    }

    function addEditErrors(row, errors) {
        assignEditErrors(row.dns_rec_no, errors);
    }

    function removeEditErrors(row) {
        assignEditErrors(row.dns_rec_no, []);
    }

    this.hasEditErrors = function (row, field) {
        return hasEditErrors(row.dns_rec_no, field);
    };

    function getEditSelection(recordsEditId) {
        if (helpers.objects.isEmpty(recordsEdit[recordsEditId])) {
            recordsEdit[recordsEditId] = {
                edit: false
            };
        }
        return recordsEdit[recordsEditId];
    }

    function isEditing(recordsEditId) {
        return getEditSelection(recordsEditId).edit;
    }

    function enableEditing(recordsEditId) {
        getEditSelection(recordsEditId).edit = true;
    }

    function disableEditing(recordsEditId) {
        getEditSelection(recordsEditId).edit = false;
    }

    function findModel(recordsEditId) {
        return helpers.arrays.find(recordsModel, 'dns_rec_no', recordsEditId);
    }

    function resetRow(row, rowForm) {
        rowForm.$setPristine();
        disableEditing(row.dns_rec_no);
        return findModel(row.dns_rec_no);
    }

    this.isEditing = function (row) {
        return isEditing(row.dns_rec_no);
    };

    this.enableEdit = function (row) {
        enableEditing(row.dns_rec_no);
    };

    function copyRecordData(dest, src) {
        dest.dns_rec_no = src.dns_rec_no;
        dest.name = src.name;
        dest.ttl = src.ttl;
        dest.type = src.type;
        dest.data = src.data;
    }

    function afterCancel(row, rowForm) {
        var originalRow = resetRow(row, rowForm);
        copyRecordData(row, originalRow);
    }

    this.cancel = function (row, rowForm) {
        afterCancel(row, rowForm);
        removeEditErrors(row);
    };

    function afterDeleteSuccess(row) {
        helpers.arrays.removeItem($scope.tableParams.settings().dataset, row);
        $scope.tableParams.reload();
        //flash message
        flash.success(gettextCatalog.getString('DNS įrašas pašalintas'));
    }

    this['delete'] = function (row) {
        $confirm({
            text: gettextCatalog.getString('Ar Jūs tikrai norite pašalinti DNS įrašą?'),
            title: gettextCatalog.getString('Patvirtinkite'),
            ok: gettextCatalog.getString('Taip'),
            cancel: gettextCatalog.getString('Ne')
        }).then(function () {
            serviceCreateHelper.deleteDNSZoneRecord($scope.zoneDetail, row).then(function (response) {
                afterDeleteSuccess(row);
            }, function (response) {
                flash.server(response.data);
            });
        });
    };

    function afterUpdateSuccess(row, rowForm) {
        var originalRow = resetRow(row, rowForm);
        copyRecordData(originalRow, row);
        //flash message
        flash.success(gettextCatalog.getString('DNS įrašas atnaujintas'));
    }

    function resolvePriorityField() {
        if (helpers.strings.isNotBlank($scope.priority)) {
            $scope.model.data = $scope.model.data + ' ' + $scope.priority;
        }
    }

    this.update = function (row, rowForm) {
        var rowErrors = [];
        removeEditErrors(row);
        validate.formValidation(rowForm, rowErrors);
        if (!rowForm.$invalid) {
            resolvePriorityField();
            serviceCreateHelper.updateDNSZoneRecord($scope.zoneDetail, row).then(function (response) {
                afterUpdateSuccess(row, rowForm);
                removeEditErrors(row);
            }, function (response) {
                rowErrors = flash.server(response.data);
                addEditErrors(row, rowErrors);
            });
        } else {
            addEditErrors(row, rowErrors);
        }
    };

    function afterCreateSuccess(newRow, modelRow) {
        $scope.errors = [];

        $scope.tableParams.settings().dataset.push(newRow);
        $scope.tableParams.reload();

        recordsModel.push(newRow);

        flash.success(gettextCatalog.getString('DNS įrašas pridėtas'));
        modelToEmpty();
    }

    this.create = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            if (this.isPriorityAvailable() && $scope.priority) {
                $scope.model.data = $scope.priority + ' ' + $scope.model.data;
            }
            serviceCreateHelper.createDNSZoneRecord($scope.zoneDetail, $scope.model).then(function (response) {
                afterCreateSuccess(response, $scope.model);
            }, function (response) {
                $scope.errors = flash.server(response.data);
            });
        }
    };

    this.isPriorityAvailable = function () {
        return $scope.model.type === 'MX';
    };

    this.resolveTypeName = function (typeValue) {
        var typeCl = helpers.arrays.find($scope.types, 'value', typeValue);
        return helpers.objects.isEmpty(typeCl) ? '' : bnLanguage.modelTranslation(typeCl, 'name');
    };

    this.resolveTTLName = function (ttlValue) {
        var ttlCl = helpers.arrays.find($scope.ttls, 'value', helpers.numbers.toStr(ttlValue));
        return helpers.objects.isEmpty(ttlCl) ? '' : bnLanguage.modelTranslation(ttlCl, 'name');
    };
}]);

},{}],120:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceGraphCtrl', ["$scope", "graphData", "flash", "graphService", "calendarTranslations", "serviceCreateHelper", "helpers", "$modalInstance", "gettextCatalog", function ($scope, graphData, flash, graphService, calendarTranslations, serviceCreateHelper, helpers, $modalInstance, gettextCatalog) {

    $scope.calendarDateRangeWithTimeOptions = calendarTranslations.getDateRangeWithTimeOptions();

    $scope.myd3options = {
        chart: {

            type: 'stackedAreaChart',

            height: 450,
            width: 750,

            margin: {
                top: 20,
                right: 20,
                bottom: 60,
                left: 65
            },

            x: function x(d) {
                return d[0];
            },
            y: function y(d) {
                return d[1];
            },

            duration: 300,
            showControls: false,
            useInteractiveGuideline: true,
            clipEdge: true,

            color: ['#009600', '#0000c8', '#c80000', '#aa00c8'],

            xAxis: {
                axisLabel: '',
                tickFormat: function tickFormat(d) {
                    return d3.time.format('%Y-%m-%d %H:%M')(new Date(d));
                },
                showMaxMin: false,
                staggerLabels: true
            },

            yAxis: {
                axisLabel: gettextCatalog.getString('Paslaugos greitis kbps'),
                tickFormat: function tickFormat(d) {
                    return d3.format(',.1f')(d);
                },
                staggerLabels: true,
                axisLabelDistance: 5
            },

            zoom: {
                enabled: true,
                scaleExtent: [1, 1000000000],
                useFixedDomain: true,
                useNiceScale: false,
                horizontalOff: false,
                verticalOff: true,
                unzoomEventType: 'dblclick.zoom'
            },

            noData: gettextCatalog.getString('Nėra duomenų')

        }
    };

    $scope.dateRange = {
        startDate: helpers.dates.startOfTheDayAsStrDateAndTime(),
        endDate: helpers.dates.nowAsStrDateAndTime()
    };
    $scope.service = graphService;
    $scope.errors = [];

    function prepareDataPoints(label, xIndex, yIndex, rawData) {
        if (helpers.arrays.isEmpty(rawData)) {
            return null;
        }
        var dataPoints = {
            key: label,
            values: []
        };
        angular.forEach(rawData, function (row) {
            var dataPoint = [helpers.dates.parseISOFormat(row[xIndex]), row[yIndex]];
            dataPoints.values.push(dataPoint);
        });
        return dataPoints;
    }

    function prepareGraph(rawData) {
        var graphs = [],
            grow = null;
        grow = prepareDataPoints(gettextCatalog.getString('Download (LT)'), 0, 1, rawData.vals);
        if (helpers.objects.isNotEmpty(grow)) {
            graphs.push(grow);
        }
        grow = prepareDataPoints(gettextCatalog.getString('Upload (LT)'), 0, 2, rawData.vals);
        if (helpers.objects.isNotEmpty(grow)) {
            graphs.push(grow);
        }
        grow = prepareDataPoints(gettextCatalog.getString('Download (International)'), 0, 1, rawData.vals_int);
        if (helpers.objects.isNotEmpty(grow)) {
            graphs.push(grow);
        }
        grow = prepareDataPoints(gettextCatalog.getString('Upload (International)'), 0, 2, rawData.vals_int);
        if (helpers.objects.isNotEmpty(grow)) {
            graphs.push(grow);
        }
        return graphs;
    }

    $scope.myd3data = prepareGraph(graphData);

    function formatGraphParameters() {
        return {
            date_from: helpers.dates.dateAndTimeFormat($scope.dateRange.startDate),
            date_to: helpers.dates.dateAndTimeFormat($scope.dateRange.endDate)
        };
    }

    function doOnGraphData(data) {
        $scope.myd3options.chart.xDomain = [helpers.dates.parseISOFormat($scope.dateRange.startDate), helpers.dates.parseISOFormat($scope.dateRange.endDate)];
        $scope.myd3data = prepareGraph(data);
    }

    function getGraph() {
        $scope.errors = [];
        serviceCreateHelper.graph(graphService, formatGraphParameters()).then(function (data) {
            doOnGraphData(data);
        }, function (response) {
            $scope.errors = flash.server(response.data);
        });
    }

    this.dateRangeChange = function () {
        getGraph();
    };

    this.close = function () {
        $modalInstance.close();
    };
}]);

},{}],121:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('PduManagementController', ["$scope", "$modal", "$routeParams", "blockUIWrapper", "namedRouteService", "flash", "gettextCatalog", "PduManagementService", function ($scope, $modal, $routeParams, blockUIWrapper, namedRouteService, flash, gettextCatalog, PduManagementService) {
    $scope.pdus = null;

    blockUIWrapper.wrap(PduManagementService.get($routeParams.unit_id)).then(function (response) {
        $scope.pdus = response.pdus;

        angular.forEach($scope.pdus, function (pdu) {
            createSocketsMatrix(pdu);
        });
    }, function (reason) {
        $scope.pdus = [];

        flash.server(reason);
    });

    // A hash-table to store the sockets that would be considered to be rebooted
    $scope.socketsToReboot = {};

    this.toggle = function (unit_id, socket_id) {
        var key = [unit_id, socket_id].join('_');

        if ($scope.socketsToReboot[key]) {
            delete $scope.socketsToReboot[key];
        } else {
            $scope.socketsToReboot[key] = socket_id;
        }
    };

    this.isChecked = function (unit_id, socket_id) {
        var key = [unit_id, socket_id].join('_');

        return $scope.socketsToReboot[key] ? $scope.socketsToReboot[key] : false;
    };

    this.toggleAll = function (unit, turnOn) {
        angular.forEach(unit.sockets, function (socket) {
            var key = [unit.id, socket.id].join('_');

            if (turnOn) {
                $scope.socketsToReboot[key] = socket.id;
            } else {
                if ($scope.socketsToReboot[key]) delete $scope.socketsToReboot[key];
            }
        });
    };

    this.nothingSelected = function () {
        return angular.equals($scope.socketsToReboot, {});
    };

    this.back = function () {
        namedRouteService.open('services', $routeParams.back);
    };

    this.submit = function (form) {
        if (!form.$valid) return;

        confirmReboot().then(function (rebootReason) {
            var sockets = [];

            angular.forEach($scope.socketsToReboot, function (socket_id, key) {
                sockets.push(socket_id);
            });

            blockUIWrapper.wrap(PduManagementService.post(sockets, rebootReason)).then(function (response) {
                flash.success(gettextCatalog.getString('Elektros lizdas perkrautas sėkmingai'));
            }, function (reason) {
                flash.error(reason.data.detail);
            });
        });
    };

    function confirmReboot() {
        var modal = $modal.open({
            animation: true,
            backdrop: 'static',
            size: 'clg',
            templateUrl: 'selfcare/routes/services/sockets-reboot-confirm-modal.html',
            controller: ["$scope", "$modalInstance", function controller($scope, $modalInstance) {
                $scope.agree = false;
                $scope.reason = '';

                $scope.reboot = function (form) {
                    if (!form.$valid) return;

                    $modalInstance.close($scope.reason);
                };

                $scope.cancel = function () {
                    $modalInstance.dismiss(false);
                };
            }]
        });

        // a promise that is resolved when a modal is closed and rejected when a modal is dismissed
        return modal.result;
    }

    function createSocketsMatrix(pdu) {
        if (pdu.sockets.length) {
            var max_in_col = 4;

            var sockets_count = pdu.sockets.length;
            pdu._sockets_matrix = [[]];
            // Iterate over linear array of sockets of given pdu an create its matrix representation in order to render
            // it as html table
            for (var row = 0, i = 0; i < sockets_count; i++) {
                pdu._sockets_matrix[row].push(pdu.sockets[i]);

                if ((i + 1) % max_in_col === 0 && i + 1 < sockets_count) {
                    row++;
                    pdu._sockets_matrix[row] = [];
                }
            }

            var rows_count = pdu._sockets_matrix.length;
            // If row has less than `max_in_col` elems - complement it with empty items
            for (row = 0; row < rows_count; row++) {
                if (pdu._sockets_matrix[row].length) {
                    while (pdu._sockets_matrix[row].length < max_in_col) {
                        pdu._sockets_matrix[row].push({ id: null });
                    }
                }
            }
        }
    }
}]);

},{}],122:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceResourcePoolDetailController', ["$scope", "$confirm", "$route", "blockUIWrapper", "flash", "namedRouteService", "serviceDetail", "gettextCatalog", function ($scope, $confirm, $route, blockUIWrapper, flash, namedRouteService, serviceDetail, gettextCatalog) {

    // service detail
    $scope.detail = serviceDetail;
    $scope.priceEdited = false;
    //var b_service_units = angular.copy(serviceDetail.service_units);

    function onServiceUpdateSuccess(data) {
        flash.success(gettextCatalog.getString('Šiuo metu paslauga atnaujinama. Luktelėkite...'), true);
        namedRouteService.open('service-resource-pool-detail', data.id);
    }

    function onServiceUpdateFailure(response) {
        flash.server(response.data);
    }

    this.updateService = function () {
        //assign new price value
        $scope.detail.current_tariff = $scope.detail.price;

        var servicePromise = blockUIWrapper.wrap($scope.detail.save());
        servicePromise.then(onServiceUpdateSuccess, onServiceUpdateFailure);
    };

    function resetServiceUnits() {
        //reset service units
        //$scope.detail.service_units = b_service_units;
        //$scope.$broadcast('service-units:refresh', b_service_units);
        //$scope.priceEdited = false;
        $route.reload();
    }

    this.resetService = function () {
        $confirm({
            text: gettextCatalog.getString('Ar Jūs tikrai norite atstatyti pradinius parametrus?'),
            title: gettextCatalog.getString('Patvirtinkite'),
            ok: gettextCatalog.getString('Taip'),
            cancel: gettextCatalog.getString('Ne')
        }).then(function () {
            resetServiceUnits();
        });
    };

    //watch service unit change
    $scope.$on('service-unit:changed', function (event, unit) {
        $scope.priceEdited = true;
    });
}]);

},{}],123:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceVirtualDedicatedServerChangeController', ["$scope", "$modalInstance", "currentDetail", "newProductValue", function ($scope, $modalInstance, currentDetail, newProductValue) {

    $scope.currentDetail = currentDetail;
    $scope.newProductValue = newProductValue;

    this.change = function () {
        $modalInstance.close($scope.newProductValue);
    };

    this.close = function () {
        $modalInstance.dismiss();
    };
}]);

},{}],124:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServiceVirtualDedicatedServerDetailController', ["$scope", "blockUIWrapper", "flash", "namedRouteService", "PRODUCT_TYPE", "ProductResource", "gettextCatalog", "serviceDetail", "products", "serviceOperationHelper", function ($scope, blockUIWrapper, flash, namedRouteService, PRODUCT_TYPE, ProductResource, gettextCatalog, serviceDetail, products, serviceOperationHelper) {

    // service detail
    $scope.products = ProductResource.getProductValues(products, PRODUCT_TYPE.OPEN_VZ_SERVICE);
    $scope.detail = serviceDetail;

    function onServiceUpdateSuccess(data) {
        flash.success(gettextCatalog.getString('Šiuo metu paslauga atnaujinama. Luktelėkite...'), true);
        namedRouteService.open('service-virtual-dedicated-server-detail', data.id);
    }

    function onServiceUpdateFailure(response) {
        flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
    }

    function executeVdsChange(productValue) {
        ProductResource.assignServiceUnitValues(productValue, $scope.detail);
        blockUIWrapper.wrap($scope.detail.save()).then(onServiceUpdateSuccess, onServiceUpdateFailure);
    }

    this.confirmChangeOfPlan = function (newProductValue) {
        var modalInstance = serviceOperationHelper.changeVds($scope.detail, newProductValue);
        modalInstance.result.then(function (productValue) {
            executeVdsChange(productValue);
        }, function () {
            console.log('Modal dismissed');
        });
    };

    this.buttonLabel = function () {
        return gettextCatalog.getString('Keisti');
    };
}]);

},{}],125:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('ServicesController', ["$scope", "$routeParams", "serviceSearch", "ngTableCreator", "locationChangeHandler", "flash", "serviceOperationHelper", function ($scope, $routeParams, serviceSearch, ngTableCreator, locationChangeHandler, flash, serviceOperationHelper) {

    $scope.category = $routeParams.category;

    //to view on manual location changes like 'browser back button'
    var serviceSearchLocationChangeHandler = locationChangeHandler.create({
        onInit: function onInit() {

            $scope.tableParams = ngTableCreator.create(function ($defer, params) {
                serviceSearch.executeServiceSearch($scope.category, $defer, params);
            }, { service_start_date: 'asc' });
        },
        onUrlChange: function onUrlChange(searchParameters) {

            $scope.tableParams.parameters(searchParameters, true);
        },
        resolveParams: function resolveParams() {

            return $scope.tableParams.url();
        }
    });

    serviceSearchLocationChangeHandler.start();

    //available operations
    this.edit = function (service) {
        serviceOperationHelper.edit(service);
    };

    this.reboot = function (service) {
        serviceOperationHelper.reboot(service);
    };

    this.login = function (service) {
        serviceOperationHelper.login(service);
    };

    this.changePassword = function (service) {
        serviceOperationHelper.changePassword(service);
    };

    this.add = function (productType) {
        serviceOperationHelper.add(productType === undefined ? $scope.category : productType);
    };

    this.graph = function (service) {
        serviceOperationHelper.graph(service);
    };

    this.isSearchEmpty = function () {
        return serviceSearch.isSearchEmpty();
    };
}]);

},{}],126:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/services/:category', {
        name: 'services',
        templateUrl: 'selfcare/routes/services/services.html',
        controller: 'ServicesController',
        controllerAs: 'ctrl',
        reloadOnSearch: false
    });

    $routeProvider.when('/services/pdu/:unit_id/management/:back', {
        name: 'services-pdu-management',
        templateUrl: 'selfcare/routes/services/service-pdu-management.html',
        controller: 'PduManagementController',
        controllerAs: 'ctrl',
        reloadOnSearch: false
    });

    $routeProvider.when('/service/resource-pool-detail/:id', {
        name: 'service-resource-pool-detail',
        templateUrl: 'selfcare/routes/services/service-resource-pool-detail.html',
        controller: 'ServiceResourcePoolDetailController',
        controllerAs: 'ctrl',
        resolve: {
            serviceDetail: ["ServicesResourcePoolResource", "$route", "blockUIWrapper", function serviceDetail(ServicesResourcePoolResource, $route, blockUIWrapper) {
                return blockUIWrapper.wrap(ServicesResourcePoolResource.get($route.current.params.id));
            }]
        }
    });

    $routeProvider.when('/service/virtual-dedicated-server-detail/:id', {
        name: 'service-virtual-dedicated-server-detail',
        templateUrl: 'selfcare/routes/services/service-virtual-dedicated-server-detail.html',
        controller: 'ServiceVirtualDedicatedServerDetailController',
        controllerAs: 'ctrl',
        resolve: {
            serviceDetail: ["ServicesVirtualDedicatedServerResource", "$route", "blockUIWrapper", function serviceDetail(ServicesVirtualDedicatedServerResource, $route, blockUIWrapper) {
                return blockUIWrapper.wrap(ServicesVirtualDedicatedServerResource.get($route.current.params.id));
            }],
            products: ["ProductResource", "blockUIWrapper", "PRODUCT_TYPE", function products(ProductResource, blockUIWrapper, PRODUCT_TYPE) {
                return blockUIWrapper.wrap(ProductResource.query({ unit_type: PRODUCT_TYPE.OPEN_VZ_SERVICE }));
            }]
        }
    });

    $routeProvider.when('/service/dns-zone-detail/:id', {
        name: 'service-dns-zone-detail',
        templateUrl: 'selfcare/routes/services/service-dns-zone-detail.html',
        controller: 'ServiceDnsZoneDetailController',
        controllerAs: 'ctrl',
        resolve: {
            zoneDetail: ["ServicesDNSZoneResource", "$route", "blockUIWrapper", function zoneDetail(ServicesDNSZoneResource, $route, blockUIWrapper) {
                return blockUIWrapper.wrap(ServicesDNSZoneResource.get($route.current.params.id));
            }],
            ttls: ["ServicesDNSZoneTTLResource", "blockUIWrapper", function ttls(ServicesDNSZoneTTLResource, blockUIWrapper) {
                return blockUIWrapper.wrap(ServicesDNSZoneTTLResource.query());
            }],
            types: ["ServicesDNSZoneTypeResource", "blockUIWrapper", function types(ServicesDNSZoneTypeResource, blockUIWrapper) {
                return blockUIWrapper.wrap(ServicesDNSZoneTypeResource.query());
            }]
        },
        error404: "dns-zone-detail-error-404"
    });

    $routeProvider.when('/service/add-virtual-dedicated-server/:progress', {
        name: 'service-add-virtual-dedicated-server',
        templateUrl: 'selfcare/routes/services/service-add-virtual-dedicated-server.html',
        controller: 'ServiceAddVirtualDedicatedServerController',
        controllerAs: 'ctrl',
        resolve: {
            products: ["$route", "ProductResource", "blockUIWrapper", "PRODUCT_TYPE", function products($route, ProductResource, blockUIWrapper, PRODUCT_TYPE) {
                if ($route.current.params.progress !== 'new') {
                    return [];
                }
                return blockUIWrapper.wrap(ProductResource.query({ unit_type: PRODUCT_TYPE.OPEN_VZ_SERVICE }));
            }]
        }
    });

    $routeProvider.when('/service/add-hosting-server/:progress', {
        name: 'service-add-hosting-server',
        templateUrl: 'selfcare/routes/services/service-add-hosting-server.html',
        controller: 'ServiceAddHostingServerController',
        controllerAs: 'ctrl',
        resolve: {
            products: ["$route", "ProductResource", "blockUIWrapper", "PRODUCT_TYPE", function products($route, ProductResource, blockUIWrapper, PRODUCT_TYPE) {
                if ($route.current.params.progress !== 'new') {
                    return [];
                }
                return blockUIWrapper.wrap(ProductResource.query({ unit_type: PRODUCT_TYPE.WEB_SERVICE }));
            }],
            daServers: ["$route", "DAServersResource", "blockUIWrapper", function daServers($route, DAServersResource, blockUIWrapper) {
                if ($route.current.params.progress !== 'new') {
                    return [];
                }
                return blockUIWrapper.wrap(DAServersResource.query());
            }],
            domains: ["$route", "ProductResource", "blockUIWrapper", "PRODUCT_TYPE", function domains($route, ProductResource, blockUIWrapper, PRODUCT_TYPE) {
                if ($route.current.params.progress !== 'new') {
                    return [];
                }
                return blockUIWrapper.wrap(ProductResource.query({ unit_type: PRODUCT_TYPE.DOMAIN_NAME }));
            }]
        }
    });

    $routeProvider.when('/service/add-domain/:progress', {
        name: 'service-add-domain',
        templateUrl: 'selfcare/routes/services/service-add-domain.html',
        controller: 'ServiceAddDomainController',
        controllerAs: 'ctrl',
        resolve: {
            domains: ["$route", "ProductResource", "blockUIWrapper", "PRODUCT_TYPE", function domains($route, ProductResource, blockUIWrapper, PRODUCT_TYPE) {
                if ($route.current.params.progress !== 'new') {
                    return [];
                }
                return blockUIWrapper.wrap(ProductResource.query({ unit_type: PRODUCT_TYPE.DOMAIN_NAME }));
            }]
        }
    });
}]);

},{}],127:[function(require,module,exports){
'use strict';

require('./tickets-controller');
require('./tickets-routes');
require('./ticket-description-controller');
require('./ticket-add-controller');
require('./ticket-detail-controller');

},{"./ticket-add-controller":128,"./ticket-description-controller":129,"./ticket-detail-controller":130,"./tickets-controller":131,"./tickets-routes":132}],128:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('TicketAddController', ["$scope", "ServicesResource", "ticketCreateHelper", "validate", "PAGINATION_COUNTERS", "flash", "namedRouteService", "gettextCatalog", function ($scope, ServicesResource, ticketCreateHelper, validate, PAGINATION_COUNTERS, flash, namedRouteService, gettextCatalog) {

    $scope.model = {
        name: null,
        description: null,
        service: null
    };
    //service list holder
    $scope.services = {
        list: [],
        total: -1,
        page: 1,
        fetch: false,
        selected: null
    };
    $scope.errors = [];

    this.refreshServices = function (service) {
        if ($scope.services.total !== $scope.services.list.length) {
            $scope.services.fetch = true;
            ServicesResource.queryWithPages({
                page: $scope.services.page,
                count: PAGINATION_COUNTERS.count
            }).then(function (data) {
                if (data) {
                    $scope.services.list = $scope.services.list.concat(data);
                    $scope.services.page = $scope.services.page + 1;
                    $scope.services.total = data.total;
                    $scope.services.fetch = false;
                }
            });
        }
    };

    this.requestMoreItems = function (service) {
        if ($scope.services.fetch === false) {
            this.refreshServices(service);
        }
    };

    //assign selected service
    this.onServiceSelect = function (item, model) {
        $scope.model.service = [model.id, null];
    };

    function onTicketSaveSuccess(response) {
        flash.success(gettextCatalog.getString('Gedimas užregistruotas sėkmingai.'), true);
        namedRouteService.open('tickets');
    }

    function onTicketSaveFailure(response) {
        flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
    }

    this.createTicket = function (formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            ticketCreateHelper.createTicket($scope.model).then(function (response) {
                onTicketSaveSuccess(response);
            }, function (response) {
                onTicketSaveFailure(response);
            });
        }
    };
}]);

},{}],129:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('TicketDescriptionCtrl', ["$scope", "$modalInstance", "ticket", function ($scope, $modalInstance, ticket) {

    $scope.ticket = ticket;

    this.close = function () {
        $modalInstance.close();
    };
}]);

},{}],130:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('TicketDetailController', ["$scope", "ticketDetail", "flash", "gettextCatalog", "helpers", "validate", "ticketCreateHelper", "ticketOperationHelper", function ($scope, ticketDetail, flash, gettextCatalog, helpers, validate, ticketCreateHelper, ticketOperationHelper) {

    $scope.ticketDetail = ticketDetail;
    $scope.messageToggles = {};

    $scope.model = {
        body_text: null
    };
    $scope.errors = [];

    function getMessageSelection(messageId) {
        if (helpers.objects.isEmpty($scope.messageToggles[messageId])) {
            $scope.messageToggles[messageId] = {
                collapsed: true
            };
        }
        return $scope.messageToggles[messageId];
    }

    this.activateMessageSelection = function (message, event) {
        var actionSelection = getMessageSelection(message.id);
        actionSelection.collapsed = !actionSelection.collapsed;
    };

    function isMessageSelectionExpanded(messageId) {
        var messageSelection = $scope.messageToggles[messageId];
        if (messageSelection === undefined) {
            return undefined;
        }
        return !messageSelection.collapsed;
    }

    this.isMessageSelectionExpanded = function (message) {
        if (helpers.objects.isEmpty(message)) {
            return undefined;
        }
        return isMessageSelectionExpanded(message.id);
    };

    this.isNotMessageSelectionExpanded = function (message) {
        if (helpers.objects.isEmpty(message)) {
            return true;
        }
        return !isMessageSelectionExpanded(message.id);
    };

    function onTicketMessageSaveSuccess(response) {
        flash.success(gettextCatalog.getString('Pranešimas sėkmingai išsiųstas.'));
        $scope.model.body_text = null;
    }

    function onTicketMessageSaveFailure(response) {
        flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
    }

    this.createTicketMessage = function (ticket, formData) {
        $scope.errors = [];
        validate.formValidation(formData, $scope.errors);
        if (!formData.$invalid) {
            ticketCreateHelper.createTicketMessage(ticket, $scope.model).then(function (response) {
                onTicketMessageSaveSuccess(response);
            }, function (response) {
                onTicketMessageSaveFailure(response);
            });
        }
    };

    this.backToTickes = function () {
        ticketOperationHelper.backToTickes();
    };
}]);

},{}],131:[function(require,module,exports){
'use strict';

angular.module('selfcare').controller('TicketsController', ["$scope", "flash", "$modal", "ngTableCreator", "ticketSearch", "ticketOperationHelper", "gettextCatalog", "calendarTranslations", "TICKET_STATES", "TICKET_CATEGORIES", "helpers", "locationChangeHandler", function ($scope, flash, $modal, ngTableCreator, ticketSearch, ticketOperationHelper, gettextCatalog, calendarTranslations, TICKET_STATES, TICKET_CATEGORIES, helpers, locationChangeHandler) {

    $scope.filter = {
        dateRange: {
            startDate: null,
            endDate: null
        },
        state: null,
        categories: null
    };

    $scope.calendarDateRangeOptions = calendarTranslations.getDateRangeOptions();

    function restoreFilter(searchParams, toDefault) {
        if (helpers.objects.isNotEmpty(searchParams.state)) {
            $scope.filter.state = searchParams.state;
        } else {
            if (toDefault) {
                $scope.filter.state = TICKET_STATES.OPEN;
            } else {
                $scope.filter.state = null;
            }
        }
        if (helpers.objects.isNotEmpty(searchParams.date_from)) {
            $scope.filter.dateRange.startDate = helpers.dates.parseSimpleFormat(searchParams.date_from);
        } else {
            if (toDefault) {
                $scope.filter.dateRange.startDate = helpers.dates.beginOfWeek();
            } else {
                $scope.filter.dateRange.startDate = null;
            }
        }
        if (helpers.objects.isNotEmpty(searchParams.date_to)) {
            $scope.filter.dateRange.endDate = helpers.dates.parseSimpleFormat(searchParams.date_to);
        } else {
            if (toDefault) {
                $scope.filter.dateRange.endDate = helpers.dates.endOfWeek();
            } else {
                $scope.filter.dateRange.endDate = null;
            }
        }
        if (helpers.arrays.isNotEmpty(searchParams.category)) {
            $scope.filter.categories = helpers.arrays.strLineToStr(searchParams.category);
        } else {
            $scope.filter.categories = null;
        }

        return $scope.filter;
    }

    function saveParameters() {
        $scope.tableParams.parameters(ticketSearch.resolveParameters($scope.filter, $scope.tableParams.url()), true);
    }

    //to view on manual location changes like 'browser back button'
    var ticketSearchLocationChangeHandler = locationChangeHandler.create({
        onInit: function onInit(searchParams, passiveParams) {
            restoreFilter(searchParams, true);
            $scope.tableParams = ngTableCreator.create(function ($defer, params) {
                ticketSearch.executeTicketSearch($scope.filter, $defer, params);
            }, { create_date: 'desc' });
            saveParameters();
        },
        onUrlChange: function onUrlChange(searchParameters) {
            restoreFilter(searchParameters, false);
            $scope.tableParams.parameters(searchParameters, true);
            //$scope.tableParams.reload();
        },
        onParamChange: function onParamChange(searchParams) {
            $scope.tableParams.parameters(searchParams, true);
            $scope.tableParams.reload();
        },
        resolveParams: function resolveParams() {
            return ticketSearch.resolveParameters($scope.filter, $scope.tableParams.url());
        }
    });
    ticketSearchLocationChangeHandler.start();

    this.dateRangeChange = function () {
        ticketSearchLocationChangeHandler.push();
    };

    //-- state button handling
    this.filterStateIsOpen = function () {
        return $scope.filter.state === TICKET_STATES.OPEN;
    };

    this.filterStateIsClosed = function () {
        return $scope.filter.state === TICKET_STATES.CLOSED;
    };

    function rotateStates(state) {
        $scope.filter.state = state;
        ticketSearchLocationChangeHandler.push();
    }

    this.activateStateAsOpen = function () {
        rotateStates(TICKET_STATES.OPEN);
    };
    this.activateStateAsClosed = function () {
        rotateStates(TICKET_STATES.CLOSED);
    };

    //-- categories
    function rotateCategories(category) {
        //make categories "alive"
        if ($scope.filter.categories === null) {
            $scope.filter.categories = [];
        }
        if (helpers.arrays.contains($scope.filter.categories, category)) {
            $scope.filter.categories = helpers.arrays.removeItem($scope.filter.categories, category);
        } else {
            $scope.filter.categories.push(category);
        }
        ticketSearchLocationChangeHandler.push();
    }

    this.filterCategoryIsIncident = function () {
        return helpers.arrays.contains($scope.filter.categories, TICKET_CATEGORIES.INCIDENT);
    };
    this.filterCategoryIsChangeRequest = function () {
        return helpers.arrays.contains($scope.filter.categories, TICKET_CATEGORIES.CHANGE_REQUEST);
    };
    this.filterCategoryIsInformationRequest = function () {
        return helpers.arrays.contains($scope.filter.categories, TICKET_CATEGORIES.INFORMATION_REQUEST);
    };
    this.filterCategoryIsEvent = function () {
        return helpers.arrays.contains($scope.filter.categories, TICKET_CATEGORIES.EVENTS);
    };

    this.activateCategoryAsIncident = function () {
        rotateCategories(TICKET_CATEGORIES.INCIDENT);
    };
    this.activateCategoryAsChangeRequest = function () {
        rotateCategories(TICKET_CATEGORIES.CHANGE_REQUEST);
    };
    this.activateCategoryAsInformationRequest = function () {
        rotateCategories(TICKET_CATEGORIES.INFORMATION_REQUEST);
    };
    this.activateCategoryAsEvent = function () {
        rotateCategories(TICKET_CATEGORIES.EVENTS);
    };

    this.openDescription = function (ticket) {
        ticketOperationHelper.openDescription(ticket);
    };

    this.openAdd = function () {
        ticketOperationHelper.openAdd();
    };

    this.openDetail = function (ticket) {
        ticketOperationHelper.openDetail(ticket);
    };

    this.isConclusionAvailable = function (ticket) {
        return ticket.state === TICKET_STATES.DONE && helpers.strings.isNotBlank(ticket.conclusion);
    };

    this.isSearchEmpty = function () {
        return ticketSearch.isSearchEmpty();
    };
}]);

},{}],132:[function(require,module,exports){
'use strict';

angular.module('selfcare').config(["$routeProvider", function ($routeProvider) {

    $routeProvider.when('/tickets', {
        name: 'tickets',
        templateUrl: 'selfcare/routes/tickets/tickets.html',
        controller: 'TicketsController',
        controllerAs: 'ctrl',
        reloadOnSearch: false
    });

    $routeProvider.when('/add-ticket', {
        name: 'ticket-add',
        templateUrl: 'selfcare/routes/tickets/ticket-add.html',
        controller: 'TicketAddController',
        controllerAs: 'ctrl'
    });

    $routeProvider.when('/ticket-detail/:id', {
        name: 'ticket-detail',
        templateUrl: 'selfcare/routes/tickets/ticket-detail.html',
        controller: 'TicketDetailController',
        controllerAs: 'ctrl',
        resolve: {
            ticketDetail: ["TicketsDetailResource", "$route", "blockUIWrapper", function ticketDetail(TicketsDetailResource, $route, blockUIWrapper) {
                return blockUIWrapper.wrap(TicketsDetailResource.get($route.current.params.id));
            }]
        }
    });
}]);

},{}],133:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('authenticationRequiredInterceptor', ["$rootScope", "$q", function authenticationRequiredInterceptor($rootScope, $q) {

    var redirectToLoginIfNeeded = function redirectToLoginIfNeeded(response) {
        if (response.status === 403 || response.status === 401) {
            $rootScope.redirectToLogin();
        }
    };

    return {
        // optional method
        'response': function response(_response) {
            return _response;
        },
        // optional method
        'responseError': function responseError(response) {
            redirectToLoginIfNeeded(response);
            return $q.reject(response);
        }
    };
}]);

},{}],134:[function(require,module,exports){
'use strict';

require('./authentication-required-interceptor');

},{"./authentication-required-interceptor":133}],135:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('blockUIWrapper', ["$q", "blockUI", function blockUIWrapper($q, blockUI) {
    return {
        wrap: function wrap(promise) {
            blockUI.start();
            return promise.then(function (data) {
                blockUI.stop();
                return data;
            })['catch'](function (reason) {
                blockUI.stop();
                return $q.reject(reason);
            });
        }
    };
}]);

},{}],136:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('bnLanguage', ["$rootScope", "$window", "$http", "$cookieStore", "$route", "validate", "tmhDynamicLocale", "gettextCatalog", "calendarTranslations", "PAYSERA_LANGUAGES", function bnLanguage($rootScope, $window, $http, $cookieStore, $route, validate, tmhDynamicLocale, gettextCatalog, calendarTranslations, PAYSERA_LANGUAGES) {

    var DEFAULT_LANGUAGE = 'lt';
    var DEFAULT_PAYSERA_LANGUAGE = 'LIT';
    var GETTEXT_BASE_LANGUAGE = 'zz';

    $rootScope.$on('$localeChangeSuccess', function (langid, language) {
        gettextCatalog.setCurrentLanguage(language);
    });

    $rootScope.$on('gettextLanguageChanged', function () {
        validate.refresh();
    });

    return {
        init: function init() {
            var currentLanguage = this.getSystemLanguage();
            gettextCatalog.debug = true;
            gettextCatalog.baseLanguage = GETTEXT_BASE_LANGUAGE;
            this.setLanguage(currentLanguage);
        },

        setLanguage: function setLanguage(language) {
            $cookieStore.put('django_language', language);
            $http.defaults.headers.common['Accept-Language'] = language;
            tmhDynamicLocale.set(language);
        },

        getLanguage: function getLanguage() {
            return tmhDynamicLocale.get();
        },

        getPaySeraLanguage: function getPaySeraLanguage() {
            var language = this.getLanguage();
            if (PAYSERA_LANGUAGES.hasOwnProperty(language)) {
                return PAYSERA_LANGUAGES[language];
            }
            return DEFAULT_PAYSERA_LANGUAGE;
        },

        // Function to determine the browser's language setting from Pascal Precht's angular-translate
        // https://github.com/angular-translate/angular-translate/blob/master/src/service/translate.js
        getSystemLanguage: function getSystemLanguage() {
            var language = $cookieStore.get('django_language');
            if (!language) {
                language = DEFAULT_LANGUAGE;
            }
            return language;
        },

        modelTranslation: function modelTranslation(entity, property) {
            var language = this.getLanguage();
            //model fields could be translated through object attributes
            var property_lang_key = property + '_' + language;
            if (entity.hasOwnProperty(property_lang_key)) {
                return entity[property_lang_key];
            } else {
                return entity[property];
            }
        }

    };
}]);

},{}],137:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('calendarTranslations', ["gettextCatalog", function calendarTranslations(gettextCatalog) {

    var self = this;

    var getLocaleShortDays = function getLocaleShortDays() {
        var shortDays = [];
        shortDays.push(gettextCatalog.getString('S'));
        shortDays.push(gettextCatalog.getString('Pr'));
        shortDays.push(gettextCatalog.getString('A'));
        shortDays.push(gettextCatalog.getString('T'));
        shortDays.push(gettextCatalog.getString('K'));
        shortDays.push(gettextCatalog.getString('Pn'));
        shortDays.push(gettextCatalog.getString('Š'));
        return shortDays;
    };

    var getLocaleMonths = function getLocaleMonths() {
        var months = [];
        months.push(gettextCatalog.getString('Sausis'));
        months.push(gettextCatalog.getString('Vasaris'));
        months.push(gettextCatalog.getString('Kovas'));
        months.push(gettextCatalog.getString('Balandis'));
        months.push(gettextCatalog.getString('Gegužė'));
        months.push(gettextCatalog.getString('Birželis'));
        months.push(gettextCatalog.getString('Liepa'));
        months.push(gettextCatalog.getString('Rugpjūtis'));
        months.push(gettextCatalog.getString('Rugsėjis'));
        months.push(gettextCatalog.getString('Spalis'));
        months.push(gettextCatalog.getString('Lapkritis'));
        months.push(gettextCatalog.getString('Gruodis'));
        return months;
    };

    this.getDateRangeOptions = function () {
        return {
            drops: 'up',
            opens: 'right',
            locale: {
                applyLabel: gettextCatalog.getString('Pasirinkti'),
                cancelLabel: gettextCatalog.getString('Atšaukti'),
                fromLabel: gettextCatalog.getString('Nuo'),
                toLabel: gettextCatalog.getString('Iki'),
                weekLabel: gettextCatalog.getString('Savaitė'),
                daysOfWeek: getLocaleShortDays(),
                monthNames: getLocaleMonths()
            }
        };
    };

    this.getDateRangeWithTimeOptions = function () {
        return angular.extend({}, self.getDateRangeOptions(), {
            format: 'YYYY-MM-DD HH:mm:ss',
            timePicker: true,
            timePicker12Hour: false
        });
    };

    this.getDateOptions = function () {
        return {
            clearText: gettextCatalog.getString('Išvalyti'),
            currentText: gettextCatalog.getString('Šiandien'),
            closeText: gettextCatalog.getString('Atšaukti')
        };
    };
}]);

},{}],138:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('contractService', ["modelize", "bnLanguage", function contractService(modelize, bnLanguage) {

    this.sign = function (contract_id, type, personal_code, phone_number, country) {
        return modelize.$request.post('contracts/api/sign/', {
            contract_id: contract_id,
            personal_code: personal_code,
            phone_number: phone_number,
            signing_type: type,
            country: country,
            lang: bnLanguage.getLanguage().toUpperCase()
        });
    };

    this.status = function (contract_id, type, token) {
        return modelize.$request.post('contracts/api/sign/status/', {
            contract_id: contract_id,
            token: token,
            signing_type: type
        });
    };

    this.getMetadata = function (contract_id) {
        return modelize.$request.get('contracts/api/metadata/' + contract_id + '/');
    };
}]);

},{}],139:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('externalLinkResolver', ["$sce", "helpers", "bnLanguage", "EXTERNAL_LINKS", function externalLinkResolver($sce, helpers, bnLanguage, EXTERNAL_LINKS) {

    this.resolveExternalLink = function (link, language) {
        var externalLink = null;
        if (helpers.objects.isEmpty(language)) {
            language = bnLanguage.getLanguage();
        }
        if (EXTERNAL_LINKS.hasOwnProperty(link)) {
            var linkProperty = EXTERNAL_LINKS[link];
            if (linkProperty.hasOwnProperty(language)) {
                externalLink = linkProperty[language];
            } else {
                externalLink = EXTERNAL_LINKS.DEFAULT;
            }
        } else {
            externalLink = EXTERNAL_LINKS.DEFAULT;
        }
        return $sce.trustAsResourceUrl(externalLink);
    };

    this.resolveAgreementLink = function () {
        return this.resolveExternalLink('AGREEMENT');
    };

    this.resolveAboutLink = function () {
        return this.resolveExternalLink('ABOUT');
    };

    this.resolveContactsLink = function () {
        return this.resolveExternalLink('CONTACTS');
    };
}]);

},{}],140:[function(require,module,exports){
'use strict';

require('./bn-language');
require('./angular-block-ui-wrapper');
require('./calendar-translation');
require('./payment-service');
require('./pdu-management-service');
require('./no-connection-interceptor');
require('./external-link-resolver');
require('./search-delay-handler');
require('./vat-service');
require('./contract-service');

},{"./angular-block-ui-wrapper":135,"./bn-language":136,"./calendar-translation":137,"./contract-service":138,"./external-link-resolver":139,"./no-connection-interceptor":141,"./payment-service":142,"./pdu-management-service":143,"./search-delay-handler":144,"./vat-service":145}],141:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('noConnectionInterceptor', ["$rootScope", "$q", function noConnectionInterceptor($rootScope, $q) {

    var redirectToLoginIfNeeded = function redirectToLoginIfNeeded(response) {
        if (response.status === 0) {
            $rootScope.redirectToShutdownPage();
        }
    };

    return {
        // optional method
        'response': function response(_response) {
            // do something on success
            return _response;
        },
        // optional method
        'responseError': function responseError(response) {
            redirectToLoginIfNeeded(response);
            return $q.reject(response);
        }
    };
}]);

},{}],142:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('paymentService', ["modelize", "helpers", function paymentService(modelize, helpers) {

    function createProductPaymentItem(service) {

        var paymentItem = {
            quantity: 1
        };

        if (helpers.objects.isNotEmpty(service.productValue)) {
            paymentItem.price = parseFloat(service.productValue.price);
            paymentItem.ref_id = parseInt(service.productValue.ref_id);
        }
        if (helpers.objects.isNotEmpty(service.invoiceValue)) {
            paymentItem.price = parseFloat(service.invoiceValue.residual);
        }
        if (helpers.objects.isNotEmpty(service.attributes)) {
            paymentItem.attributes = service.attributes;
        }
        if (helpers.objects.isNotEmpty(service.extra)) {
            paymentItem.extra = service.extra;
        }
        if (helpers.objects.isNotEmpty(service.description)) {
            paymentItem.description = service.description;
        }
        if (helpers.objects.isNotEmpty(service.unit)) {
            paymentItem.unit = service.unit;
        }

        return paymentItem;
    }

    function createProductPayment(payment, provider) {

        var product = {
            amount: payment.totalPrice,
            amountWithVat: payment.totalPriceWithVat,
            payment_text: payment.paymentText,
            lang: payment.lang,
            items: [],
            provider: provider
        };

        if (helpers.objects.isNotEmpty(payment.unit)) {
            product.unit = payment.unit;
        }
        //return paths
        if (helpers.objects.isNotEmpty(payment.returnPathSuccess)) {
            product.return_path_success = payment.returnPathSuccess;
        }
        if (helpers.objects.isNotEmpty(payment.returnPathFailure)) {
            product.return_path_failure = payment.returnPathFailure;
        }

        angular.forEach(payment.services, function (services) {
            product.items.push(createProductPaymentItem(services));
        });

        return product;
    }

    this.executePayment = function (payment_id) {
        return modelize.$request.post('payments/api/pay/', { payment: payment_id });
    };

    this.createPayment = function (payment, provider) {
        return modelize.$request.post('payments/api/create-service/', createProductPayment(payment, provider));
    };

    this.createInvoice = function (payment, provider) {
        return modelize.$request.post('payments/api/create-invoice/', createProductPayment(payment, provider));
    };
}]);

},{}],143:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('PduManagementService', ["modelize", function (modelize) {

    var service = {
        get: get,
        post: post
    };

    return service;

    function get(unit_id) {
        console.log(unit_id);
        return modelize.$request.get('pdu/api/pdus?unit_id=' + unit_id);
    }

    function post(sockets, reason) {
        var data = {
            sockets: sockets,
            reason: reason
        };

        return modelize.$request.post('pdu/api/pdus', data);
    }
}]);

},{}],144:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('searchDelayHandler', ["helpers", "$timeout", function (helpers, $timeout) {
    var DEFAULT_DELAY = 300,
        searchTimers = {},
        self = this;
    this.search = function (name, callback, delay) {
        if (helpers.objects.isEmpty(delay)) {
            delay = DEFAULT_DELAY;
        }
        self.cancel(name);
        var timer = $timeout(function () {
            if (callback) {
                callback();
            }
        }, delay);
        searchTimers[name] = timer;
    };
    this.cancel = function (name) {
        if (searchTimers.hasOwnProperty(name)) {
            $timeout.cancel(searchTimers[name]);
            delete searchTimers[name];
        }
    };
    return self;
}]);

},{}],145:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('vatService', ["VAT_СONSTANTS", function vatService(VAT_СONSTANTS) {

    this.totalVAT = function (price) {
        return new Big(price).mul(1 + VAT_СONSTANTS.DEFAULT).round(2, 1);
    };
}]);

},{}],146:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('djangoAuth', ["djangoHttpCommon", "$cookies", "$rootScope", "$q", function djangoAuth(djangoHttpCommon, $cookies, $rootScope, $q) {

    var djangoAuthFac = {

        'authenticated': USER_AUTHENTICATED || false,
        'authPromise': null,

        loginAndGet: function loginAndGet(username, password) {

            var djangoAuth = this;
            return djangoHttpCommon.request({
                'method': 'POST',
                'url': 'authentication/api/login/',
                'data': {
                    'username': username,
                    'password': password
                }
            }).then(function (data) {
                return djangoHttpCommon.request({
                    'method': "GET",
                    'url': "authentication/api/user/"
                }).then(function (profileData) {
                    djangoAuth.authenticated = true;
                    $rootScope.$broadcast('djangoAuth.logged_in', true, profileData);
                });
            });
        },

        login: function login(username, password) {

            var djangoAuth = this;
            return djangoHttpCommon.request({
                'method': 'POST',
                'url': 'authentication/api/login/',
                'data': {
                    'username': username,
                    'password': password
                }
            }).then(function (data) {
                djangoAuth.authenticated = true;
                $rootScope.$broadcast('djangoAuth.logged_in', data);
            });
        },

        logout: function logout() {
            var djangoAuth = this;
            return djangoHttpCommon.request({
                'method': "POST",
                'url': "authentication/api/logout/"
            }).then(function (data) {
                djangoAuth.authenticated = false;
                USER_AUTHENTICATED = false;
                $rootScope.$broadcast("djangoAuth.logged_out");
            });
        },

        resetPassword: function resetPassword(username) {
            return djangoHttpCommon.request({
                'method': "POST",
                'url': "authentication/api/password/reset/",
                'data': {
                    'username': username
                }
            });
        },

        confirmReset: function confirmReset(token, password1, password2) {
            return djangoHttpCommon.request({
                'method': "POST",
                'url': "authentication/api/password/reset/confirm/",
                'data': {
                    'token': token,
                    'new_password1': password1,
                    'new_password2': password2
                }
            });
        },

        register: function register(email) {
            return djangoHttpCommon.request({
                'method': "POST",
                'url': "authentication/api/registration/",
                'data': {
                    'email': email
                }
            });
        },

        registrationConfirm: function registrationConfirm(token, user) {
            var _user = angular.copy(user);
            _user.token = token;
            return djangoHttpCommon.request({
                'method': "POST",
                'url': "authentication/api/registration/confirm/",
                'data': _user
            });
        },

        profile: function profile() {
            return djangoHttpCommon.request({
                'method': "GET",
                'url': "authentication/api/user/"
            });
        },

        updateProfile: function updateProfile(data) {
            var _user = angular.copy(data);
            return djangoHttpCommon.request({
                'method': "PATCH",
                'url': "authentication/api/user/",
                'data': _user
            }).then(function (data) {
                $rootScope.$broadcast('djangoAuth.profile_updated', _user);
            });
        },

        changeEmail: function changeEmail(email) {
            return djangoHttpCommon.request({
                'method': "POST",
                'url': "authentication/api/change-email/",
                'data': {
                    'email': email
                }
            });
        },

        changeEmailConfirm: function changeEmailConfirm(token, password) {
            var _password = angular.copy(password);
            _password.token = token;
            return djangoHttpCommon.request({
                'method': "POST",
                'url': "authentication/api/change-email/confirm/",
                'data': _password
            });
        },

        authenticationStatus: function authenticationStatus(restrict, force) {
            //Set restrict to true to reject the promise if not logged in
            //Set to false or omit to resolve when status is known
            //Set force to true to ignore stored value and query API
            restrict = restrict || false;
            force = force || false;
            var da = this;
            var getAuthStatus = $q.defer();
            if (this.authenticated !== null && !force) {
                // We have a stored value which means we can pass it back right away.
                if (this.authenticated === false && restrict) {
                    getAuthStatus.reject("User is not logged in.");
                } else {
                    getAuthStatus.resolve(this.authenticated);
                }
            } else {

                if (this.authPromise === null) {
                    this.authPromise = djangoHttpCommon.request({
                        'method': "GET",
                        'url': "authentication/api/user/logged/"
                    });
                }

                // There isn't a stored value, or we're forcing a request back to
                // the API to get the authentication status.
                this.authPromise.then(function (data) {
                    da.authenticated = data.authenticated;
                    getAuthStatus.resolve(da.authenticated);
                }, function () {
                    da.authenticated = false;
                    if (restrict) {
                        getAuthStatus.reject("User is not logged in.");
                    } else {
                        getAuthStatus.resolve(da.authenticated);
                    }
                });
            }
            return getAuthStatus.promise;
        }

    };

    return djangoAuthFac;
}]);

},{}],147:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('djangoHttpCommon', ["$q", "$http", "$cookies", "gettextCatalog", function djangoHttpCommon($q, $http, $cookies, gettextCatalog) {

    var djangoHttpCommonFac = {

        request: function request(args) {

            // Continue
            params = args.params || {};
            args = args || {};
            var deferred = $q.defer(),
                url = args.url,
                method = args.method || 'GET',
                params = params,
                data = args.data || {};
            // Fire the request, as configured.
            $http({
                url: url,
                withCredentials: true,
                method: method.toUpperCase(),
                params: params,
                data: data
            }).success(function (data, status, headers, config) {

                deferred.resolve(data, status);
            }).error(function (data, status, headers, config) {

                // Set request status
                if (data) {
                    data.status = status;
                }

                if (status === 0) {
                    if (data === '') {
                        data = {};
                        data.status = 0;
                        data.non_field_errors = [gettextCatalog.getString('Nepavyko prisijungti. Bandykite dar kartą.')];
                    }
                    // or if the data is null, then there was a timeout.
                    if (data === null) {
                        // Inject a non field error alerting the user
                        // that there's been a timeout error.
                        data = {};
                        data.status = 0;
                        data.non_field_errors = [gettextCatalog.getString('Serveris neatsiliepė. Bandykite dar kartą.')];
                    }
                }

                deferred.reject(data, status, headers, config);
            });

            return deferred.promise;
        }

    };

    return djangoHttpCommonFac;
}]);

},{}],148:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('djangoServerUtils', function djangoServerUtils() {

    function resolveTraverseErrors(data) {
        var leaves = traverse(data).reduce(function (acc, x) {

            if (this.isLeaf && this.key != 'status') {
                var _error = {};
                if (this.level > 1) {
                    _error.key = this.parent.key;
                } else {
                    _error.key = this.key;
                }
                _error.value = x;
                acc.push(_error);
            }

            return acc;
        }, []);

        var validationErrors = {},
            globalMessages = [];

        angular.forEach(leaves, function (leaf) {
            if (leaf.key === 'non_field_errors' || leaf.key === 'detail') {
                globalMessages.push(leaf.value);
            } else {
                if (!validationErrors.hasOwnProperty(leaf.key)) {
                    validationErrors[leaf.key] = [];
                }
                validationErrors[leaf.key].push(leaf.value);
            }
        });

        return {
            validationErrors: validationErrors,
            globalMessages: globalMessages
        };
    }

    function resolveSimpleErrors(data) {
        var globalMessages = [];
        var _gm = data.non_field_errors;
        if (_gm) {
            globalMessages = globalMessages.concat(_gm);
        }
        _gm = data.detail;
        if (_gm) {
            globalMessages.push(_gm);
        }
        return {
            validationErrors: data,
            globalMessages: globalMessages
        };
    }

    return {
        formatMessages: function formatMessages(data) {
            if (data === null) {
                return;
            }
            return resolveTraverseErrors(data);
        }
    };
});

},{}],149:[function(require,module,exports){
'use strict';

require('./django-http-common');
require('./django-auth');
require('./django-server-utils');

},{"./django-auth":146,"./django-http-common":147,"./django-server-utils":148}],150:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('contractOperationHelper', ["$modal", "$confirm", "$ngConfirm", "ContractsResource", "gettextCatalog", "contractService", function contractOperationHelper($modal, $confirm, $ngConfirm, ContractsResource, gettextCatalog, contractService) {

    this.openContent = function (contract, $scope, $location) {
        var url = ContractsResource.getUrl(contract.id);
        var modal_scope = $scope.$new(true, null);
        modal_scope.url = '/static/pdf-viewer/web/viewer.html?file=' + url;
        modal_scope.signing = {};
        modal_scope.signing.contract = contract;
        modal_scope.signing.control_code = null;
        modal_scope.signing.countries = [{
            code: 'LT',
            name: gettextCatalog.getString('Lietuva')
        }, {
            code: 'LV',
            name: gettextCatalog.getString('Latvija')
        }, {
            code: 'EE',
            name: gettextCatalog.getString('Estija')
        }];
        modal_scope.signing.country = 'LT';
        $ngConfirm({
            title: contract.name,
            theme: 'bootstrap',
            columnClass: 'xlarge',
            closeIcon: true,
            contentUrl: 'selfcare/routes/contracts/contract-view.html',
            scope: modal_scope,

            onClose: function onClose() {
                $location.search('open', null);
            },
            buttons: {

                cancel: {
                    text: gettextCatalog.getString('Atšaukti'),
                    btnClass: 'btn-red btn-rounded',
                    show: false,
                    action: function action(scope) {
                        scope.signing['break'] = true;
                        return false;
                    }

                },
                sign: {
                    text: gettextCatalog.getString('Pasirašyti'),
                    btnClass: 'btn-primary btn-rounded',
                    show: !contract.signed,
                    action: function action(scope) {
                        scope.signing.error = null;
                        if (is_valid()) {
                            var buttons = this.buttons;
                            var signing_type = scope.signing.variant;
                            var sing_request = sing();
                            buttons.sign.setShow(false);
                            scope.signing.loading = true;
                            sing_request.then(function (sing_result) {
                                scope.signing.loading = false;
                                buttons.cancel.setShow(true);
                                if (sing_result.status === 'ok') {
                                    scope.signing.control_code = sing_result.control_code;
                                } else {
                                    scope.signing.error = gettextCatalog.getString('Įvyko klaida, mėginkite dar kartą');
                                    reset_status();
                                }

                                check_status(100);

                                scope.signing['break'] = false;
                                scope.signing.time_left = 100;
                                var interval = setInterval(function () {
                                    scope.signing.time_left -= 5;
                                    console.log('hi', scope.signing.time_left);
                                    if (scope.signing.time_left <= 1) {
                                        clearInterval(interval);
                                        scope.signing['break'] = true;
                                        scope.signing.error = gettextCatalog.getString('Atsakymas nesulauktas. Mėginkite dar kartą.');
                                    }
                                }, 5000);

                                function check_status(count) {
                                    scope.signing.countdown = count;
                                    var status_result = contractService.status(contract.id, signing_type, sing_result.token);
                                    return status_result.then(function (status_res) {
                                        if (status_res.status === 'ok') {
                                            scope.signing.success = true;
                                            buttons.cancel.setShow(false);
                                            contract.signed = true;
                                        } else if (status_res.status === 'error') {
                                            if (status_res.error_code === 6005) {
                                                scope.signing.error = gettextCatalog.getString('Atsakymas nesulauktas. Mėginkite dar kartą.');
                                            } else {
                                                scope.signing.error = gettextCatalog.getString('Įvyko klaida, mėginkite dar kartą');
                                            }

                                            reset_status();
                                        } else if (count > 0 && !scope.signing['break'] && status_res.status === 'waiting') {
                                            setTimeout(function () {
                                                check_status(--count);
                                            }, 1000);
                                        } else if (scope.signing['break']) {
                                            reset_status();
                                        } else if (count <= 0 && !scope.signing['break']) {
                                            scope.signing.error = gettextCatalog.getString('Įvyko klaida, mėginkite dar kartą');
                                            reset_status();
                                        } else if (status_res.status === 'canceled') {
                                            scope.signing.error = gettextCatalog.getString('Pasirašymas atšauktas');
                                            reset_status();
                                        }
                                    });
                                }
                            }, function (error) {
                                scope.signing.loading = false;
                                if (error.data && error.data.status === 'error') {
                                    var error_code = error.data.error_code;
                                    if (error_code === 6006 || error_code === 6001 || error_code === 7019) {
                                        scope.signing.error = gettextCatalog.getString('Šis vartotojas neturi el. parašo');
                                    } else if (error_code === 400) {
                                        scope.signing.error = gettextCatalog.getString('Patikrinkite telefono numerį');
                                    }
                                }
                                buttons.sign.setDisabled(false);
                                if (!scope.signing.error) {
                                    scope.signing.error = gettextCatalog.getString('Įvyko klaida, mėginkite dar kartą');
                                }
                                reset_status();
                            });
                        } else {
                            scope.signing.error = gettextCatalog.getString('Užpildykite privalomus laukus');
                        }

                        function reset_status() {

                            buttons.sign.setShow(true);
                            buttons.cancel.setShow(false);
                            scope.signing.loading = false;
                            scope.signing.control_code = null;
                            scope.signing.countdown = null;
                            scope.signing.time_left = 120;
                        }

                        function is_valid() {
                            if (scope.signing.variant === 'mobile') {
                                if (scope.signing.personal_code && scope.signing.phone_number) {
                                    return true;
                                }
                            } else if (scope.signing.variant === 'smartid') {
                                if (scope.signing.personal_code && scope.signing.country) {
                                    return true;
                                }
                            }

                            return false;
                        }

                        function sing() {
                            if (scope.signing.variant === 'mobile') {
                                return contractService.sign(contract.id, 'mobile', scope.signing.personal_code, scope.signing.phone_number, null);
                            } else if (scope.signing.variant === 'smartid') {
                                return contractService.sign(contract.id, 'smartid', scope.signing.personal_code, null, scope.signing.country);
                            }
                        }

                        return false;
                    }
                }
            }
        });
    };

    this.getMetadata = function (contract_id) {
        return contractService.getMetadata(contract_id);
    };

    this.downloadContent = function (contract) {
        ContractsResource.downloadContent(contract.id);
    };
}]);

},{}],151:[function(require,module,exports){
'use strict';

require('./contract-operation-helper');

},{"./contract-operation-helper":150}],152:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('helpers', function helpers() {

    var ObjectUtils = {};
    ObjectUtils.isEmpty = function (src) {
        return src === null || src === undefined;
    };
    ObjectUtils.isNotEmpty = function (src) {
        return !ObjectUtils.isEmpty(src);
    };
    ObjectUtils.isEquals = function (src, dest) {
        return src === dest;
    };
    ObjectUtils.isAllEmpty = function () {
        var isEmpty = true;
        for (var argument in arguments) {
            isEmpty = isEmpty && ObjectUtils.isEmpty(argument);
        }
        return isEmpty;
    };
    ObjectUtils.isAllNotEmpty = function () {
        return !ObjectUtils.isAllEmpty(arguments);
    };
    ObjectUtils.values = function (src) {
        if (ObjectUtils.isEmpty(src)) {
            return [];
        }
        var keys = Object.keys(src),
            values = [];
        for (var i = 0; i < keys.length;) {
            values.push(src[keys[i]]);
            i = i + 1;
        }
        return values;
    };
    ObjectUtils.iif = function (val, valueGood, valueDefault) {
        if (ObjectUtils.isEmpty(val)) {
            return valueGood;
        } else {
            return valueDefault;
        }
    };
    ObjectUtils.getProperty = function (val, property) {
        if (ObjectUtils.isEmpty(val)) {
            return null;
        } else {
            if (val.hasOwnProperty(property)) {
                return val[property];
            } else {
                return null;
            }
        }
    };

    var ArrayUtils = {};
    ArrayUtils.strLineToInt = function (str) {
        return str.split(',').map(function (item) {
            return parseInt(item, 10);
        });
    };
    ArrayUtils.strLineToStr = function (str) {
        return str.split(',');
    };
    ArrayUtils.isEmpty = function (list) {
        if (list === null || list === undefined || list.length === 0) {
            return true;
        }
        return false;
    };
    ArrayUtils.isNotEmpty = function (list) {
        return !ArrayUtils.isEmpty(list);
    };
    ArrayUtils.remove = function (list, key) {
        list.splice(key, 1);
        return ArrayUtils.clone(list);
    };
    ArrayUtils.removeItem = function (list, item) {
        var index = list.indexOf(item);
        if (index >= 0) {
            return ArrayUtils.remove(list, index);
        }
        return list;
    };
    ArrayUtils.clone = function (list) {
        return list.slice();
    };
    ArrayUtils.compare = function (array) {
        // if the other array is a falsy value, return
        if (!array) {
            return false;
        }
        // compare lengths - can save a lot of time
        if (this.length !== array.length) {
            return false;
        }

        for (var i = 0, l = this.length; i < l;) {
            // Check if we have nested arrays
            if (this[i] instanceof Array && array[i] instanceof Array) {
                // recurse into the nested arrays
                if (!this[i].compare(array[i])) {
                    return false;
                }
            } else if (this[i] !== array[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            i = i + 1;
        }
        return true;
    };
    ArrayUtils.contains = function (array, item) {
        if (!array) {
            return false;
        }

        for (var i = 0; i < array.length;) {
            if (array[i] === item) {
                return true;
            }
            i = i + 1;
        }
        return false;
    };
    ArrayUtils.find = function (items, itemProperty, itemValue) {
        if (!items) {
            return null;
        }
        for (var i = 0; i < items.length;) {
            var item = items[i];
            if (item[itemProperty] === itemValue) {
                return item;
            }
            i = i + 1;
        }
        return null;
    };
    ArrayUtils.filter = function (items, itemProperty, itemValue) {
        if (!items) {
            return null;
        }
        var filterItems = items.filter(function (item) {
            return item[itemProperty] === itemValue;
        });
        return filterItems;
    };
    ArrayUtils.collectProps = function (items, itemProperty) {
        if (!items) {
            return null;
        }
        var collectedProperties = [];
        angular.forEach(items, function (item) {
            collectedProperties.push(item[itemProperty]);
        });
        return collectedProperties;
    };
    ArrayUtils.last = function (items) {
        if (!items || items.length === 0) {
            return null;
        }
        return items[items.length - 1];
    };

    var FunctionHandlerUtils = {};
    FunctionHandlerUtils.forEachFn = function (arr, fnName, args) {
        var i = arr.length;
        while (i >= 0) {
            var t = arr[i];
            t[fnName].apply(t, args);
            i = i - 1;
        }
    };
    FunctionHandlerUtils.forEachFnHook = function (arr, fnName) {
        arr[fnName] = function () {
            FunctionHandlerUtils.forEachFn(this, fnName, arguments);
        };
    };

    var NumberUtils = {};
    NumberUtils.roundUp = function (number, places) {
        var multiplier = Math.pow(10, places);
        return Math.round(number * multiplier) / multiplier;
    };
    NumberUtils.roundDown = function (number, places) {
        var multiplier = Math.pow(10, places);
        return Math.floor(number * multiplier) / multiplier;
    };
    NumberUtils.round = function (number, places, rm) {
        if (rm === "up") {
            return NumberUtils.roundUp(number, places);
        } else if (rm === "down") {
            return NumberUtils.roundDown(number, places);
        } else {
            return number;
        }
    };
    NumberUtils.hashDecimalPlaces = function (number) {
        return number % 1 !== 0;
    };
    NumberUtils.toFixedNumberRoot = function (number, places, rtz, rm) {
        if (number === null || number === undefined) {
            return null;
        }
        if (rm !== "none") {
            number = NumberUtils.round(number, places, rm);
        }
        var numberStr = number.toFixed(places);
        if (rtz && NumberUtils.hashDecimalPlaces(number)) {
            return numberStr.replace(/0+$/, "");
        }
        return numberStr;
    };
    NumberUtils.toFixedNumber = function (number, places) {
        return NumberUtils.toFixedNumberRoot(number, places, false);
    };
    NumberUtils.toFixedNumberWith2 = function (number) {
        return NumberUtils.toFixedNumberRoot(number, 2, false);
    };
    NumberUtils.parseInt = function (number) {
        return parseInt(number, 10);
    };
    NumberUtils.toStr = function (number) {
        if (!number) {
            return null;
        }
        return number + '';
    };
    NumberUtils.safeMultiply = function (fnum, snumb) {
        if (!fnum || !snumb) {
            return 0;
        }
        return fnum * snumb;
    };

    var RandomStringUtils = {
        CHARS: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    };

    RandomStringUtils.uuid = function (len, radix) {
        var chars = RandomStringUtils.CHARS,
            uuid = [],
            i;
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) {
                uuid[i] = chars[0 | Math.random() * radix];
            }
        } else {
            // rfc4122, version 4 form
            var r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    };
    RandomStringUtils.uuidFast = function () {
        var chars = RandomStringUtils.CHARS,
            uuid = new Array(36),
            rnd = 0,
            r;
        for (var i = 0; i < 36; i++) {
            if (i == 8 || i == 13 || i == 18 || i == 23) {
                uuid[i] = '-';
            } else if (i == 14) {
                uuid[i] = '4';
            } else {
                if (rnd <= 0x02) rnd = 0x2000000 + Math.random() * 0x1000000 | 0;
                r = rnd & 0xf;
                rnd = rnd >> 4;
                uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
            }
        }
        return uuid.join('');
    };
    RandomStringUtils.uuidCompact = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    RandomStringUtils.uuidInt = function () {
        return parseInt(RandomStringUtils.uuid(8, 10), 10);
    };
    RandomStringUtils.uuidIntNegative = function () {
        return -1 * RandomStringUtils.uuidInt();
    };
    RandomStringUtils.uuidLong = function () {
        return parseInt(RandomStringUtils.uuid(15, 10), 10);
    };
    RandomStringUtils.uuidLongNegative = function () {
        return -1 * RandomStringUtils.uuidLong();
    };

    var StringUtils = {};
    StringUtils.isBlank = function (str) {
        if (str === null) {
            str = '';
        }
        return (/^\s*$/.test(str)
        );
    };
    StringUtils.isNotBlank = function (str) {
        return !StringUtils.isBlank(str);
    };
    StringUtils.toSentence = function (array, separator, lastSeparator, serial) {
        if (array === null) {
            return '';
        }
        separator = separator || ', ';
        lastSeparator = lastSeparator || ' and ';
        var clean = [];
        for (var i = 0; i < array.length; i++) {
            if (StringUtils.isNotBlank(array[i])) {
                clean.push(array[i]);
            }
        }
        if (clean.length === 0) {
            return '';
        }
        var a = clean.slice(),
            lastMember = a.pop();

        if (clean.length > 2 && serial) {
            lastSeparator = _s.rtrim(separator) + lastSeparator;
        }

        return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
    };
    StringUtils.truncate = function (str, length, truncateStr) {
        if (str === null) {
            return '';
        }
        str = String(str);truncateStr = truncateStr || '...';
        length = ~ ~length;
        return str.length > length ? str.slice(0, length) + truncateStr : str;
    };
    StringUtils.trimToEmpty = function (str) {
        if (str === null) {
            return '';
        }
        return str.trim();
    };
    StringUtils.tldName = function (tld) {
        return '.' + tld;
    };
    StringUtils.calculateDomainName = function (domainToCheck, tld) {
        return domainToCheck + '.' + tld;
    };
    StringUtils.wordwrap = function (long_string, max_char) {

        function sum_length_of_words(word_array) {
            var out = 0;
            if (word_array.length !== 0) {
                for (var i = 0; i < word_array.length; i++) {
                    var word = word_array[i];
                    out = out + word.length;
                }
            }
            return out;
        }

        function chunkString(str, length) {
            return str.match(new RegExp('.{1,' + length + '}', 'g'));
        }

        function splitLongWord(word, maxChar) {
            var out = [];
            if (maxChar >= 1) {
                var wordArray = chunkString(word, maxChar - 1); // just one under maxChar in order to add the innerword separator '-'
                if (wordArray.length >= 1) {
                    // Add every piece of word but the last, concatenated with '-' at the end
                    for (var i = 0; i < wordArray.length - 1; i++) {
                        var piece = wordArray[i];
                        out.push(piece);
                    }
                    // finally, add the last piece
                    out.push(wordArray[wordArray.length - 1]);
                }
            }
            // If nothing done, just use the same word
            if (out.length === 0) {
                out.push(word);
            }
            return out;
        }

        var split_out = [[]];
        var split_string = long_string.split(' ');
        for (var j = 0; j < split_string.length; j++) {
            var word = split_string[j];

            // If the word itself exceed the max length, split it,
            if (word.length > max_char) {
                var wordPieces = splitLongWord(word, max_char);
                for (var jj = 0; jj < wordPieces.length; jj++) {
                    var wordPiece = wordPieces[jj];
                    split_out = split_out.concat([[]]);
                    split_out[split_out.length - 1] = split_out[split_out.length - 1].concat(wordPiece);
                }
            } else {
                // otherwise add it if possible
                if (sum_length_of_words(split_out[split_out.length - 1]) + word.length > max_char) {
                    split_out = split_out.concat([[]]);
                }

                split_out[split_out.length - 1] = split_out[split_out.length - 1].concat(word);
            }
        }

        for (var i = 0; i < split_out.length; i++) {
            split_out[i] = split_out[i].join(' ');
        }

        return split_out.join('\n');
    };

    var DateUtils = {};
    DateUtils.simpleFormat = function (date) {
        if (ObjectUtils.isEmpty(date)) {
            return null;
        }
        return moment(date).format("YYYY-MM-DD");
    };
    DateUtils.dateAndTimeFormat = function (date) {
        if (ObjectUtils.isEmpty(date)) {
            return null;
        }
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
    };
    DateUtils.parseSimpleFormat = function (date) {
        if (ObjectUtils.isEmpty(date)) {
            return null;
        }
        return moment(date, "YYYY-MM-DD");
    };
    DateUtils.parseISOFormat = function (date) {
        if (ObjectUtils.isEmpty(date)) {
            return null;
        }
        return moment(date, "YYYY-MM-DD HH:mm:ssZ");
    };
    DateUtils.getDaysBefore = function (date, days) {
        return moment(date).subtract('days', days);
    };
    DateUtils.getDaysAfter = function (date, days) {
        return moment(date).add('days', days);
    };
    DateUtils.daysTillToday = function (start) {
        return moment().startOf('day').diff(start, 'days');
    };
    DateUtils.startOfTheDay = function () {
        return moment().startOf('day');
    };
    DateUtils.endOfTheDay = function () {
        return moment().endOf('day');
    };
    DateUtils.now = function () {
        return moment();
    };
    DateUtils.getYesterday = function () {
        return DateUtils.getDaysBefore(DateUtils.now(), 1);
    };
    DateUtils.nowAsStr = function () {
        return DateUtils.simpleFormat(DateUtils.now());
    };
    DateUtils.getYearBefore = function () {
        return moment().subtract(1, 'year');
    };
    DateUtils.getYearBeforeAsStr = function () {
        return DateUtils.simpleFormat(DateUtils.getYearBefore());
    };
    DateUtils.getHalfYearBefore = function () {
        return moment().subtract(5, 'month');
    };
    DateUtils.getMonthBefore = function () {
        return moment().subtract(1, 'month');
    };
    DateUtils.getSevenMonthBefore = function () {
        return moment().subtract(6, 'month');
    };
    DateUtils.getHalfYearBeforeAsStr = function () {
        return DateUtils.simpleFormat(DateUtils.getHalfYearBefore());
    };
    DateUtils.getMonthBeforeAsStr = function () {
        return DateUtils.simpleFormat(DateUtils.getMonthBefore());
    };
    DateUtils.getSevenMonthBeforeAsStr = function () {
        return DateUtils.simpleFormat(DateUtils.getSevenMonthBefore());
    };
    DateUtils.beginOfWeek = function () {
        return moment().day(1);
    };
    DateUtils.endOfWeek = function () {
        return moment().day(7);
    };
    DateUtils.startOfTheDayAsStrDateAndTime = function () {
        return DateUtils.dateAndTimeFormat(DateUtils.startOfTheDay());
    };
    DateUtils.endOfTheDayAsStrDateAndTime = function () {
        return DateUtils.dateAndTimeFormat(DateUtils.endOfTheDay());
    };
    DateUtils.nowAsStrDateAndTime = function () {
        return DateUtils.dateAndTimeFormat(DateUtils.now());
    };

    var BooleanUtils = {};
    BooleanUtils.ands = function () {
        var result = true;
        angular.forEach(arguments, function (argument) {
            result = result && argument;
        });
        return result;
    };
    BooleanUtils.ors = function () {
        var result = false;
        angular.forEach(arguments, function (argument) {
            result = result || argument;
        });
        return result;
    };

    var TextToHtmlParser = new StrParser();
    TextToHtmlParser.addPreset("break", function (newLine) {
        return newLine + "<br/>";
    });
    TextToHtmlParser.addPreset("url", function (link) {
        var display = link.replace(/^https?:\/\//i, "").replace(/^www\./i, "").replace(/\/$/i, "");
        return "<a href=\"" + link + "\">" + display + "</a>";
    });
    TextToHtmlParser.addPreset("email", function (email) {
        return "<a href=\"mailto:" + email + "\">" + email + "</a>";
    });

    var MoneyUtils = {};
    MoneyUtils.addMoney = function (a, b) {
        return new Big(a).add(new Big(b)).round(2, 1);
    };
    MoneyUtils.toMoney = function (a) {
        return new Big(a).round(2, 1);
    };

    var RouteUtils = {};
    RouteUtils.interpolatePath = function (path, params) {
        var result = [];
        angular.forEach((path || '').split(':'), function (segment, i) {
            if (i === 0) {
                result.push(segment);
            } else {
                var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
                var key = segmentMatch[1];
                result.push(params[key]);
                result.push(segmentMatch[2] || '');
                delete params[key];
            }
        });
        return result.join('');
    };

    var _helpers = {};
    _helpers.numbers = NumberUtils;
    _helpers.arrays = ArrayUtils;
    _helpers.objects = ObjectUtils;
    _helpers.functionHandlers = FunctionHandlerUtils;
    _helpers.randomString = RandomStringUtils;
    _helpers.strings = StringUtils;
    _helpers.dates = DateUtils;
    _helpers.booleans = BooleanUtils;
    _helpers.txt2Parser = TextToHtmlParser;
    _helpers.money = MoneyUtils;
    _helpers.routes = RouteUtils;

    return _helpers;
});

},{}],153:[function(require,module,exports){
'use strict';

require('./products');
require('./services');
require('./invoices');
require('./helpers');
require('./parameter-helper');
require('./location-change-handler');
require('./wizard-handler-helper');
require('./menu-helpers');
require('./contracts');

},{"./contracts":151,"./helpers":152,"./invoices":154,"./location-change-handler":156,"./menu-helpers":157,"./parameter-helper":158,"./products":159,"./services":161,"./wizard-handler-helper":167}],154:[function(require,module,exports){
'use strict';

require('./invoice-operation-helper');

},{"./invoice-operation-helper":155}],155:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('invoiceOperationHelper', ["$modal", "$confirm", "$ngConfirm", "InvoicesResource", "blockUIWrapper", "paymentService", "flash", "poster", "gettextCatalog", "INVOICE_STATES", "INVOICE_LOCAL_LOCK", function invoiceOperationHelper($modal, $confirm, $ngConfirm, InvoicesResource, blockUIWrapper, paymentService, flash, poster, gettextCatalog, INVOICE_STATES, INVOICE_LOCAL_LOCK) {

    this.openContent = function (invoice) {
        InvoicesResource.openContent(invoice.id);
    };

    this.downloadContent = function (invoice) {
        InvoicesResource.downloadContent(invoice.id);
    };

    function executeInvoicePayment(invoicePayment, provider) {

        var invoiceCreatePromise = blockUIWrapper.wrap(paymentService.createInvoice(invoicePayment, provider));

        invoiceCreatePromise.then(function (data) {
            var service_post_data = data.service_post_data;

            var buyServicePromise = blockUIWrapper.wrap(paymentService.executePayment(service_post_data.payment_id));
            buyServicePromise.then(function (data) {
                console.log(JSON.stringify(data));
                flash.info(gettextCatalog.getString('Inicijuojamas mokėjimas. Luktelėkite...'));
                if (data.provider === 'PAYSERA') {
                    poster.postForm(data.payment_post_data);
                } else if (data.provider === 'PAYPAL') {
                    window.location.href = data.payment_post_data;
                }
            }, function (response) {
                flash.server(response.data);
            });
        }, function (response) {
            flash.server(response.data);
        });
    }

    this.pay = function (invoicePayment) {
        $confirm({
            text: gettextCatalog.getString('Jeigu mokėjimą atlikote ne iš Automatinės paslaugų valdymo sistemos (myportal.balt.net) puslapio, Jūsų mokėjimas bus užskaitytas per kelias darbo dienas. Prašome nekartoti mokėjimo.'),
            title: gettextCatalog.getString('Patvirtinkite'),
            ok: gettextCatalog.getString('Mokėti'),
            cancel: gettextCatalog.getString('Atšaukti')
        }).then(function () {
            $ngConfirm({
                title: gettextCatalog.getString('Pasirinkite mokėjimo būdą'),
                content: '',
                theme: 'bootstrap',
                columnClass: 'medium',
                closeIcon: true,

                buttons: {
                    // long hand button definition
                    paysera: {
                        text: " ",
                        btnClass: 'btn-primary btn-paysera',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function action(scope) {
                            executeInvoicePayment(invoicePayment, 'PAYSERA');
                        }
                    },
                    paypal: {
                        text: " ",
                        btnClass: 'btn-primary btn-paypal',
                        keys: ['enter'], // will trigger when enter is pressed
                        action: function action(scope) {
                            executeInvoicePayment(invoicePayment, 'PAYPAL');
                        }
                    }

                }
            });
        });
    };

    /*close: {
        text: gettextCatalog.getString('Atšaukti'),
         btnClass: 'btn-payment-choice',
        action: function (scope) {
         }
    }*/
    this.isPaymentAvailable = function (invoice) {
        return (invoice.state === INVOICE_STATES.PRO || invoice.state === INVOICE_STATES.OPEN) && invoice.local_lock === INVOICE_LOCAL_LOCK.UNLOCKED;
    };

    this.isConclusionAvailable = function (invoice) {
        return invoice.local_lock === INVOICE_LOCAL_LOCK.LOCKED && invoice.state !== INVOICE_STATES.PAID;
    };
}]);

},{}],156:[function(require,module,exports){
/*
 * Location handler - helper to watch $location changes.
 * Only unique changes would be fired to 'onUrlChange' callback.
 *
 * Notes.
 *  - Private methods are marked wih underscore
 */

'use strict';

angular.module('selfcare').factory('locationChangeHandler', ['$location', '$rootScope', '$timeout', function locationChangeHandler($location, $rootScope, $timeout) {

    function LocationWatcher(id) {
        var self = this;
        var state = {
            id: id,
            onInit: null,
            onUrlChange: null,
            onParamChange: null,
            resolveParams: null,
            block: true,
            flush: false
        };
        this.ready = function (registration) {
            self._init(registration);
            return self;
        };
        this._init = function (registration) {
            state.onInit = registration.onInit;
            state.onUrlChange = registration.onUrlChange;
            state.onParamChange = registration.onParamChange;
            state.resolveParams = registration.resolveParams;
            state.block = true;
            return self;
        };
        this._changeWatch = function () {
            if (state.block) {
                return;
            }
            if (state.flush) {
                state.flush = false;
                return;
            }
            var searchParams = $location.search(),
                controllerParams = self._resolveControllerParameters();
            if (angular.equals(controllerParams, searchParams)) {
                return;
            }
            self._applyUrlChange(searchParams);
        };
        this._resolveControllerParameters = function () {
            if (state.resolveParams) {
                return state.resolveParams();
            }
            return null;
        };
        this._applyUrlChange = function (searchParams) {
            if (state.onUrlChange) {
                state.onUrlChange(searchParams);
            }
        };
        this._applyParamChange = function (searchParams) {
            if (state.onParamChange) {
                state.onParamChange(searchParams);
            }
        };
        this.push = function () {
            if (state.block) {
                return;
            }
            var searchParams = $location.search(),
                controllerParams = self._resolveControllerParameters();
            if (angular.equals(controllerParams, searchParams)) {
                return;
            }
            self._applyParamChange(controllerParams);
            $location.search(controllerParams);
        };
        this._dropPassives = function (passives) {
            if (passives) {
                angular.forEach(passives, function (passive) {
                    $location.search(passive, null);
                });
            }
        };
        this._parsePassives = function (passives) {
            var passiveParams = null;
            if (passives) {
                passiveParams = {};
                var searchParams = $location.search();
                angular.forEach(passives, function (passive) {
                    var paramValue = searchParams[passive];
                    if (ObjectUtils.isNotEmpty(paramValue)) {
                        passiveParams[passive] = paramValue;
                    }
                });
            }
            return passiveParams;
        };
        this.start = function (passives) {
            var passiveParams = null,
                searchParams = null;
            if (passives) {
                passiveParams = self._parsePassives(passives);
                self._dropPassives(passives);
            }
            searchParams = $location.search();
            if (state.onInit) {
                //TODO may we need to use callbacks
                $timeout(function () {
                    state.onInit(searchParams, passiveParams);
                    self.unBlock();
                });
            } else {
                self.unBlock();
            }
        };
        this.flush = function () {
            if (state.block) {
                return;
            }
            state.flush = true;
            $location.search({});
        };
        this.block = function () {
            state.block = true;
        };
        this.unBlock = function () {
            state.block = false;
        };
    }

    var locationWatcher = new LocationWatcher('_locationWatcher');

    $rootScope.$on('$locationChangeSuccess', function (event, o, n) {
        locationWatcher._changeWatch();
    });

    return {
        create: function create(registration) {
            return locationWatcher.ready(registration);
        }
    };
}]);

},{}],157:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('menuHelper', ["$q", "ServicesResource", "helpers", function menuHelper($q, ServicesResource, helpers) {

    function prepareMenuContext(serviceData) {
        var menuContext = { permittedMenuItems: [], restrictedMenuItems: [] };
        if (serviceData !== null && serviceData.length > 0) {
            menuContext.permittedMenuItems.push('rp-itp');
        } else {
            menuContext.restrictedMenuItems.push('rp-itp');
        }
        return menuContext;
    }

    this.resolveContext = function () {
        var menuContextDefer = $q.defer();
        ServicesResource.query({ category: 'its' }).then(function (data) {
            menuContextDefer.resolve(prepareMenuContext(data));
        }, function (response) {
            menuContextDefer.reject(response);
        });
        return menuContextDefer.promise;
    };
}]);

},{}],158:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('parameterHelper', function plansHelpers() {

    this.slugParam = function (parameter) {
        return parameter.replace(/-/g, '_');
    };
});

},{}],159:[function(require,module,exports){
'use strict';

require('./product-helper');

},{"./product-helper":160}],160:[function(require,module,exports){
'use strict';

var PRODUCT_SORT_FTN = function PRODUCT_SORT_FTN(firstS, secondS) {
    if (firstS.index > secondS.index) {
        return 1;
    } else if (firstS.index < secondS.index) {
        return -1;
    } else {
        return 0;
    }
};

angular.module('selfcare').service('productHelpers', ["helpers", "PRODUCT_TYPE", function productHelpers(helpers, PRODUCT_TYPE) {
    var self = this;

    //attribute maker
    this.createAttributeValue = function (attribute) {
        var attributeValue = {};
        attributeValue.code = attribute.code;
        switch (attribute.type) {
            case 'char':
                attributeValue.name = null;
                attributeValue.value = null;
                break;
            case 'integer':
                attributeValue.name = parseInt(attribute.max_value);
                attributeValue.value = parseInt(attribute.max_value);
                break;
            case 'selection':
                var selections = attribute.selections;
                attributeValue.value = selections[0].code;
                attributeValue.selections = selections;
                break;
            default:
                attributeValue.name = null;
                attributeValue.value = null;
                break;
        }
        return attributeValue;
    };
    this.getValue = function (attributes, attributeCode) {
        var attribute = helpers.arrays.find(attributes, 'code', attributeCode);
        if (attribute === null || attribute === undefined) {
            return null;
        }
        return this.createAttributeValue(attribute);
    };

    //product value maker
    this.createProductValue = function (product, unit_type) {
        var productValue = null;
        switch (unit_type) {
            case PRODUCT_TYPE.OPEN_VZ_SERVICE:
                {
                    productValue = {
                        name: product.name,
                        name_lt: product.name_lt,
                        name_en: product.name_en,
                        name_ru: product.name_ru,

                        id: helpers.randomString.uuidLong(),
                        price: product.price,
                        ref_id: product.ref_id,

                        index: product.index,

                        cpu: product.cpu,
                        ram: product.ram,
                        hdd: product.hdd,
                        ip: product.ip,
                        os: product.os,
                        host: product.host
                    };
                    break;
                }
            case PRODUCT_TYPE.WEB_SERVICE:
                {
                    productValue = {
                        name: product.name,
                        name_lt: product.name_lt,
                        name_en: product.name_en,
                        name_ru: product.name_ru,

                        id: helpers.randomString.uuidLong(),
                        price: product.price,
                        ref_id: product.ref_id,

                        index: product.index,

                        email: product.email,
                        server: product.server,

                        template: product.html_template,
                        template_lt: product.html_template_lt,
                        template_en: product.html_template_en,
                        template_ru: product.html_template_ru
                    };
                    break;
                }
            case PRODUCT_TYPE.DOMAIN_NAME:
                {
                    productValue = {
                        name: product.name,
                        name_lt: product.name_lt,
                        name_en: product.name_en,
                        name_ru: product.name_ru,

                        id: helpers.randomString.uuidLong(),
                        price: product.price,
                        ref_id: product.ref_id,

                        index: product.index
                    };
                    break;
                }
            default:
                {
                    break;
                }
        }
        return productValue;
    };
    this.getProductValues = function (products, unit_type) {
        var productValues = [];
        products.sort(PRODUCT_SORT_FTN);
        angular.forEach(products, function (product) {
            productValues.push(self.createProductValue(product, unit_type));
        });
        return productValues;
    };

    //payment setter
    this.createPaymentAttribute = function (value) {
        if (!value) {
            return null;
        }
        var paymentAttribute = {};
        paymentAttribute[value.code] = value.value;
        return paymentAttribute;
    };
    this.getPaymentAttributes = function (productValue, unit_type) {
        var paymentAttributes = {};
        switch (unit_type) {
            case PRODUCT_TYPE.OPEN_VZ_SERVICE:
                {
                    paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productValue.cpu));
                    paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productValue.ram));
                    paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productValue.hdd));
                    paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productValue.ip));
                    paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productValue.os));

                    var productHost = productValue.hasOwnProperty('host') ? productValue.host : null;
                    if (helpers.objects.isNotEmpty(productHost) && helpers.objects.isNotEmpty(productHost.value) && productHost.value !== '') {
                        paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productHost));
                    }
                    break;
                }
            case PRODUCT_TYPE.WEB_SERVICE:
                {
                    paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productValue.server));

                    var productEmail = productValue.hasOwnProperty('email') ? productValue.email : null;
                    if (helpers.objects.isNotEmpty(productEmail) && helpers.objects.isNotEmpty(productEmail.value) && productEmail.value !== '') {
                        paymentAttributes = angular.extend(paymentAttributes, self.createPaymentAttribute(productEmail));
                    }

                    break;
                }
            default:
                {
                    break;
                }
        }
        return paymentAttributes;
    };

    this.assignServiceUnitValue = function (service_units, value) {
        var service_unit = helpers.arrays.find(service_units, 'code', value.code);
        if (service_unit) {
            service_unit.current.name = value.name;
            service_unit.current.value = value.value;
        }
    };

    this.assignServiceUnitValues = function (productValue, serviceDetail) {
        //assign new price
        serviceDetail.current_tariff = parseFloat(productValue.price);

        //assign new parameters
        this.assignServiceUnitValue(serviceDetail.service_units, productValue.cpu);
        this.assignServiceUnitValue(serviceDetail.service_units, productValue.ram);
        this.assignServiceUnitValue(serviceDetail.service_units, productValue.hdd);

        return serviceDetail;
    };
}]);

},{}],161:[function(require,module,exports){
'use strict';

require('./service-unit-helpers');
require('./service-state-helpers');
require('./service-operation-helpers');
require('./ticket-operation-helpers');
require('./report-operation-helpers');

},{"./report-operation-helpers":162,"./service-operation-helpers":163,"./service-state-helpers":164,"./service-unit-helpers":165,"./ticket-operation-helpers":166}],162:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('reportCreateHelper', ["modelize", "blockUIWrapper", "VoipReportResource", function reportCreateHelper(modelize, blockUIWrapper, VoipReportResource) {

    this.createVoipReport = function (report) {
        return blockUIWrapper.wrap(VoipReportResource.$new(report).save());
    };

    this.deleteReport = function (report) {
        return blockUIWrapper.wrap(VoipReportResource.$new(report).destroy({ wait: true }));
    };
}]);

angular.module('selfcare').service('reportOperationHelper', ["API_PATHS", "helpers", function reportOperationHelper(API_PATHS, helpers) {

    this.downloadReport = function (reportType, period) {
        window.open(API_PATHS.REPORT_PATHS.REPORT_DOWNLOAD + reportType + '/?period=' + helpers.dates.simpleFormat(period), '_blank');
    };
}]);

},{}],163:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('serviceCreateHelper', ["modelize", "blockUIWrapper", "API_PATHS", function serviceCreateHelper(modelize, blockUIWrapper, API_PATHS) {

    this.deleteDNSZoneRecord = function (zone, record) {
        return blockUIWrapper.wrap(modelize.$request['delete'](API_PATHS.SERVICE_PATHS.SERVICE_DNS_ZONE_RECORD_API + zone.id + '/' + record.dns_rec_no));
    };

    this.updateDNSZoneRecord = function (zone, record) {
        return blockUIWrapper.wrap(modelize.$request.put(API_PATHS.SERVICE_PATHS.SERVICE_DNS_ZONE_RECORD_API + zone.id + '/' + record.dns_rec_no, record));
    };

    this.createDNSZoneRecord = function (zone, record) {
        return blockUIWrapper.wrap(modelize.$request.post(API_PATHS.SERVICE_PATHS.SERVICE_DNS_ZONE_RECORD_API + zone.id, record));
    };

    this.graph = function (service, params) {
        return blockUIWrapper.wrap(modelize.$request.get(API_PATHS.SERVICE_PATHS.GRAPH_API + service.id, { params: params }));
    };

    this.checkDomain = function (domain) {
        return blockUIWrapper.wrap(modelize.$request.get(API_PATHS.PRODUCT_PATHS.CHECK_DOMAIN_API, { params: { domain: domain } }));
    };
}]);

angular.module('selfcare').service('serviceLoginHelper', ["modelize", "poster", "flash", "blockUIWrapper", "gettextCatalog", "$timeout", function serviceLoginHelper(modelize, poster, flash, blockUIWrapper, gettextCatalog, $timeout) {

    var createDirectAdminData = function createDirectAdminData(data) {
        var directAdminData = {};
        directAdminData.action = data.login_url;
        directAdminData.target = '_self';
        directAdminData.fields = {
            'username': data.username,
            'password': data.password
        };
        return directAdminData;
    };

    this.directAdminLogin = function (serviceId) {
        var redirectWindow = window.open('/common/poster-wait/', '_blank');
        modelize.$request.get('services/api/direct-admin/' + serviceId).then(function (data) {
            var postStr = Base64.encode(JSON.stringify(createDirectAdminData(data)));
            redirectWindow.location = '/common/poster/?post=' + postStr;
        }, function (response) {
            flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
            redirectWindow.close();
        });
    };

    this.getNewDirectAdminPassword = function (serviceId) {
        return blockUIWrapper.wrap(modelize.$request.get('services/api/direct-admin-new-password/' + serviceId));
    };
}]);

angular.module('selfcare').service('serviceOperationHelper', ["PRODUCT_CATEGORIES", "SERVICE_OPERATIONS", "PRODUCT_LIST_TYPES", "$modal", "namedRouteService", "serviceLoginHelper", "helpers", "gettextCatalog", function serviceOperationHelper(PRODUCT_CATEGORIES, SERVICE_OPERATIONS, PRODUCT_LIST_TYPES, $modal, namedRouteService, serviceLoginHelper, helpers, gettextCatalog) {

    function graphModal(service, parameters) {
        var modalInstance = $modal.open({
            animation: true,
            backdrop: 'static',
            size: 'clg',
            templateUrl: 'selfcare/routes/services/service-graph-modal.html',
            controller: 'ServiceGraphCtrl',
            controllerAs: 'ghCtrl',
            resolve: {
                graphData: ["serviceCreateHelper", function graphData(serviceCreateHelper) {
                    return serviceCreateHelper.graph(service, parameters).then(function (data) {
                        return data;
                    }, function (response) {
                        return response;
                    });
                }],
                graphService: function graphService() {
                    return service;
                }
            }
        });

        return modalInstance;
    }

    function vdsChangeModal(_currentDetail, _newProductValue) {
        var modalInstance = $modal.open({
            animation: true,
            backdrop: 'static',
            size: 'lg',
            templateUrl: 'selfcare/routes/services/service-virtual-dedicated-server-change-modal.html',
            controller: 'ServiceVirtualDedicatedServerChangeController',
            controllerAs: 'chCtrl',
            resolve: {
                currentDetail: function currentDetail() {
                    return _currentDetail;
                },
                newProductValue: ["serviceCreateHelper", function newProductValue(serviceCreateHelper) {
                    return _newProductValue;
                }]
            }
        });

        return modalInstance;
    }

    function changeDirectAdminPasswordModal(_service) {
        var modalInstance = $modal.open({
            animation: true,
            backdrop: 'static',
            size: 'clg',
            templateUrl: 'selfcare/routes/services/service-direct-admin-change-password-modal.html',
            controller: 'ServiceDirectAdminChangePasswordCtrl',
            controllerAs: 'dacpCtrl',
            resolve: {
                newPassword: ["serviceLoginHelper", function newPassword(serviceLoginHelper) {
                    return serviceLoginHelper.getNewDirectAdminPassword(_service.id);
                }],
                service: function service() {
                    return _service;
                }
            }
        });

        return modalInstance;
    }

    this.operationSequence = function (service) {
        var operationSequence = [];
        switch (service.categoryId) {
            case PRODUCT_CATEGORIES.HOSTING_DOMAIN:
                operationSequence.push({ operation: SERVICE_OPERATIONS.EDIT,
                    title: gettextCatalog.getString('Redaguoti DNS') });
                break;
            case PRODUCT_CATEGORIES.HOSTING_DIRECT_ADMIN:
                operationSequence.push({ operation: SERVICE_OPERATIONS.LOGIN,
                    title: gettextCatalog.getString('Valdymo skydelis') });
                operationSequence.push({ operation: SERVICE_OPERATIONS.CHANGE_PASSWORD,
                    title: gettextCatalog.getString('Keisti slaptažodį') });
                break;
            case PRODUCT_CATEGORIES.IASS_RESOURCE_POOL:
                operationSequence.push({ operation: SERVICE_OPERATIONS.EDIT,
                    title: gettextCatalog.getString('Redaguoti') });
                break;
            case PRODUCT_CATEGORIES.VDS_OPEN_VZ:
                operationSequence.push({ operation: SERVICE_OPERATIONS.EDIT,
                    title: gettextCatalog.getString('Redaguoti') });
                break;
            default:
                break;
        }
        return operationSequence;
    };

    this.operations = function (categoryId) {
        var operation = {},
            currentOperation = null,
            operationSequence = this.operationSequence(categoryId);
        operation.operationSequence = operationSequence;

        currentOperation = helpers.arrays.find(operationSequence, 'operation', SERVICE_OPERATIONS.EDIT);
        operation.couldEdit = currentOperation ? true : false;
        operation.couldEditTitle = currentOperation ? currentOperation.title : '';

        currentOperation = helpers.arrays.find(operationSequence, 'operation', SERVICE_OPERATIONS.LOGIN);
        operation.couldLogin = currentOperation ? true : false;
        operation.couldLoginTitle = currentOperation ? currentOperation.title : '';

        currentOperation = helpers.arrays.find(operationSequence, 'operation', SERVICE_OPERATIONS.CHANGE_PASSWORD);
        operation.couldChangePassword = currentOperation ? true : false;
        operation.couldChangePasswordTitle = currentOperation ? currentOperation.title : '';

        return operation;
    };

    this.login = function (service) {
        switch (service.categoryId) {
            case PRODUCT_CATEGORIES.HOSTING_DIRECT_ADMIN:
                serviceLoginHelper.directAdminLogin(service.id);
                break;
            default:
                break;
        }
    };

    this.changePassword = function (service) {
        switch (service.categoryId) {
            case PRODUCT_CATEGORIES.HOSTING_DIRECT_ADMIN:
                changeDirectAdminPasswordModal(service);
                break;
            default:
                break;
        }
    };

    this.edit = function (service) {
        switch (service.categoryId) {
            case PRODUCT_CATEGORIES.IASS_RESOURCE_POOL:
                namedRouteService.open('service-resource-pool-detail', service.id);
                break;
            case PRODUCT_CATEGORIES.VDS_OPEN_VZ:
                namedRouteService.open('service-virtual-dedicated-server-detail', service.id);
                break;
            case PRODUCT_CATEGORIES.HOSTING_DOMAIN:
                namedRouteService.open('service-dns-zone-detail', service.domainId);
                break;
            case PRODUCT_CATEGORIES.HOSTING_PDU_MANAGEMENT:
                console.log(service);
                namedRouteService.open('services-pdu-management', [service.info.dc_server_id.join(','), 'dc-colo']);
                break;
            default:
                break;
        }
    };

    this.reboot = function (service) {
        console.log(service.categoryId);
        switch (service.categoryId) {
            case PRODUCT_CATEGORIES.HOSTING_PDU_MANAGEMENT:
                console.log(service);
                namedRouteService.open('services-pdu-management', [service.info.dc_server_id.join(','), 'dc-colo']);
                break;
            case PRODUCT_CATEGORIES.DEDICATED_SERVERS:
                console.log(service);
                namedRouteService.open('services-pdu-management', [service.info.dc_server_id.join(','), 'dc-dedi']);
                break;
            default:
                break;
        }
    };

    this.add = function (type) {
        switch (type) {
            case PRODUCT_LIST_TYPES.VDS:
                namedRouteService.open('service-add-virtual-dedicated-server', { progress: 'new' });
                break;
            case PRODUCT_LIST_TYPES.HOSTING:
                namedRouteService.open('service-add-hosting-server', { progress: 'new' });
                break;
            case PRODUCT_LIST_TYPES.DOMAIN:
                namedRouteService.open('service-add-domain', { progress: 'new' });
                break;
            default:
                break;
        }
    };

    this.graph = function (service) {
        return graphModal(service, { date_from: helpers.dates.startOfTheDayAsStrDateAndTime(), date_to: helpers.dates.nowAsStrDateAndTime() });
    };

    this.changeVds = function (currentDetail, newProductValue) {
        return vdsChangeModal(currentDetail, newProductValue);
    };
}]);

},{}],164:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('serviceStateHelper', ["SERVICE_STATES", function serviceStateHelper(SERVICE_STATES) {

    this.editModeStates = function (service) {
        var editStates = {};
        editStates.realState = service.state;
        editStates.isEditable = service.state !== SERVICE_STATES.DRAFT && service.state !== SERVICE_STATES.TEMPORARY_LOCK;
        editStates.isNotEditable = !editStates.isEditable;
        return editStates;
    };
}]);

},{}],165:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('serviceUnitHelper', ["$log", "helpers", "PRODUCT_ATTRIBUTES", function serviceUnitHelper($log, helpers, PRODUCT_ATTRIBUTES) {

    var self = this;

    this.getConfUnitAttribute = function (conf_units, attribute) {
        if (!conf_units.hasOwnProperty(attribute)) {
            return null;
        }
        return conf_units[attribute];
    };

    // - price calculations
    this.getCurrentServiceUnits = function (service_units) {
        var currentServiceUnis = [];
        angular.forEach(service_units, function (service_unit) {
            currentServiceUnis.push({
                code: service_unit.code, value: service_unit.current.value
            });
        });
        return currentServiceUnis;
    };

    this.currentOfPackage = function (spackages, currents) {
        var currentValue = {};
        angular.forEach(spackages, function (spackage) {
            var cValues = helpers.arrays.find(currents, 'code', spackage);
            if (helpers.arrays.isNotEmpty(cValues)) {
                currentValue[spackage] = String(cValues.value);
            }
        });
        return currentValue;
    };

    this.mergeAttributeValueInterest = function (avtList) {
        var interest = {};
        angular.forEach(avtList, function (avt) {
            interest = angular.extend(interest, avt);
        });
        return interest;
    };

    this.priceOfPackage = function (pricePackage, priceList, currents) {
        var self = this;
        var currentValues = this.currentOfPackage(pricePackage, currents);

        var packagePrice = 0;
        angular.forEach(priceList, function (price) {
            if (angular.equals(price.attributes, pricePackage) && angular.equals(self.mergeAttributeValueInterest(price.attribute_value_interests), currentValues)) {
                packagePrice = parseFloat(price.price);
            }
        });
        return packagePrice;
    };

    this.getServicePrice = function (calculationScope) {
        var servicePrice = 0;
        angular.forEach(calculationScope.pricePackages, function (pricePackage) {
            var packagePrice = self.priceOfPackage(pricePackage, calculationScope.priceList, calculationScope.currents);
            servicePrice = servicePrice + packagePrice;
        });

        return servicePrice;
    };

    this.getVirtualDedicatedServerPrice = function (calculationScope) {
        var servicePrice = this.getServicePrice(calculationScope);
        if (servicePrice > 0) {
            return parseFloat(calculationScope.current_tariff) + servicePrice;
        } else {
            return parseFloat(calculationScope.current_tariff);
        }
        return servicePrice;
    };

    this.getArgumentExpression = function (priceExtensions, argumentName) {
        var arg = helpers.arrays.find(priceExtensions, 'argument', argumentName);
        if (arg === null || arg === undefined) {
            return null;
        }
        return JSON.parse(arg.expression);
    };

    this.getArgumentZPrice = function (calculationScope) {
        //$log.info('Calculating price argument Z of the scope ' + JSON.stringify(calculationScope));

        var argExpression = this.getArgumentExpression(calculationScope.priceExtensions, 'z');
        if (argExpression === null || argExpression === undefined) {
            //$log.warn('Price expression is not set');
            return 0;
        }

        // resolve backup, hdd, ssd
        var backup = helpers.arrays.find(calculationScope.currents, 'code', PRODUCT_ATTRIBUTES.VMW_SERVICE.BACKUP),
            hdd = helpers.arrays.find(calculationScope.currents, 'code', PRODUCT_ATTRIBUTES.VMW_SERVICE.HDD),
            ssd = helpers.arrays.find(calculationScope.currents, 'code', PRODUCT_ATTRIBUTES.VMW_SERVICE.SSD);

        if (backup === null) {
            //$log.warn('Backup value is not found');
            return 0;
        }

        //$log.debug('Backup value is ' + JSON.stringify(backup));
        //$log.debug('HDD value is '+ JSON.stringify(hdd));
        //$log.debug('SSD value is '+ JSON.stringify(ssd));

        // resolve multiplier
        var multiplier = helpers.arrays.find(argExpression, 'code', backup.value);

        if (multiplier === null) {
            //$log.warn('Multiplier value is not found');
            return 0;
        }

        //$log.debug('Multiplier value is ' + JSON.stringify(multiplier));

        var argumentPrice = helpers.numbers.safeMultiply(multiplier.ssd, ssd.value) + helpers.numbers.safeMultiply(multiplier.hdd, hdd.value);

        return argumentPrice;
    };

    this.getResourcePoolPrice = function (calculationScope) {
        var servicePrice = this.getServicePrice(calculationScope);
        servicePrice = servicePrice + this.getArgumentZPrice(calculationScope);
        if (servicePrice > 0) {
            return servicePrice;
        } else {
            return parseFloat(calculationScope.current_tariff);
        }
    };
}]);

},{}],166:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('ticketCreateHelper', ["modelize", "blockUIWrapper", "TicketsDetailResource", function ticketCreateHelper(modelize, blockUIWrapper, TicketsDetailResource) {

    this.createTicket = function (ticket) {
        return blockUIWrapper.wrap(TicketsDetailResource.$new(ticket).save());
    };

    this.createTicketMessage = function (ticket, ticketMessage) {
        return blockUIWrapper.wrap(ticket.messages.create(ticketMessage));
    };
}]);

angular.module('selfcare').service('ticketOperationHelper', ["$modal", "namedRouteService", function ticketOperationHelper($modal, namedRouteService) {

    this.openDescription = function (_ticket, closeCallback, dismissCallback) {
        var modalInstance = $modal.open({
            animation: true,
            backdrop: 'static',
            templateUrl: 'selfcare/routes/tickets/ticket-description-modal.html',
            controller: 'TicketDescriptionCtrl',
            controllerAs: 'tdCtrl',
            resolve: {
                ticket: function ticket() {
                    return _ticket;
                }
            }
        });
        //close actions
        modalInstance.result.then(function () {
            if (closeCallback) {
                closeCallback();
            }
        }, function () {
            if (dismissCallback) {
                dismissCallback();
            }
        });
    };

    this.openAdd = function () {
        namedRouteService.open('ticket-add');
    };

    this.openDetail = function (ticket) {
        namedRouteService.open('ticket-detail', ticket.id);
    };

    this.backToTickes = function () {
        namedRouteService.open('tickets');
    };
}]);

},{}],167:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('wizardHandlerHelper', ["WizardHandler", "$q", "$timeout", function wizardHandlerHelper(WizardHandler, $q, $timeout) {

    function WizardHandlerHelper(id) {
        var self = this;

        var state = {
            wizardHandlerName: id,
            wizardHandler: null
        };

        this.getWizardHandler = function () {
            if (state.wizardHandler === null) {
                state.wizardHandler = WizardHandler.wizard(state.wizardHandlerName);
            }
            return state.wizardHandler;
        };

        this.moveNext = function () {
            var d = $q.defer();
            $timeout(function () {
                self.getWizardHandler().next();
                return d.resolve(true);
            }, 250);
            return d.promise;
        };

        this.moveTo = function (step) {
            var d = $q.defer();
            $timeout(function () {
                self.getWizardHandler().goTo(step);
                return d.resolve(true);
            }, 250);
            return d.promise;
        };

        this.finish = function () {
            var d = $q.defer();
            $timeout(function () {
                self.getWizardHandler().finish();
                return d.resolve(true);
            }, 250);
            return d.promise;
        };

        this.done = function () {
            return this.moveNext(this.finish);
        };
    }

    function getWizardHandler(id) {
        if (!isNaN(id)) {
            throw new Error('Handler name cannot be a number');
        }
        return new WizardHandlerHelper(id);
    }

    return {
        create: function create(wizardName) {
            return getWizardHandler(wizardName);
        }
    };
}]);

},{}],168:[function(require,module,exports){
'use strict';

require('./django');
require('./validation');
require('./helpers');
require('./authentication');
require('./commons');
require('./pagination');
require('./search');

},{"./authentication":134,"./commons":140,"./django":149,"./helpers":153,"./pagination":169,"./search":172,"./validation":178}],169:[function(require,module,exports){
'use strict';

require('./ngtable-instance');

},{"./ngtable-instance":170}],170:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('ngTableCreator', ["ngTableParams", "helpers", "$location", "PAGINATION_COUNTERS", function ngTableCreator(ngTableParams, helpers, $location, PAGINATION_COUNTERS) {
    return {
        create: function create(_getData, sorting) {

            var tableSorting = {};
            if (helpers.objects.isNotEmpty(sorting)) {
                tableSorting = {
                    sorting: sorting
                };
            }

            var tableParameters = angular.extend({}, tableSorting, PAGINATION_COUNTERS, $location.search());

            return new ngTableParams(tableParameters, {
                total: 0,
                getData: function getData($defer, params) {
                    $location.search(params.url());
                    return _getData($defer, params);
                }
            });
        },
        createNotPaged: function createNotPaged(_getData2) {
            // count >> -1 means that we we have infinity pages
            // counts >> [] means that we hide page size controls
            return new ngTableParams({
                count: -1
            }, {
                counts: [],
                total: 0,
                getData: function getData($defer, params) {
                    return _getData2($defer, params);
                }
            });
        }
    };
}]);

},{}],171:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('contractSearch', ["ContractsResource", "blockUIWrapper", "flash", "gettextCatalog", function contractSearch(ContractsResource, blockUIWrapper, flash, gettextCatalog) {

    var emptyHolder = null;

    this.executeContractSearch = function ($defer, params) {
        var contractsParams = params.url();

        var contractsPromise = blockUIWrapper.wrap(ContractsResource.queryWithPages(contractsParams));
        contractsPromise.then(function (data) {
            if (data) {
                emptyHolder = data.total === 0;
                params.total(data.total);
                $defer.resolve(data);
            }
        }, function (data) {
            emptyHolder = true;
            $defer.reject('empty');
            flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
        });
    };

    this.isSearchEmpty = function () {
        return emptyHolder;
    };
}]);

},{}],172:[function(require,module,exports){
'use strict';

require('./invoice-search');
require('./contract-search');
require('./service-search');
require('./ticket-search');
require('./voip-report-search');

},{"./contract-search":171,"./invoice-search":173,"./service-search":174,"./ticket-search":175,"./voip-report-search":176}],173:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('invoiceSearch', ["InvoicesResource", "blockUIWrapper", "flash", "gettextCatalog", function invoiceSearch(InvoicesResource, blockUIWrapper, flash, gettextCatalog) {

    var emptyHolder = null;

    this.executeInvoiceSearch = function ($defer, params) {
        var invoicesParams = params.url();

        var invoicesPromise = blockUIWrapper.wrap(InvoicesResource.queryWithPages(invoicesParams));
        invoicesPromise.then(function (data) {
            if (data) {
                emptyHolder = data.total === 0;
                params.total(data.total);
                $defer.resolve(data);
            }
        }, function (data) {
            emptyHolder = true;
            $defer.reject('empty');
            flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
        });
    };

    this.isSearchEmpty = function () {
        return emptyHolder;
    };
}]);

},{}],174:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('serviceSearch', ["ServicesResource", "blockUIWrapper", "flash", "parameterHelper", "gettextCatalog", function serviceSearch(ServicesResource, blockUIWrapper, flash, parameterHelper, gettextCatalog) {

    var emptyHolder = null;

    this.executeServiceSearch = function (category, $defer, params) {
        var servicesParams = {};
        if (category === 'all') {
            servicesParams = params.url();
        } else {
            servicesParams = angular.extend(params.url(), { category: parameterHelper.slugParam(category) });
        }
        var servicesPromise = blockUIWrapper.wrap(ServicesResource.queryWithPages(servicesParams));
        servicesPromise.then(function (data) {
            if (data) {
                emptyHolder = data.total === 0;
                params.total(data.total);
                $defer.resolve(data);
            }
        }, function (data) {
            emptyHolder = true;
            $defer.reject('empty');
            flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
        });
    };

    this.isSearchEmpty = function () {
        return emptyHolder;
    };
}]);

},{}],175:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('ticketSearch', ["TicketsResource", "blockUIWrapper", "helpers", "flash", "gettextCatalog", function ticketSearch(TicketsResource, blockUIWrapper, helpers, flash, gettextCatalog) {

    var emptyHolder = null;

    this.executeTicketSearch = function (filter, $defer, params) {
        //add data fitlrer params
        var ticketsParams = this.resolveParameters(filter, params.url());

        var ticketsPromise = blockUIWrapper.wrap(TicketsResource.queryWithPages(ticketsParams));
        ticketsPromise.then(function (data) {
            if (data) {
                emptyHolder = data.total === 0;
                params.total(data.total);
                $defer.resolve(data);
            }
        }, function (data) {
            emptyHolder = true;
            $defer.reject('empty');
            flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
        });
    };

    this.formatParams = function (filter) {
        var filterParams = {};
        //-- date range
        if (helpers.objects.isNotEmpty(filter.dateRange)) {
            filterParams.date_to = helpers.dates.simpleFormat(filter.dateRange.endDate);
            filterParams.date_from = helpers.dates.simpleFormat(filter.dateRange.startDate);
        }
        //-- state
        if (helpers.objects.isNotEmpty(filter.state)) {
            filterParams.state = filter.state;
        }
        //-- categories
        if (helpers.arrays.isNotEmpty(filter.categories)) {
            filterParams.category = filter.categories.join('-');
        }
        return filterParams;
    };

    this.resolveParameters = function (filter, urlParam) {
        var resolvedParams = this.formatParams(filter),
            urlParameters = angular.extend({}, urlParam);
        if (helpers.objects.isEmpty(resolvedParams.state)) {
            delete urlParameters.state;
        } else {
            urlParameters.state = resolvedParams.state;
        }
        if (helpers.objects.isEmpty(resolvedParams.category)) {
            delete urlParameters.category;
        } else {
            urlParameters.category = resolvedParams.category;
        }
        if (helpers.objects.isEmpty(resolvedParams.date_from)) {
            delete urlParameters.date_from;
        } else {
            urlParameters.date_from = resolvedParams.date_from;
        }
        if (helpers.objects.isEmpty(resolvedParams.date_to)) {
            delete urlParameters.date_to;
        } else {
            urlParameters.date_to = resolvedParams.date_to;
        }
        return urlParameters;
    };

    this.isSearchEmpty = function () {
        return emptyHolder;
    };
}]);

},{}],176:[function(require,module,exports){
'use strict';

angular.module('selfcare').service('voipReportSearch', ["VoipReportResource", "blockUIWrapper", "helpers", "flash", "gettextCatalog", function voipReportSearch(VoipReportResource, blockUIWrapper, helpers, flash, gettextCatalog) {

    var emptyHolder = null;

    this.executeReportSearch = function ($defer, params) {
        var reportsPromise = blockUIWrapper.wrap(VoipReportResource.queryWithPages(params.url()));
        reportsPromise.then(function (data) {
            if (data) {
                emptyHolder = data.total === 0;
                params.total(data.total);
                $defer.resolve(data);
            }
        }, function (data) {
            emptyHolder = true;
            $defer.reject('empty');
            flash.error(gettextCatalog.getString('Įvyko klaida! Prašome susisiekti su sistemos administratoriumi.'));
        });
    };

    this.isSearchEmpty = function () {
        return emptyHolder;
    };
}]);

},{}],177:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('formHostnameValidator', ["VALIDATION_PATTERNS", function formHostnameValidator(VALIDATION_PATTERNS) {
    var regexp = new RegExp(VALIDATION_PATTERNS.HOST_NAME);
    return {
        test: function test(value) {
            if (value === null || value === undefined || value === '') {
                return true;
            }
            return regexp.test(value);
        }
    };
}]);

},{}],178:[function(require,module,exports){
'use strict';

require('./validate');
require('./form-validators');

},{"./form-validators":177,"./validate":179}],179:[function(require,module,exports){
'use strict';

angular.module('selfcare').factory('validate', ["gettextCatalog", function validate(gettextCatalog) {

    function ValidationMessageStore() {

        this.message = {
            'minlength': gettextCatalog.getString('Nurodyta reikšmė yra per trumpa.'),
            'maxlength': gettextCatalog.getString('Nurodyta reikšmė yra per ilga'),
            'email': gettextCatalog.getString('Neteisingai nurodytas pašto adresas.'),
            'required': gettextCatalog.getString('Šis laukas yra privalomas.')
        };

        this.moreMessages = {
            'demo': {
                'required': gettextCatalog.getString('Kiti validavimo pranešimai.')
            }
        };
    }

    return {

        messageStore: new ValidationMessageStore(),

        checkMoreMessages: function checkMoreMessages(name, error) {
            return (this.messageStore.moreMessages[name] || [])[error] || null;
        },

        validationMessages: function validationMessages(field, form, error_bin) {
            var messages = [];
            for (var e in form[field].$error) {
                if (form[field].$error[e]) {
                    var special_message = this.checkMoreMessages(field, e);
                    if (special_message) {
                        messages.push(special_message);
                    } else if (this.messageStore.message[e]) {
                        messages.push(this.messageStore.message[e]);
                    } else {
                        messages.push("Error: " + e);
                    }
                }
            }
            var deduped_messages = [];
            angular.forEach(messages, function (el, i) {
                if (deduped_messages.indexOf(el) === -1) {
                    deduped_messages.push(el);
                }
            });
            if (error_bin) {
                error_bin[field] = deduped_messages;
            }
        },

        formValidation: function formValidation(form, error_bin) {
            for (var field in form) {
                if (field.substr(0, 1) !== "$") {
                    this.validationMessages(field, form, error_bin);
                }
            }
        },

        refresh: function refresh() {
            this.messageStore = new ValidationMessageStore();
        }

    };
}]);

},{}]},{},[2]);


